(function () {
  'use strict';

  angular
    .module('cndFrontend',
      ['angular-loading-bar', 'ngAnimate', 'ngCookies', 'ngSanitize', 'ngMessages',
        'ngAria', 'ngResource', 'ui.date', 'ui.router', 'ui.bootstrap', 'sp-input-components',
        'pascalprecht.translate', 'federicot.ng-message-center', 'toastr']);

})();

(function () {
  'use strict';

  angular
    .module('cndFrontend')
    .controller('MainController', ['RecService', 'SidService', '$log', '$filter', '$rootScope', '$scope', 'ngMessageCenter',
      '$state', '$stateParams', 'devedor', 'situacao', 'registro', '$window', '$document',
      function (RecService, SidService, $log, $filter, $rootScope, $scope, ngMessageCenter,
        $state, $stateParams, devedor, situacao, registro, $window) {
        /** @ngInject */
        var vm = this;
        vm.isCollapsed = false;

        vm.devedor = devedor;
        vm.certidaoPositiva = undefined;
        vm.certidaoPositivaNegativa = undefined;
        vm.certidaoNegativa = undefined;
        vm.certidaoName = undefined;

        if ($stateParams.nuRegistro === "") {
          vm.devedor.nuRegistro = !!registro ? registro.nuRegistro : 'Indisponível';
        } else {
          vm.devedor.nuRegistro = $stateParams.nuRegistro;
        }
        vm.devedor.nuDocumentoFmt = !!vm.devedor.dePlaca ? 'Indisponível' : formatDocumentoPessoa(vm.devedor.nuDocumento);
        vm.devedor.deNomeFmt = !!vm.devedor.dePlaca ? 'Indisponível' : devedor.deNome;

        formatEnderecoDevedor();
        exibirSituacaoDevedor();

        vm.backToPreviousPage = function () {
          $window.history.back();
        };

        vm.openExtatoPage = function () {
          angular.element('#visualize-positive-button').button('loading');
          angular.element('#visualize-positive-negative-button').button('loading');
          angular.element('#visualize-negative-button').button('loading');
          $state.go(RouterName.EXTRATO, {
            nuDocumento: !!vm.devedor.dePlaca ? undefined : vm.devedor.nuDocumento,
            dePlaca: vm.devedor.dePlaca,
            nuRegistro: vm.devedor.nuRegistro,
            devedor: vm.devedor
          });
        };

        vm.imprimirCertidao = function () {
          angular.element('#print-positive-certificate-button').button('loading');
          angular.element('#print-positive-negative-certificate-button').button('loading');
          angular.element('#print-negative-certificate-button').button('loading');
          var filter = buildFilterCertidao();
          vm.certidaoName = filter.fileName;
          RecService.printCertidao(filter)
            .then(function (response) {
              var file = new Blob([response.data], {
                type: 'application/pdf'
              });
              if (vm.situacao.negativo) {
                vm.certidaoNegativa = file;
              }
              if (vm.situacao.positivo) {
                vm.certidaoPositiva = file;
              }
              if (vm.situacao.positivoNegativo) {
                vm.certidaoPositivaNegativa = file;
              }
            }).catch(function (fallback) {
              ngMessageCenter.error({
                timeout: 12000,
                title: 'ERRO!',
                text: __montaMensagemDeErro($filter, fallback),
                name: 'mainMessages'
              });
            }).finally(function () {
              angular.element('#print-positive-certificate-button').button('reset');
              angular.element('#print-positive-negative-certificate-button').button('reset');
              angular.element('#print-negative-certificate-button').button('reset');
            });
        };

        function formatEnderecoDevedor() {
          if (TipoPessoa.FISICA === vm.devedor.tpPessoa) {
            vm.devedor.deEndereco = null;
            vm.exibeLabelEndereco = false;
          } else {
            vm.devedor.deEnderecoFmt = !!vm.devedor.dePlaca ? 'Indisponível' : vm.devedor.deEndereco;
            vm.exibeLabelEndereco = true;
          }
        }

        function exibirSituacaoDevedor() {
          if (situacao != null) {
            vm.situacao = {};
            vm.devedor.situacao = situacao.situacao;
            vm.situacao.negativo = situacao.situacao.toLowerCase() == Situacao.NEGATIVO;
            vm.situacao.positivo = situacao.situacao.toLowerCase() == Situacao.POSITIVO;
            vm.situacao.positivoNegativo = situacao.situacao.toLowerCase() == Situacao.POSITIVO_NEGATIVO;
            vm.situacao.dataAtual = new Date();

            if (vm.situacao.positivoNegativo) {
              SidService.findEfeitoSuspensivoByNuDocumento(vm.devedor.nuDocumento)
                .then(function (data) {
                  vm.situacao.deObservacaoEfeitoSuspensivo = data.deObservacao;
                }).catch(function (fallback) {
                  ngMessageCenter.error({
                    timeout: 12000,
                    title: 'ERRO!',
                    text: __montaMensagemDeErro($filter, fallback),
                    name: 'mainMessages'
                  });
                });
            }
          }
        }

        function buildFilterCertidao() {
          var filter = {};
          if (vm.situacao.negativo) {
            filter.tpRelCertidao = Certidao.NEGATIVA;
            filter.fileName = $filter('translate')('title.certidao.negativa') + "-" + (!vm.devedor.dePlaca ? vm.devedor.nuDocumento : Date.now()) + ".pdf";
          }
          if (vm.situacao.positivo) {
            filter.tpRelCertidao = Certidao.POSITIVA;
            filter.fileName = $filter('translate')('title.certidao.positiva') + "-" + (!vm.devedor.dePlaca ? vm.devedor.nuDocumento : Date.now()) + ".pdf";
          }
          if (vm.situacao.positivoNegativo) {
            filter.tpRelCertidao = Certidao.POSITIVA_NEGATIVA;
            filter.fileName = $filter('translate')('title.certidao.negativa.negativa') + "-" + (!vm.devedor.dePlaca ? vm.devedor.nuDocumento : Date.now()) + ".pdf";
            filter.deObservacaoEfeitoSuspensivo = vm.situacao.deObservacaoEfeitoSuspensivo;
          }
          filter.nomeRazaoSocial = !!vm.devedor.dePlaca ? 'Indisponível' : vm.devedor.deNome;
          filter.nuRegistro = !!vm.devedor.dePlaca ? undefined : vm.devedor.nuRegistro;
          filter.deEndereco = !!vm.devedor.dePlaca ? 'Indisponível' : vm.devedor.deEndereco;
          filter.nuCPFCNPJ = !!vm.devedor.dePlaca ? 'Indisponível' : formatDocumentoPessoa(vm.devedor.nuDocumento);
          return filter;
        }
      }
    ]);
})();

(function () {
  'use strict';

  angular
    .module('cndFrontend').controller('SearchController',[
      '$filter', 
      '$state', 
      '$stateParams', 
      '$log', 
      '$document', 
      'RecService',
      'CdtService', 
      'CndService', 
      'ngMessageCenter', 
      '$q', 
      '$timeout',
      'RECAPTCHA_KEY_SITE', 
      function (
        $filter, 
        $state, $stateParams, 
        $log,
        $document, 
        RecService, 
        CdtService, 
        CndService, 
        ngMessageCenter, 
        $q, 
        $timeout,
        RECAPTCHA_KEY_SITE
      ) { /** @ngInject */

        var vm = this;
        vm.searchFilter = {};
        vm.searchForm = {};
        vm.searchFilter.type = FilterType.REGISTRO;
        vm.searchFilter.isREGISTRO = true;

        //-- mantis 122566 
        vm.valor_chave_captcha = RECAPTCHA_KEY_SITE; 

        //-- caso precise rodar com localhost, atribuir o valor da chave
       //vm.valor_chave_captcha = "6LdOZJwrAAAAACMHvqm_LUm0sHLPPzl26-yZVohU"; 

        //--  <div class="g-recaptcha" data-sitekey="6LdOZJwrAAAAACMHvqm_LUm0sHLPPzl26-yZVohU" 
        //--  <iframe src="https://www.google.com/recaptcha/api/fallback?k=6LdOZJwrAAAAACMHvqm_LUm0sHLPPzl26-yZVohU"
 

        vm.changeFieldOption = function () {
          vm.searchFilter.nuDocumento = "";
          vm.searchFilter.nuRegistro = "";
          vm.searchFilter.nuPlaca = "";
          vm.searchFilter.isCNPJ = FilterType.CNPJ === vm.searchFilter.type;
          vm.searchFilter.isCPF = FilterType.CPF === vm.searchFilter.type;
          vm.searchFilter.isREGISTRO = FilterType.REGISTRO === vm.searchFilter.type;
          vm.searchFilter.isPLACA = FilterType.PLACA === vm.searchFilter.type;

          //--- ocultar a div de mensagem do captcha
          if (document.getElementById("msgCaptcha")) {
            document.getElementById("msgCaptcha").style.display = 'none';

            var errorMsgs = document.getElementsByClassName("recaptcha-error-message");
            if (errorMsgs.length) {
              errorMsgs[0].remove(); // ou errorMsgs[0].parentNode.removeChild(errorMsgs[0]);
            }
          }
        };

        vm.openMainPage = function () {
          if (vm.searchFilter.nuRegistro !== "") {
            vm.searchFilter.nuRegistro = parseInt(vm.searchFilter.nuRegistro);
          }
          $state.go(RouterName.MAIN, {
            nuDocumento: vm.searchFilter.nuDocumento,
            nuRegistro: vm.searchFilter.nuRegistro,
            dePlaca: vm.searchFilter.nuPlaca
          });
        };

        vm.verificaInconsistencias = function () {

          var promises = [];

          promises.push(CndService.dividasExtintasComContaReceberExecutada(vm.searchFilter.nuDocumento, vm.searchFilter.nuPlaca));
          promises.push(CndService.dividasQuitadasSemRegistroDaExtincao(vm.searchFilter.nuDocumento, vm.searchFilter.nuPlaca));
          promises.push(CndService.contasReceberQuitadasSemExtincaoDaDivida(vm.searchFilter.nuDocumento, vm.searchFilter.nuPlaca));
          promises.push(CndService.contasReceberAtivasComDividaExtinta(vm.searchFilter.nuDocumento, vm.searchFilter.nuPlaca));
          promises.push(CndService.contasReceberParceladasComRecebimento(vm.searchFilter.nuDocumento, vm.searchFilter.nuPlaca));
          promises.push(CndService.contasReceberExecutadasComRecebimento(vm.searchFilter.nuDocumento, vm.searchFilter.nuPlaca));
          promises.push(CndService.contasReceberQuitadaSemRecebimento(vm.searchFilter.nuDocumento, vm.searchFilter.nuPlaca));
          promises.push(CndService.contasReceberAtivasComDividaExecutada(vm.searchFilter.nuDocumento, vm.searchFilter.nuPlaca));
          //verifica se tem divida e rec quitadas para a placa
          if(!!vm.searchFilter.nuPlaca) promises.push(CndService.contasReceberQuitadaComDividaQuitada(vm.searchFilter.nuDocumento, vm.searchFilter.nuPlaca));

          $q.all(promises).then(function(response) {
            var consistenciaPagamento = null;
            if(!!vm.searchFilter.nuPlaca) {
              consistenciaPagamento = response[8];
              response = response.splice(0,7);
            }

            vm.deInconsistencias = [];
            var consistente = true;

            angular.forEach(response, function(value) {
              if (value.inconsistencias.length > 0) {
                consistente = false;
                vm.deInconsistencias.push(value.deInconsistencia);
              }
            });

            // é consistente e possui rec/divida quitada
            if(consistente && consistenciaPagamento && consistenciaPagamento.inconsistencias.length == 0) {
              vm.searchFilter = {};
              vm.searchForm = {};
              vm.searchFilter.type = FilterType.REGISTRO;
              vm.searchFilter.isREGISTRO = true;
              ngMessageCenter.success({
                    timeout: 12000,
                    text: 'Não foram localizadas débitos para a placa em questão.',
                    name: 'searchMessages'
                });
                angular.element('#search-button').button('reset');
                $state.go(RouterName.HOME);
                return;
            };

            if (consistente) {
              vm.openMainPage();
            } else {
              angular.element('#modalConsolidacao').modal('show');
              angular.element('#search-button').button('reset');
            }

          }).catch(function (fallback) {
            if(fallback.status <= 0 || fallback.status == HttpCode.SERVICE_UNAVAILABLE || fallback.status == HttpCode.NOT_FOUND) {
              vm.openMainPage();
            }else{
              ngMessageCenter.error({
                timeout: 12000,
                title: 'ERRO!',
                text: __montaMensagemDeErro(fallback),
                name: 'mainMessages'
              });
            }
          });
        };

        vm.confirmarNotificacao = function () {
          CndService.notificacaoDeInconsistencia(vm.devedor, vm.notificacaoForm.deEmail, vm.deInconsistencias)
            .then(function (data) {
              angular.element('#modalConsolidacao').modal('hide');
            }).catch(function (fallback) {
            ngMessageCenter.error({
              timeout: 12000,
              title: 'ERRO!',
              text: __montaMensagemDeErro(fallback),
              name: 'mainMessages'
            });
          });
        };

        vm.consultaDevedor = function (form) {
          angular.element('#search-button').button('loading');
          if(form.$invalid){
            angular.element('#search-button').button('reset');
            form.$setPristine();
            return;
          }
          if (FilterType.REGISTRO === vm.searchFilter.type) {
            var registroFilter = {numeroRegistro: vm.searchFilter.nuRegistro};
              RecService.findDadosEmpresa(registroFilter)
              .then(function (data) {
                vm.searchFilter.nuDocumento = data.nuDocumento;
                if (vm.searchFilter.nuDocumento === null || vm.searchFilter.nuDocumento === undefined) {
                  angular.element('#search-button').button('reset');
                  ngMessageCenter.success({
                    timeout: 12000,
                    text: $filter('translate')('messages.registro.nao.encontrado'),
                    name: 'searchMessages'
                  });
                } else {
                  consultaDocumentoDevedor(vm.searchFilter.nuDocumento);
                }
              }).catch(function (fallback) {
              angular.element('#search-button').button('reset');
              ngMessageCenter.error({
                timeout: 12000,
                title: 'ERRO!',
                text: __montaMensagemDeErro(fallback),
                name: 'searchMessages'
              });
            });
          }
          if (FilterType.CPF === vm.searchFilter.type || FilterType.CNPJ === vm.searchFilter.type) {
            consultaDocumentoDevedor(vm.searchFilter.nuDocumento);
          }

          if (FilterType.PLACA === vm.searchFilter.type || FilterType.PLACA === vm.searchFilter.type) {
            vm.verificaInconsistencias();
            //RecService.findDados
          }
        };

        function consultaDocumentoDevedor(searchFilter) {
          CdtService.findPessoaByNuDocumento(searchFilter)
            .then(function (data) {
              if (data.status == HttpCode.OK && angular.isDefined(data.data) && data.data.length > 0) {
                vm.devedor = data.data[0];
                vm.verificaInconsistencias();
              } else {
                angular.element('#search-button').button('reset');
                ngMessageCenter.success({
                  timeout: 12000,
                  text: $filter('translate')('messages.registro.nao.encontrado'),
                  name: 'searchMessages'
                });
              }
            }).catch(function (fallback) {
            angular.element('#search-button').button('reset');
            ngMessageCenter.error({
              timeout: 12000,
              title: 'ERRO!',
              text: __montaMensagemDeErro(fallback),
              name: 'searchMessages'
            });
          });
        }

        function __montaMensagemDeErro(fallback) {
          $log.info("Erro status code: " + fallback.status + ", conteudo do response: " + fallback);
          if (HttpCode.NOT_FOUND === fallback.status) {
            return $filter('translate')('messages.service.notfound');
          }
          if (HttpCode.SERVICE_UNAVAILABLE === fallback.status) {
            return $filter('translate')('messages.service.unavailable');
          }
          if (HttpCode.SERVER_ERROR === fallback.status) {
            return fallback.text;
          }
          if (HttpCode.BAD_REQUEST === fallback.status) {
            return $filter('translate')('messages.service.badrequest') + fallback.data.message;
          } else {
            return $filter('translate')('messages.service.error.unexpected');
          }
        }
        //-------------------------------------------
        //-- mantis 122566 
        vm.validateCaptchaAndSubmit = function (form) {
          //var response = grecaptcha.getResponse();

          var response = grecaptcha.enterprise.getResponse();

          var teste = vm.valor_chave_captcha

       //  alert("valor: " + teste + "\n" + "response: " + response);
          if (response.length === 0) {
            // reCAPTCHA não resolvido
            if (!document.getElementsByClassName("recaptcha-error-message").length) {
              var errorMsg =  document.createElement("div"); //document.getElementById("divMsgCaptcha");
              errorMsg.className = "recaptcha-error-message";
              errorMsg.innerHTML = "<p id ='msgCaptcha' style='color: red; margin-top: 10px;'>Por favor, resolva o reCAPTCHA.</p>";
              document.querySelector(".g-recaptcha").appendChild(errorMsg);

            }
          } else {
            // reCAPTCHA resolvido, prossegue
            vm.consultaDevedor(form);
          }
        }
        //-------------------
      }


    ]);
})();

(function () {
  "use strict";

  angular.module("cndFrontend").controller("ExtratoController", [
    "$filter",
    "$rootScope",
    "$scope",
    "$location",
    "$state",
    "$log",
    "$sce",
    "CdtService",
    "CndService",
    "SidService",
    "GruService",
    "ProtestoService",
    "RecService",
    "$stateParams",
    "ngMessageCenter",
    "contas",
    "dividas",
    "dividasEmProtestoEProtestada",
    "dividasExecutadas",
    "acordosAdministrativos",
    "acordosJuridicos",
    "contasComEfeitoSuspensivo",
    "dividasComEfeitoSuspensivo",
    "contasAgImposicaoFinal",
    "$window",
    "BB_PAY_ENABLED",
    function (
      $filter,
      $rootScope,
      $scope,
      $location,
      $state,
      $log,
      $sce,
      CdtService,
      CndService,
      SidService,
      GruService,
      ProtestoService,
      RecService,
      $stateParams,
      ngMessageCenter,
      contas,
      dividas,
      dividasEmProtestoEProtestada,
      dividasExecutadas,
      acordosAdministrativos,
      acordosJuridicos,
      contasComEfeitoSuspensivo,
      dividasComEfeitoSuspensivo,
      contasAgImposicaoFinal,
      $window,
      BB_PAY_ENABLED
    ) {
      /** @ngInject */

      var vm = this;
      vm.enderecoForm = {};
      vm.gru = undefined;
      vm.gruName = undefined;
      vm.extratoDebitoReport = undefined;
      vm.unidadesFederais = UNIDADES_FEDERAIS;
      vm.tab = tabCode.TAB_EXTRATO;
      vm.itensSelecionados = [];
      vm.selectedAll = {};

      vm.isCollapsedHeader = false;
      vm.vlTotalExecutadoAtualizado = 0.0;
      vm.vlTotalAtualizado = 0.0;
      vm.vlTotalAtualizadoComJuros = 0.0;
      vm.vlTotalSelecionado = 0.0;
      vm.vlTotalSelecionadoProtestado = 0.0;
      vm.vlTotalEfeitoSuspensivo = 0.0;
      vm.vlTotalEfeitoSuspensivoComJuros = 0.0;

      vm.canGenerateBbPay = false;
      vm.isGeneratingBbPay = false;
      vm.bbPayModalUrl = null;
      vm.showBbPayButtons = BB_PAY_ENABLED;
      vm.bbPay = {
        codigoSolicitacao: null,
        dividasSelecionadas: [],
      };

      vm.contas = contas.contasReceber;
      vm.dividas = dividas.dividasAtivas;
      vm.dividasEmProtestoConsulta = dividasEmProtestoEProtestada.dividasAtivas;
      vm.dividasExecutadas = dividasExecutadas.dividasAtivas;
      vm.contasComEfeitoSuspensivo = contasComEfeitoSuspensivo.contasReceber;
      vm.dividasComEfeitoSuspensivo = dividasComEfeitoSuspensivo.dividasAtivas;
      vm.contasAgImposicaoFinal = contasAgImposicaoFinal.contasReceber;

      vm.dividasEmProtesto = [];
      vm.debitos = [];
      vm.debitosComEfeitoSuspensivo = [];

      var contaReceberFormatadas = formatContasReceber(vm.contas);
      vm.debitos = vm.debitos.concat(contaReceberFormatadas.debitos);
      vm.vlTotalAtualizado =
        vm.vlTotalAtualizado + contaReceberFormatadas.vlTotalAtualizado;
      vm.vlTotalAtualizadoComJuros =
        vm.vlTotalAtualizadoComJuros +
        contaReceberFormatadas.vlTotalAtualizadoComJuros;

      // vm.dividasEmProtesto = vm.dividasEmProtesto.concat(contaReceberFormatadas.debitos);
      var protestoFormatado = formatDividasAtivas(vm.dividasEmProtestoConsulta);
      vm.dividasEmProtesto = vm.dividasEmProtesto.concat(
        protestoFormatado.debitos
      );
      vm.vlTotalEmProtestoAtualizado = protestoFormatado.vlTotalAtualizado;
      vm.vlTotalEmProtestoAtualizadoComJuros =
        protestoFormatado.vlTotalAtualizadoComJuros;

      var dividasFormatadas = formatDividasAtivas(vm.dividas);
      vm.debitos = vm.debitos.concat(dividasFormatadas.debitos);
      vm.vlTotalAtualizado =
        vm.vlTotalAtualizado + dividasFormatadas.vlTotalAtualizado;
      vm.vlTotalAtualizadoComJuros =
        vm.vlTotalAtualizadoComJuros +
        dividasFormatadas.vlTotalAtualizadoComJuros;

      var dividasExecutadasFormatadas = formatDividasAtivasExecutadas(
        vm.dividasExecutadas
      );
      vm.debitosExecutados = dividasExecutadasFormatadas.debitos;
      vm.vlTotalExecutadoAtualizado =
        vm.vlTotalExecutadoAtualizado +
        dividasExecutadasFormatadas.vlTotalExecutadoAtualizado;

      var contaReceberComEfeitoSuspensivoFormatadas = formatContasReceber(
        vm.contasComEfeitoSuspensivo
      );
      vm.debitosComEfeitoSuspensivo = vm.debitosComEfeitoSuspensivo.concat(
        contaReceberComEfeitoSuspensivoFormatadas.debitos
      );
      vm.vlTotalEfeitoSuspensivo =
        vm.vlTotalEfeitoSuspensivo +
        contaReceberComEfeitoSuspensivoFormatadas.vlTotalAtualizado;
      vm.vlTotalEfeitoSuspensivoComJuros =
        vm.vlTotalEfeitoSuspensivoComJuros +
        contaReceberComEfeitoSuspensivoFormatadas.vlTotalAtualizadoComJuros;

      var dividasComEfeitoSuspensivoFormatadas = formatDividasAtivas(
        vm.dividasComEfeitoSuspensivo
      );
      vm.debitosComEfeitoSuspensivo = vm.debitosComEfeitoSuspensivo.concat(
        dividasComEfeitoSuspensivoFormatadas.debitos
      );
      vm.vlTotalEfeitoSuspensivo =
        vm.vlTotalEfeitoSuspensivo +
        dividasComEfeitoSuspensivoFormatadas.vlTotalAtualizado;
      vm.vlTotalEfeitoSuspensivoComJuros =
        vm.vlTotalEfeitoSuspensivoComJuros +
        dividasComEfeitoSuspensivoFormatadas.vlTotalAtualizadoComJuros;

      vm.acordosJuridicos = formatAcordosJuridicos(
        acordosJuridicos.acordoJuridicos
      );

      vm.acordosAdministrativos = formatAcordosAdministrativos(
        acordosAdministrativos.acordos
      );

      vm.isDebitoFromMulta = checkIfIsDebitoFromMulta;

      vm.showPrintButton =
        vm.debitos.length > 0 ||
        vm.debitosExecutados.length > 0 ||
        vm.debitosComEfeitoSuspensivo.length > 0;
      if (
        !!!$stateParams.devedor &&
        vm.debitos.length == 0 &&
        vm.debitosComEfeitoSuspensivo.length == 0 &&
        vm.acordosJuridicos.length == 0 &&
        vm.acordosAdministrativos.length == 0
      ) {
        ngMessageCenter.success({
          timeout: 12000,
          text: "Não foram localizadas débitos para a placa em questão.",
          name: "searchMessages",
        });
        $state.go(RouterName.HOME);
      }
      vm.rootScopeOn = $rootScope.$on("$locationChangeSuccess", function () {
        $rootScope.actualLocation = $location.path();
      });

      if ($stateParams.devedor === null) {
        consultaPessoa($stateParams.nuDocumento, $stateParams.dePlaca);
      } else {
        vm.devedor = $stateParams.devedor;
        vm.devedor.nuRegistro = !!vm.devedor.dePlaca
          ? "Indisponível"
          : $stateParams.nuRegistro;
        vm.devedor.nuDocumentoFmt = !!vm.devedor.dePlaca
          ? "Indisponível"
          : formatDocumentoPessoa(vm.devedor.nuDocumento);
        vm.devedor.deNomeFmt = !!vm.devedor.dePlaca
          ? "Indisponível"
          : $stateParams.devedor.deNome;
        formatEnderecoDevedor();
      }

      function isLocationAtThisRoute(location, route) {
        if (angular.isUndefined(location) || angular.isUndefined(route)) {
          return false;
        }
        return (
          location.indexOf(
            route.substr(RouterName.EXTRATO.toString().length + 1)
          ) !== -1
        );
      }

      vm.rootScopeWatch = $rootScope.$watch(
        function () {
          return $location.path();
        },
        function (newLocation, oldLocation) {
          if ($rootScope.actualLocation === newLocation) {
            if (
              isLocationAtThisRoute(
                oldLocation,
                RouterName.ACORDOADMINISTRATIVO
              )
            ) {
              vm.tab = tabCode.TAB_ACORDO_ADMINISTRATIVO;
            }
            if (isLocationAtThisRoute(oldLocation, RouterName.ACORDOJURIDICO)) {
              vm.tab = tabCode.TAB_ACORDO_JURIDICO;
            }
            if (
              isLocationAtThisRoute(oldLocation, RouterName.EFEITOSUSPENSIVO)
            ) {
              vm.tab = tabCode.TAB_EFEITO_SUSPENSIVO;
            }
            if (
              isLocationAtThisRoute(oldLocation, RouterName.AGIMPOSICAOFINAL)
            ) {
              vm.tab = tabCode.TAB_AG_IMPOSICAO_FINAL;
            }
          }
        }
      );

      if (angular.isDefined($stateParams.tabSelected)) {
        vm.tab = $stateParams.tabSelected;
      }

      var ViewDebitoDetailDialogModel = function () {
        this.visible = false;
      };
      var ViewProtestoDetailDialogModel = function () {
        this.visible = false;
      };
      ViewDebitoDetailDialogModel.prototype.open = function (debito) {
        var debitoDetail = {};
        debitoDetail = debito;

        if (
          CodigoTipoDivida.STC === debitoDetail.cdTipoDivida ||
          CodigoTipoReceita.STC === debitoDetail.nuTipoReceita
        ) {
          debitoDetail.autoInfracao = debitoDetail.nuAuto;
          debitoDetail.deLocalInfracao = debitoDetail.deLocalPenalidade;
        }
        if (
          CodigoTipoDivida.MTM === debitoDetail.cdTipoDivida ||
          CodigoTipoReceita.MTM === debitoDetail.nuTipoReceita
        ) {
          debitoDetail.autoInfracao = debitoDetail.nuMulta;
          debitoDetail.dtVencto = debitoDetail.dtVenctoMultaMtm;
        }
        this.debito = debitoDetail;
        this.visible = true;
      };

      ViewProtestoDetailDialogModel.prototype.open = function (debito) {
        var debitoDetail = {};
        debitoDetail = debito;

        ProtestoService.findCartorioByDividaAtiva(debito.nuDividaAtiva)
          .then(function (data) {
            debitoDetail.cartorioNome = data.nomeCartorio;

            //endereço completo
            var endereco = data.endereco || ""; // Se 'data.endereco' for null ou undefined, será substituído por uma string vazia
            var bairro = data.bairro || "";
            var municipio = data.municipio || "";
            var uf = data.uf || "";
            var cep = data.cep || "";

            // Concatenando o endereço completo, com um espaço entre os componentes
            var enderecoCompleto =
              endereco +
              (endereco && bairro ? " - " : "") +
              bairro +
              (bairro && uf ? " - " : "") +
              municipio +
              "/" +
              uf +
              (uf && cep ? " - CEP: " : "") +
              cep;

            debitoDetail.cartorioEndereco = enderecoCompleto;
            debitoDetail.cartorioTelefone = data.telefones;
            debitoDetail.cartorioEmail = data.emails;
          })
          .catch(function (fallback) {
            ngMessageCenter.error({
              timeout: 12000,
              title: "ERRO!",
              text: __montaMensagemDeErro($filter, fallback),
              name: "extratoMessages",
            });
          });

        this.debito = debitoDetail;

        //efetuar a consulta no cartorio para identificar os dados da dívida

        this.visible = true;
      };

      ViewDebitoDetailDialogModel.prototype.close = function () {
        this.visible = false;
      };

      ViewProtestoDetailDialogModel.prototype.close = function () {
        this.visible = false;
      };
      $scope.viewDebitoDetailDialog = new ViewDebitoDetailDialogModel();

      $scope.viewProtestoDetailDialog = new ViewProtestoDetailDialogModel();

      vm.changeTab = function (tabNumber) {
        vm.showPrintButton =
          (tabCode.TAB_EFEITO_SUSPENSIVO === tabNumber ||
            tabCode.TAB_EXTRATO === tabNumber) &&
          (vm.debitos.length > 0 ||
            vm.debitosExecutados.length > 0 ||
            vm.debitosComEfeitoSuspensivo.length > 0);
        cleanLocalReferenceFiles();
        vm.tab = tabNumber;
        if (
          isLocationAtThisRoute(
            $location.path(),
            RouterName.ACORDOADMINISTRATIVO
          ) ||
          isLocationAtThisRoute($location.path(), RouterName.ACORDOJURIDICO) ||
          isLocationAtThisRoute(
            $location.path(),
            RouterName.EFEITOSUSPENSIVO
          ) ||
          isLocationAtThisRoute($location.path(), RouterName.AGIMPOSICAOFINAL)
        ) {
          $state.go(RouterName.EXTRATO);
        }
        if (tabCode.TAB_EFEITO_SUSPENSIVO === tabNumber) {
          vm.openTabEfeitoSuspensivo();
        }
        if (tabCode.TAB_AG_IMPOSICAO_FINAL === tabNumber) {
          vm.openTabAgImposicaoFinal();
        }
        vm.updateCanGenerateBbPay();
      };

      vm.openModal = function (debitos) {
        cleanLocalReferenceFiles();
        var notSelected = true;
        vm.itensSelecionados = [];
        angular.forEach(debitos, function (item) {
          if (item.selected) {
            notSelected = false;
            vm.itensSelecionados.push(item);
          }
        });

        if (!notSelected) {
          angular.element("#modalEndereco").modal("show");
          return;
        }

        if (notSelected) {
          ngMessageCenter.warning({
            timeout: 12000,
            title: $filter("translate")("messages.warning.attention"),
            text: $filter("translate")(
              "messages.validation.selecione.um.registro.para.gerar.guia"
            ),
            name: "extratoMessages",
          });
        }
      };

      vm.openDetalheAcordoJuridico = function (index) {
        var acordoJuridicoSelecionado = vm.acordosJuridicos[index];
        $state.go(RouterName.ACORDOJURIDICO, {
          nuAnoContaReceber: acordoJuridicoSelecionado.nuAnoContaReceber,
          nuContaReceber: acordoJuridicoSelecionado.nuContaReceber,
          nuDocumento: vm.devedor.nuDocumento,
          nuRegistro: vm.devedor.nuRegistro,
          devedor: vm.devedor,
        });
      };

      vm.openDetalheAcordoAdministrativo = function (index) {
        var acordoAdministrativoSelecionado = vm.acordosAdministrativos[index];
        $state.go(RouterName.ACORDOADMINISTRATIVO, {
          nuAnoContaReceber: acordoAdministrativoSelecionado.nuAnoContaReceber,
          nuContaReceber: acordoAdministrativoSelecionado.nuContaReceber,
          nuDocumento: vm.devedor.nuDocumento,
          nuRegistro: vm.devedor.nuRegistro,
          devedor: vm.devedor,
        });
      };

      vm.openTabEfeitoSuspensivo = function () {
        $state.go(RouterName.EFEITOSUSPENSIVO, {
          nuDocumento: !!vm.devedor.dePlaca
            ? undefined
            : vm.devedor.nuDocumento,
          nuRegistro: !!vm.devedor.dePlaca ? undefined : vm.devedor.nuRegistro,
          devedor: vm.devedor,
          contasComEfeitoSuspensivo: vm.contasComEfeitoSuspensivo,
          dividasComEfeitoSuspensivo: vm.dividasComEfeitoSuspensivo,
        });
      };

      vm.openTabAgImposicaoFinal = function () {
        $state.go(RouterName.AGIMPOSICAOFINAL, {
          nuDocumento: !!vm.devedor.dePlaca
            ? undefined
            : vm.devedor.nuDocumento,
          nuRegistro: !!vm.devedor.dePlaca ? undefined : vm.devedor.nuRegistro,
          devedor: vm.devedor,
          contasAgImposicaoFinal: vm.contasAgImposicaoFinal,
        });
      };

      vm.checkAll = function () {
        var vlTotalItems = 0.0;
        angular.forEach(vm.debitos, function (item) {
          item.selected = vm.selectedAll;
          vlTotalItems = vlTotalItems + item.vlAtualizado;
          verificaSeDividaPossuiGrupoServico(item);
        });
        if (vm.selectedAll) {
          vm.vlTotalSelecionado = vlTotalItems;
        } else {
          vm.vlTotalSelecionado = 0.0;
        }
        vm.updateCanGenerateBbPay();
      };

      vm.atualizaValorSelecionado = function (debito) {
        atualizaDadosDebitoSelecionado(debito);
        vm.updateCanGenerateBbPay();
      };

      // Função para atualizar o estado do botão BB Pay com base na seleção e aba ativa
      vm.updateCanGenerateBbPay = function () {
        // Essas são as abas onde o botão BB Pay está presente.
        if (vm.tab === 1) {
          // Aba do Extrato
          vm.canGenerateBbPay = vm.vlTotalSelecionado > 0;
        } else if (vm.tab === 6) {
          // Aba do Protesto
          vm.canGenerateBbPay = vm.vlTotalSelecionadoProtestado > 0;
        } else {
          vm.canGenerateBbPay = false;
        }
      };

      vm.atualizaValorSelecionadoProtestado = function (debito) {
        atualizaDadosDebitoSelecionadoProtestado(debito);
      };

      vm.backToPreviousPage = function () {
        $window.history.back();
      };

      vm.imprimirExtratoDebito = function () {
        vm.extratoDebitoReportName =
          $filter("translate")("title.extrato.debitos") +
          "-" +
          (!vm.devedor.dePlaca ? vm.devedor.nuDocumento : Date.now()) +
          ".pdf";
        var extratoDebito = {
          deNome: !!vm.devedor.dePlaca ? "Indisponível" : vm.devedor.deNome,
          nuDocumentoFmt: !!vm.devedor.dePlaca
            ? "Indisponível"
            : vm.devedor.nuDocumentoFmt,
          nuRegistro: !!vm.devedor.dePlaca ? undefined : vm.devedor.nuRegistro,
          deEndereco: !!vm.devedor.dePlaca
            ? "Indisponível"
            : vm.devedor.deEndereco,
          debitos: vm.debitos,
          vlTotalAtualizado: vm.vlTotalAtualizado,
          debitosExecutados: vm.debitosExecutados,
          vlTotalExecutadoAtualizado: vm.vlTotalExecutadoAtualizado,
          debitosSuspensos: vm.debitosComEfeitoSuspensivo,
          vlTotalSuspenso: vm.vlTotalEfeitoSuspensivoComJuros,
          vlTotalGeral:
            vm.vlTotalAtualizado +
            vm.vlTotalExecutadoAtualizado +
            vm.vlTotalEfeitoSuspensivoComJuros,
        };
        angular.element("#print-debits-report-button").button("loading");
        RecService.printExtratoDebito(JSON.stringify(extratoDebito))
          .then(function (response) {
            vm.extratoDebitoReport = new Blob([response.data], {
              type: "application/pdf",
            });
          })
          .catch(function (fallback) {
            ngMessageCenter.error({
              timeout: 12000,
              title: "ERRO!",
              text: __montaMensagemDeErro($filter, fallback),
              name: "extratoMessages",
            });
          })
          .finally(function () {
            angular.element("#print-debits-report-button").button("reset");
          });
      };

      vm.geraGru = function () {
        salvarEImprimirGRU(
          preencheDadosGru(vm.itensSelecionados, "/gru/salvarGru")
        );
      };

      /**
       * Gera o link de pagamento BB Pay para os débitos selecionados.
       */
      vm.generateBbPayLink = function (debitos, event) {
        if (!vm.canGenerateBbPay || vm.isGeneratingBbPay) {
          return;
        }

        cleanLocalReferenceFiles();
        var notSelected = true;
        vm.itensSelecionados = [];
        angular.forEach(debitos, function (item) {
          if (item.selected) {
            notSelected = false;
            vm.itensSelecionados.push(item);
          }
        });

        if (notSelected) {
          // Fecha a modal se nada foi selecionado
          angular.element("#bbPayPaymentModal").modal("hide");
          ngMessageCenter.warning({
            timeout: 12000,
            title: $filter("translate")("messages.warning.attention"),
            text: $filter("translate")(
              "messages.validation.selecione.um.registro.para.gerar.guia"
            ),
            name: "extratoMessages",
          });
          return;
        }

        var buttonElement;
        if (event && event.currentTarget) {
          buttonElement = angular.element(event.currentTarget);
        } else {
          // Fallback para IDs baseado na aba ativa
          if (vm.tab === 1) {
            // Aba do Extrato
            buttonElement = angular.element("#btn-modal-gerar-guia-bb-pay");
          } else if (vm.tab === 6) {
            // Aba do Protesto
            buttonElement = angular.element(
              "#btn-modal-gerar-guia-bb-pay-protesto"
            );
          } else {
            buttonElement = undefined;
          }
        }

        vm.isGeneratingBbPay = true;
        if (buttonElement) {
          buttonElement.button("loading");
        }
        GruService.generatePaymentLink(
          preencheDadosGru(vm.itensSelecionados, "/gru/salvarGruArrecadacao")
        )
          .then(function (response) {
            // Armazena os dados da solicitação para consulta posterior
            vm.bbPay.codigoSolicitacao = response.data.codigoSolicitacao;
            vm.bbPay.dividasSelecionadas = vm.itensSelecionados;

            vm.bbPayModalUrl = $sce.trustAsResourceUrl(
              response.data.linkCartao
            );
            angular.element("#bbPayPaymentModal").modal("show");
          })
          .catch(function (errorMessage) {
            // O serviço já deve retornar uma string de erro amigável
            ngMessageCenter.error({
              timeout: 12000,
              title: "ERRO!",
              text: __montaMensagemDeErro($filter, errorMessage),
              name: "extratoMessages",
            });
          })
          .finally(function () {
            vm.isGeneratingBbPay = false;
            if (buttonElement) {
              buttonElement.button("reset");
            }
          });
      };

      function cleanLocalReferenceFiles() {
        vm.gru = undefined;
        vm.gruName = undefined;
        vm.extratoDebitoReport = undefined;
        vm.bbPayModalUrl = undefined;
      }

      function consultarStatusPagamento() {
        if (!vm.bbPay || !vm.bbPay.codigoSolicitacao) {
          return;
        }

        GruService.consultarPagamentoBBPay(vm.bbPay.codigoSolicitacao)
          .then(function (response) {
            if (
              response.data &&
              response.data.estadoSolicitacao === "CONCLUIDA"
            ) {
              ngMessageCenter.success({
                timeout: 12000,
                text: "Pagamento confirmado! Atualizando lista de débitos.",
                name: "extratoMessages",
              });

              // Cria um mapa de IDs únicos para os débitos que foram pagos.
              var idsPagos = {};
              vm.bbPay.dividasSelecionadas.forEach(function (debito) {
                var id =
                  debito.nuAnoContaReceber +
                  "-" +
                  debito.nuContaReceber +
                  "-" +
                  (debito.nuDividaAtiva || "null");
                idsPagos[id] = true;
              });

              var isDebitoPago = function (debito) {
                var id =
                  debito.nuAnoContaReceber +
                  "-" +
                  debito.nuContaReceber +
                  "-" +
                  (debito.nuDividaAtiva || "null");
                return !!idsPagos[id];
              };

              // Filtra as listas de débitos, removendo os que foram pagos
              vm.debitos = vm.debitos.filter(function (d) {
                return !isDebitoPago(d);
              });
              vm.dividasEmProtesto = vm.dividasEmProtesto.filter(function (d) {
                return !isDebitoPago(d);
              });

              // Zera os totais e a seleção para evitar inconsistências
              vm.vlTotalSelecionado = 0.0;
              vm.vlTotalSelecionadoProtestado = 0.0;
              vm.selectedAll = {};
              vm.itensSelecionados = [];
              vm.updateCanGenerateBbPay();
            }
          })
          .catch(function (error) {
            $log.warn(
              "Não foi possível verificar o status do pagamento:",
              error
            );
          })
          .finally(function () {
            // Limpa os dados da transação pendente para não re-verificar
            vm.bbPay.codigoSolicitacao = null;
            vm.bbPay.dividasSelecionadas = [];

            // Garante que o iframe seja limpo para a próxima abertura
            $scope.$applyAsync(function () {
              vm.bbPayModalUrl = null;
            });
          });
      }

      function salvarEImprimirGRU(gruDTO) {
        angular.element("#generate-gru-button").button("loading");
        GruService.saveGru(gruDTO)
          .then(function (data) {
            angular.element("#modalEndereco").modal("hide");
            imprimirBoleto({
              nuAnogru: data.data.nuAnogru,
              nuGru: data.data.nuGru,
            });
          })
          .catch(function (fallback) {
            ngMessageCenter.error({
              timeout: 12000,
              title: "ERRO!",
              text: __montaMensagemDeErro($filter, fallback),
              name: "extratoMessages",
            });
          })
          .finally(function () {
            angular.element("#generate-gru-button").button("reset");
          });
      }

      function imprimirBoleto(gruPK) {
        vm.gruName =
          $filter("translate")("title.gru") +
          "-" +
          gruPK.nuAnogru +
          "-" +
          gruPK.nuGru +
          ".pdf";
        var filter = {
          cdTipoEmissao: TipoBoleto.SACADO_DETALHADO_DERPR,
          tipoObservacao: TipoCampoObservacaoBoleto.CAMPO_OBSERVACAO_DERPR,
          esconderEnderecoSacado: vm.devedor.tpPessoa === "F",
          nuAnoGru: gruPK.nuAnogru,
          nuGru: gruPK.nuGru,
        };
        GruService.printBoleto(filter)
          .then(function (response) {
            vm.gru = new Blob([response.data], {
              type: "application/pdf",
            });
          })
          .catch(function (fallback) {
            ngMessageCenter.error({
              timeout: 12000,
              title: "ERRO!",
              text: __montaMensagemDeErro($filter, fallback),
              name: "extratoMessages",
            });
          });
      }

      function preencheDadosGru(itensSelecionados, nmFormValue) {
        var gruDTO = {};
        gruDTO.auditInfo = {
          cdSistema: 340,
          nmForm: nmFormValue,
          cdUsuario: "INTERNET",
        };
        gruDTO.cdBanco = $filter("translate")("label.codigo.banco.brasil");
        gruDTO.cdCarteira = $filter("translate")("label.codigo.carteira");
        gruDTO.sacado = {
          deComplemento: vm.devedor.deComplemento,
          deLogradouro: vm.enderecoForm.deEndereco,
          deNome: vm.devedor.deNome,
          nmBairro: vm.enderecoForm.nmBairro,
          nmCidade: vm.enderecoForm.nmMunicipio,
          nuCep: vm.enderecoForm.nuCEP,
          nuIdent: vm.devedor.nuDocumento,
          nuNumero: vm.enderecoForm.nuNumero,
          sgUF: vm.enderecoForm.sgUnidadefederal,
          tipo: vm.devedor.tpPessoa === "F" ? "FISICA" : "JURIDICA",
        };
        gruDTO.nuIdentCedente = $filter("translate")(
          "label.numero.ident.cedente"
        );
        gruDTO.nmCedente = $filter("translate")("label.nome.cedente");
        gruDTO.deObservacao =
          itensSelecionados.length +
          " " +
          $filter("translate")("label.parcelas.selecionadas");
        gruDTO.dtDocumento = new Date();
        gruDTO.dtProcessamento = new Date();
        gruDTO.deInstrucoes = $filter("translate")(
          "label.nao.receber.apos.vencimento"
        );
        gruDTO.codigoUsuario = "INTERNET";
        gruDTO.servicos = [];
        gruDTO.composicoes = [];
        angular.forEach(itensSelecionados, function (item) {
          gruDTO.composicoes.push({
            nuAnoContaReceber: item.nuAnoContaReceber,
            nuContaReceber: item.nuContaReceber,
            nuDividaAtiva: item.nuDividaAtiva,
            nuParcelamento: item.nuParcelamento,
            vlAtualizado: item.vlAtualizado,
            vlInicial: item.vlOriginal,
          });
          gruDTO.servicos.push({
            qtUnidades: 1,
            qtQuantidade: 1,
            valor: item.vlAtualizado,
            codCategoria: item.cdGrupo,
            codServico: item.cdServico,
          });
        });
        return gruDTO;
      }

      function formatEnderecoDevedor() {
        if (TipoPessoa.FISICA === vm.devedor.tpPessoa) {
          vm.devedor.deEndereco = null;
          vm.devedor.nuNumero = null;
          vm.devedor.deComplemento = null;
          vm.devedor.nmBairro = null;
          vm.devedor.nuCEP = null;
          vm.devedor.nmMunicipio = null;
          vm.devedor.sgUnidadefederal = null;
          vm.exibeLabelEndereco = false;
        } else {
          if (
            vm.devedor.deEndereco != null &&
            vm.devedor.deEndereco.length > 48
          ) {
            vm.devedor.deEndereco = vm.devedor.deEndereco.substring(0, 48);
          }
          vm.enderecoForm.deEndereco = vm.devedor.deEndereco;
          vm.enderecoForm.nuNumero = vm.devedor.nuNumero;
          vm.enderecoForm.deComplemento = vm.devedor.deComplemento;
          vm.enderecoForm.nmBairro = vm.devedor.nmBairro;
          vm.enderecoForm.nuCEP = vm.devedor.nuCEP;
          vm.enderecoForm.nmMunicipio = vm.devedor.nmMunicipio;
          vm.enderecoForm.sgUnidadefederal = vm.devedor.sgUnidadefederal;
          vm.exibeLabelEndereco = true;
        }
        vm.devedor.cdMunicipio = null;
      }

      function atualizaDadosDebitoSelecionado(debitoSelecionado) {
        if (debitoSelecionado.selected) {
          vm.vlTotalSelecionado =
            vm.vlTotalSelecionado + debitoSelecionado.vlAtualizado;
          verificaSeDividaPossuiGrupoServico(debitoSelecionado);
        } else {
          vm.vlTotalSelecionado =
            vm.vlTotalSelecionado - debitoSelecionado.vlAtualizado;
        }
      }

      function atualizaDadosDebitoSelecionadoProtestado(debitoSelecionado) {
        if (debitoSelecionado.selected) {
          vm.vlTotalSelecionadoProtestado =
            vm.vlTotalSelecionadoProtestado + debitoSelecionado.vlAtualizado;
          verificaSeDividaPossuiGrupoServico(debitoSelecionado);
        } else {
          vm.vlTotalSelecionadoProtestado =
            vm.vlTotalSelecionadoProtestado - debitoSelecionado.vlAtualizado;
          vm.updateCanGenerateBbPay();
        }
      }

      function verificaSeDividaPossuiGrupoServico(debitoSelecionado) {
        if (
          debitoSelecionado.nuDividaAtiva !== null &&
          angular.isUndefined(debitoSelecionado.cdGrupo)
        ) {
          SidService.findGrupoServicoByChaveContaReceber(
            debitoSelecionado.nuAnoContaReceber,
            debitoSelecionado.nuContaReceber
          )
            .then(function (data) {
              debitoSelecionado.cdGrupo = data.cdGrupo;
              debitoSelecionado.cdServico = data.cdServico;
            })
            .catch(function (fallback) {
              ngMessageCenter.error({
                timeout: 12000,
                title: "ERRO!",
                text: __montaMensagemDeErro($filter, fallback),
                name: "extratoMessages",
              });
            });
        }
      }

      function consultaPessoa(nuDocumento, dePlaca) {
        CndService.findPessoaByNuDocumentoOuDePlaca(nuDocumento, dePlaca)
          .then(function (data) {
            vm.devedor = data;
            vm.devedor.dePlaca = dePlaca;
            vm.devedor.nuRegistro = !!dePlaca
              ? undefined
              : $stateParams.nuRegistro;
            vm.devedor.nuDocumentoFmt = !!dePlaca
              ? "Indisponível"
              : formatDocumentoPessoa(vm.devedor.nuDocumento);
            vm.devedor.deNomeFmt = !!dePlaca ? "Indisponível" : data.deNome;
            formatEnderecoDevedor();
          })
          .catch(function (fallback) {
            ngMessageCenter.error({
              timeout: 12000,
              title: "ERRO!",
              text: __montaMensagemDeErro($filter, fallback),
              name: "extratoMessages",
            });
          });
      }

      // Inicializa o estado do botão BB Pay
      vm.updateCanGenerateBbPay();

      // Listener para o evento de fechamento da modal do BB Pay
      angular.element("#bbPayPaymentModal").on("hidden.bs.modal", function () {
        $scope.$apply(function () {
          consultarStatusPagamento();
        });
      });
    },
  ]);
})();

(function () {
  'use strict';

  angular
    .module('cndFrontend')
    .controller('EfeitoSuspensivoController', ['$state', '$stateParams', '$log', '$scope', 'ngMessageCenter', 'contasComEfeitoSuspensivo',
      'dividasComEfeitoSuspensivo',
      function ($state, $stateParams, $log, $scope, ngMessageCenter, contasComEfeitoSuspensivo,
        dividasComEfeitoSuspensivo) {

          var vm = this;

        vm.vlTotalAtualizado = 0.0;
        vm.vlTotalAtualizadoComJuros = 0.0;
        vm.debitosComEfeitoSuspensivoDetail = {};
        vm.debitosComEfeitoSuspensivo = [];
        vm.isDebitoFromMulta = checkIfIsDebitoFromMulta;

        var contaReceberFormatadas = formatContasReceber(contasComEfeitoSuspensivo.contasReceber);
        vm.debitosComEfeitoSuspensivo = vm.debitosComEfeitoSuspensivo.concat(contaReceberFormatadas.debitos);
        vm.vlTotalAtualizado = vm.vlTotalAtualizado + contaReceberFormatadas.vlTotalAtualizado;
        vm.vlTotalAtualizadoComJuros = vm.vlTotalAtualizadoComJuros + contaReceberFormatadas.vlTotalAtualizadoComJuros;

        var dividasFormatadas = formatDividasAtivas(dividasComEfeitoSuspensivo.dividasAtivas);
        vm.debitosComEfeitoSuspensivo = vm.debitosComEfeitoSuspensivo.concat(dividasFormatadas.debitos);
        vm.vlTotalAtualizado = vm.vlTotalAtualizado + dividasFormatadas.vlTotalAtualizado;
        vm.vlTotalAtualizadoComJuros = vm.vlTotalAtualizadoComJuros + dividasFormatadas.vlTotalAtualizadoComJuros;
      }
    ]);
})();

(function () {
  "use strict";

  angular.module("cndFrontend").controller("EmissaoGuiaController", [
    "$filter",
    "$state",
    "$stateParams",
    "$log",
    "$document",
    "RecService",
    "SidService",
    "CdtService",
    "CndService",
    "ngMessageCenter",
    "$q",
    "$timeout",
    function (
      $filter,
      $state,
      $stateParams,
      $log,
      $document,
      RecService,
      SidService,
      CdtService,
      CndService,
      ngMessageCenter,
      $q,
      $timeout
    ) {
      /** @ngInject */

      var vm = this;
      vm.searchFilter = {};
      vm.searchForm = {};
      vm.searchFilter.type = FilterType.CNPJ;
      vm.searchFilter.isREGISTRO = true;
      vm.searchFilter.isCNPJ = FilterType.CNPJ;

      vm.changeFieldOption = function () {
        vm.searchFilter.nuDocumento = "";
        vm.searchFilter.nuRegistro = "";
        vm.searchFilter.nuPlaca = "";
        vm.searchFilter.isCNPJ = FilterType.CNPJ === vm.searchFilter.type;
        vm.searchFilter.isCPF = FilterType.CPF === vm.searchFilter.type;
      };

      vm.gerarGuia = function () {
        SidService.printBoletoCartorio(
          vm.searchFilter.nuRegistro,
          vm.searchFilter.nuDocumento
        )
          .then(function (response) {
            vm.gruName = "GRU_CARTORIO_" + vm.searchFilter.nuRegistro;
            vm.gru = new Blob([response.data], {
              type: "application/pdf",
            });
            //var fileURL = URL.createObjectURL(vm.gru);
            //window.open(fileURL);
          })
          .catch(function (fallback) {
            var uint8Array = new Uint8Array(fallback.data);
            var decodedString = new TextDecoder("utf-8").decode(uint8Array);
            ngMessageCenter.error({
              timeout: 12000,
              title: "ERRO!",
              //text: decodedString,
              text:
                HttpCode.BAD_REQUEST === fallback.status
                  ? decodedString
                  : __montaMensagemDeErro($filter, fallback),
              name: "cartorioMessages",
            });
          });
      };

      vm.openMainPage = function () {
        if (vm.searchFilter.nuRegistro !== "") {
          vm.searchFilter.nuRegistro = parseInt(vm.searchFilter.nuRegistro);
        }
        $state.go(RouterName.MAIN, {
          nuDocumento: vm.searchFilter.nuDocumento,
          nuRegistro: vm.searchFilter.nuRegistro,
          dePlaca: vm.searchFilter.nuPlaca,
        });
      };

      vm.confirmarNotificacao = function () {
        CndService.notificacaoDeInconsistencia(
          vm.devedor,
          vm.notificacaoForm.deEmail,
          vm.deInconsistencias
        )
          .then(function (data) {
            angular.element("#modalConsolidacao").modal("hide");
          })
          .catch(function (fallback) {
            ngMessageCenter.error({
              timeout: 12000,
              title: "ERRO!",
              text: __montaMensagemDeErro(fallback),
              name: "mainMessages",
            });
          });
      };

      function __montaMensagemDeErro(fallback) {
        $log.info(
          "Erro status code: " +
            fallback.status +
            ", conteudo do response: " +
            fallback
        );
        if (HttpCode.NOT_FOUND === fallback.status) {
          return $filter("translate")("messages.service.notfound");
        }
        if (HttpCode.SERVICE_UNAVAILABLE === fallback.status) {
          return $filter("translate")("messages.service.unavailable");
        }
        if (HttpCode.SERVER_ERROR === fallback.status) {
          return fallback.text;
        }
        if (HttpCode.BAD_REQUEST === fallback.status) {
          return (
            $filter("translate")("messages.service.badrequest") +
            fallback.data.message
          );
        } else {
          return $filter("translate")("messages.service.error.unexpected");
        }
      }
    },
  ]);
})();

(function () {
  'use strict';

  angular
    .module('cndFrontend')
    .controller('AcordoJuridicoController',
      ['$state', '$stateParams', '$log', 'ngMessageCenter', 'detalhesAcordoJuridico', function ($state, $stateParams, $log, ngMessageCenter, detalhesAcordoJuridico) {

        var vm = this;
        vm.nuContaReceber = $stateParams.nuContaReceber;
        vm.nuAnoContaReceber = $stateParams.nuAnoContaReceber;
        vm.detalhesAcordoJuridico = formatDetalheAcordoJuridico(detalhesAcordoJuridico.detalhesAcordoJuridico);

        function formatDetalheAcordoJuridico(detalhesAcordoJuridico) {
          var detalhesAcordoJuridicoFmt = [];
          for (var i = 0, len = detalhesAcordoJuridico.length; i < len; i++) {
            var debito = detalhesAcordoJuridico[i];
            debito.isCollapsedExtratoAcordo = false;
            detalhesAcordoJuridicoFmt[i] = debito;
          }
          return detalhesAcordoJuridicoFmt;
        }
      }]);
})();

(function () {
  'use strict';

  angular
    .module('cndFrontend')
    .controller('AcordoAdministrativoController',
      ['$filter', '$state', '$stateParams', '$log', 'ngMessageCenter', 'detalhesAcordoAdministrativo',
        'CdtService', 'GruService', function ($filter, $state, $stateParams, $log, ngMessageCenter, detalhesAcordoAdministrativo, CdtService, GruService) {

        var vm = this;
        vm.nuContaReceber = $stateParams.nuContaReceber;
        vm.nuAnoContaReceber = $stateParams.nuAnoContaReceber;
        vm.enderecoForm = {};
        vm.gru = undefined;
        vm.gruName = undefined;
        vm.unidadesFederais = UNIDADES_FEDERAIS;
        vm.detalhesAcordoAdministrativo = formatDetalheAcordoAdministrativo(detalhesAcordoAdministrativo);

        if ($stateParams.devedor === null) {
          consultaPessoa($stateParams.nuDocumento);
        } else {
          vm.devedor = $stateParams.devedor;
          vm.devedor.nuRegistro = $stateParams.nuRegistro;
          vm.devedor.nuDocumentoFmt = formatDocumentoPessoa(vm.devedor.nuDocumento);
          formatEnderecoDevedor();
        }

        function consultaPessoa(searchFilter) {
          CdtService.findPessoaByNuDocumento(searchFilter)
            .then(function (data) {
              vm.devedor = data.data[0];
              vm.devedor.nuRegistro = $stateParams.nuRegistro;
              vm.devedor.nuDocumentoFmt = formatDocumentoPessoa(vm.devedor.nuDocumento);
              formatEnderecoDevedor();
            }).catch(function (fallback) {
            ngMessageCenter.error({
              timeout: 12000,
              title: 'ERRO!',
              text: __montaMensagemDeErro(fallback),
              name: 'extratoMessages'
            });
          });
        }

        function formatEnderecoDevedor() {
          if (TipoPessoa.FISICA === vm.devedor.tpPessoa) {
            vm.devedor.deEndereco = null;
            vm.devedor.nuNumero = null;
            vm.devedor.deComplemento = null;
            vm.devedor.nmBairro = null;
            vm.devedor.nuCEP = null;
            vm.devedor.nmMunicipio = null;
            vm.devedor.sgUnidadefederal = null;
            vm.exibeLabelEndereco = false;
          } else {
            if(vm.devedor.deEndereco != null && vm.devedor.deEndereco.length > 48){
              vm.devedor.deEndereco = vm.devedor.deEndereco.substring(0,48);
            }
            vm.enderecoForm.deEndereco = vm.devedor.deEndereco;
            vm.enderecoForm.nuNumero = vm.devedor.nuNumero;
            vm.enderecoForm.deComplemento = vm.devedor.deComplemento;
            vm.enderecoForm.nmBairro = vm.devedor.nmBairro;
            vm.enderecoForm.nuCEP = vm.devedor.nuCEP;
            vm.enderecoForm.nmMunicipio = vm.devedor.nmMunicipio;
            vm.enderecoForm.sgUnidadefederal = vm.devedor.sgUnidadefederal;
            vm.exibeLabelEndereco = true;
          }
          vm.devedor.cdMunicipio = null;
        }

        function formatDetalheAcordoAdministrativo(detalhesAcordoAdministrativo) {
          var detalhesAcordoAdministrativoFmt = [];
          for (var i = 0, len = detalhesAcordoAdministrativo.parcelamento.length; i < len; i++) {
            var parcela = {};
            parcela.isCollapsedExtratoAcordo = false;
            parcela.nuParcelamento = detalhesAcordoAdministrativo.parcelamento[i].nuParcelamento;
            parcela.nuAnoContaReceber = detalhesAcordoAdministrativo.nuAnoContaReceber;
            parcela.nuContaReceber = detalhesAcordoAdministrativo.nuContaReceber;
            parcela.cdGrupo = detalhesAcordoAdministrativo.cdGrupo;
            parcela.cdServico = detalhesAcordoAdministrativo.cdServico;
            parcela.nuAnoGru = detalhesAcordoAdministrativo.parcelamento[i].nuAnogru;
            parcela.nuGru = detalhesAcordoAdministrativo.parcelamento[i].nuGru;
            parcela.vlParcela = detalhesAcordoAdministrativo.parcelamento[i].vlParcela;
            parcela.dtPagamento = detalhesAcordoAdministrativo.parcelamento[i].dtPagto;
            parcela.dtVencimento = detalhesAcordoAdministrativo.parcelamento[i].dtVencto;
            detalhesAcordoAdministrativoFmt[i] = parcela;
          }
          return detalhesAcordoAdministrativoFmt;
        }
      }]);
})();

(function () {
  'use strict';

  angular
    .module('cndFrontend')
    .controller('AgImposicaoFinalController', ['$state', '$stateParams', '$log', '$scope', 'ngMessageCenter', 'contasAgImposicaoFinal',
      function ($state, $stateParams, $log, $scope, ngMessageCenter, contasAgImposicaoFinal) {

        var vm = this;

        vm.vlTotalAtualizado = 0.0;
        vm.vlTotalAtualizadoComJuros = 0.0;
        vm.vlTotalSelecionado = 0.0;

        vm.debitosAgImposicaoFinalDetail = {};
        vm.debitosAgImposicaoFinal = [];
        vm.isDebitoFromMulta = checkIfIsDebitoFromMulta;

        var contaReceberFormatadas = formatContasReceber(contasAgImposicaoFinal.contasReceber);
        vm.debitosAgImposicaoFinal = vm.debitosAgImposicaoFinal.concat(contaReceberFormatadas.debitos);
        vm.vlTotalAtualizado = vm.vlTotalAtualizado + contaReceberFormatadas.vlTotalAtualizado;
        vm.vlTotalAtualizadoComJuros = vm.vlTotalAtualizadoComJuros + contaReceberFormatadas.vlTotalAtualizadoComJuros;

        vm.atualizaValorSelecionado = function (debito) {
          atualizaDadosDebitoSelecionado(debito);
        };

        function atualizaDadosDebitoSelecionado(debitoSelecionado) {
          if (debitoSelecionado.selected) {
            vm.vlTotalSelecionado = vm.vlTotalSelecionado + debitoSelecionado.vlAtualizadoComJuros;
            verificaSeDividaPossuiGrupoServico(debitoSelecionado);
          } else {
            vm.vlTotalSelecionado = vm.vlTotalSelecionado - debitoSelecionado.vlAtualizadoComJuros;
          }
        }

        vm.checkAll = function () {
          var vlTotalItems = 0.0;
          angular.forEach(vm.debitosAgImposicaoFinal, function (item) {
            item.selected = vm.selectedAll;
            vlTotalItems = vlTotalItems + item.vlAtualizadoComJuros;
            verificaSeDividaPossuiGrupoServico(item);
          });
          if (vm.selectedAll) {
            vm.vlTotalSelecionado = vlTotalItems;
          } else {
            vm.vlTotalSelecionado = 0.0;
          }
        };

        function verificaSeDividaPossuiGrupoServico(debitoSelecionado) {
          if (debitoSelecionado.nuDividaAtiva !== null && angular.isUndefined(debitoSelecionado.cdGrupo)) {
            SidService.findGrupoServicoByChaveContaReceber(debitoSelecionado.nuAnoContaReceber, debitoSelecionado.nuContaReceber).then(function (data) {
              debitoSelecionado.cdGrupo = data.cdGrupo;
              debitoSelecionado.cdServico = data.cdServico;
            }).catch(function (fallback) {
              ngMessageCenter.error({
                timeout: 12000,
                title: 'ERRO!',
                text: __montaMensagemDeErro($filter, fallback),
                name: 'extratoMessages'
              });
            });
          }
        }

      }
    ]);
})();

(function() {
  'use strict';

  angular
      .module('cndFrontend')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Softplan Angular UI Bootstrap',
        'url': 'https://github.com/pdsoftplan/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team. (Softplan customs)',
        'logo': 'ui-bootstrap.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('cndFrontend')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('cndFrontend')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
  var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
  $provide.value("$locale", {
    "DATETIME_FORMATS": {
      "AMPMS": [
        "AM",
        "PM"
      ],
      "DAY": [
        "domingo",
        "segunda-feira",
        "ter\u00e7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\u00e1bado"
      ],
      "ERANAMES": [
        "antes de Cristo",
        "depois de Cristo"
      ],
      "ERAS": [
        "a.C.",
        "d.C."
      ],
      "FIRSTDAYOFWEEK": 6,
      "MONTH": [
        "janeiro",
        "fevereiro",
        "mar\u00e7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
      ],
      "SHORTDAY": [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\u00e1b"
      ],
      "SHORTMONTH": [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
      ],
      "STANDALONEMONTH": [
        "janeiro",
        "fevereiro",
        "mar\u00e7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
      ],
      "WEEKENDRANGE": [
        5,
        6
      ],
      "fullDate": "EEEE, d 'de' MMMM 'de' y",
      "longDate": "d 'de' MMMM 'de' y",
      "medium": "d 'de' MMM 'de' y HH:mm:ss",
      "mediumDate": "d 'de' MMM 'de' y",
      "mediumTime": "HH:mm:ss",
      "short": "dd/MM/yy HH:mm",
      "shortDate": "dd/MM/yy",
      "shortTime": "HH:mm"
    },
    "NUMBER_FORMATS": {
      "CURRENCY_SYM": "R$",
      "DECIMAL_SEP": ",",
      "GROUP_SEP": ".",
      "PATTERNS": [
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 3,
          "minFrac": 0,
          "minInt": 1,
          "negPre": "-",
          "negSuf": "",
          "posPre": "",
          "posSuf": ""
        },
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 2,
          "minFrac": 2,
          "minInt": 1,
          "negPre": "-\u00a4",
          "negSuf": "",
          "posPre": "\u00a4",
          "posSuf": ""
        }
      ]
    },
    "id": "pt-br",
    "localeID": "pt_BR",
    "pluralCat": function(n, opt_precision) {  if (n >= 0 && n <= 2 && n != 2) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
  });
}]);

(function() {
  'use strict';

  angular
    .module('cndFrontend')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

angular.module('cndFrontend').filter('ifEmpty', function () {
  return function (input, defaultValue) {
    if (angular.isUndefined(input) || input === null || input === '') {
      return defaultValue;
    }
    return input;
  }
});

angular
  .module('cndFrontend')
  .directive('spCnpjAlfa', [function () {
    
    /**
     * Validação baseada na documentação técnica do SERPRO e implementação Java
     * [cite: 15, 16, 54, 81]
     */
    function validarCNPJAlfanumerico(cnpj) {
        if (!cnpj) return false;

        // 1. Limpeza e Formatação Inicial
        // Remove caracteres de formatação [./-] conforme REGEX_CARACTERES_FORMATACAO [cite: 49, 87]
        cnpj = cnpj.replace(/[.\-\/]/g, '').toUpperCase();

        // 2. Validação de Formação
        // Deve ter 14 caracteres, não ser zerado e os 12 primeiros alfanuméricos [cite: 15, 50, 52]
        if (cnpj.length !== 14 || /^0+$/.test(cnpj) || !/^[A-Z0-9]{12}/.test(cnpj)) {
            return false;
        }

        // 3. Configuração de Pesos
        // Os pesos são distribuídos de 2 a 9 da direita para a esquerda [cite: 26, 54]
        var pesos = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

        /**
         * Função interna para calcular o dígito (Módulo 11)
         * [cite: 31, 32, 33, 84]
         */
        var calcularDigito = function(trecho) {
            var soma = 0;
            // O peso usado depende do tamanho do trecho (12 ou 13 caracteres)
            var offsetPeso = pesos.length - trecho.length;

            for (var i = 0; i < trecho.length; i++) {
                var c = trecho[i];
                var valor;
                
                // Conforme PDF SERPRO: Subtrair 48 do Valor ASCII 
                // Números (0-9): ASCII 48-57 -> Valores 0-9
                // Letras (A-Z): ASCII 65-90 -> Valores 17-42
                valor = c.charCodeAt(0) - 48;
                
                soma += valor * pesos[offsetPeso + i];
            }

            var resto = soma % 11;
            return (resto < 2) ? 0 : 11 - resto;
        };

        // 4. Cálculo dos Dígitos Verificadores
        // Extrai a base (12 caracteres) e os DVs informados [cite: 59, 61]
        var baseCnpj = cnpj.substring(0, 12);
        var dvInformado = cnpj.substring(12);

        var dv1 = calcularDigito(baseCnpj);
        var dv2 = calcularDigito(baseCnpj + dv1);

        // 5. Comparação Final [cite: 62]
        return (dv1.toString() + dv2.toString()) === dvInformado;
    }

    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            // Adiciona a regra de validação ao ngModel do Angular
            ngModel.$validators.cnpj = function (modelValue, viewValue) {
                var valor = modelValue || viewValue;
                if (ngModel.$isEmpty(valor)) return true;
                return validarCNPJAlfanumerico(valor);
            };

            // Garante que o input visual seja sempre maiúsculo
            element.on('input', function () {
                var position = this.selectionStart;
                this.value = this.value.toUpperCase();
                this.selectionStart = this.selectionEnd = position;
            });
        }
    };
  }]);
angular
  .module('cndFrontend').directive('protestoDetailDialog', [function () {
    return {
      restrict: 'E',
      scope: {
        model: '='
      },
      link: function (scope, element, attributes) {
        scope.$watch('model.visible', function (newValue) {
          var modalElement = element.find('.modal');
          modalElement.modal(newValue ? 'show' : 'hide');
        });

        element.on('shown.bs.modal', function () {
          scope.$apply(function () {
            scope.model.visible = true;
          });
        });

        element.on('hidden.bs.modal', function () {
          angular.element('body').css('padding-right', '0');
          scope.$apply(function () {
            scope.model.visible = false;
          });
        });
      },
      templateUrl: 'app/components/directives/protesto-detail-dialog.html'
    };
  }]);

angular
  .module('cndFrontend').directive('fileDownload', function () {
  return {
    restrict: 'A',
    scope: {
      fileDownload: '=',
      fileName: '='
    },

    link: function (scope, elem, atrs) {

      scope.$watch('fileDownload', function (newValue, oldValue) {

        if (newValue != undefined && newValue != null) {
          var isIE = /*@cc_on!@*/!!document.documentMode;
          var isEdge = !isIE && !!window.StyleMedia;
          var isChrome = !!window.chrome && !!window.chrome.webstore;

          if (isIE || isChrome || isEdge) {
            if (isChrome) {
              console.log('Manage Google Chrome download');
              var url = window.URL || window.webkitURL;
              var fileURL = url.createObjectURL(scope.fileDownload);
              var downloadLink = angular.element('<a></a>');//create a new  <a> tag element
              downloadLink.attr('href', fileURL);
              downloadLink.attr('download', scope.fileName);
              downloadLink.attr('target', '_self');
              downloadLink[0].click();//call click function
              url.revokeObjectURL(fileURL);//revoke the object from URL
            }
            if (isIE || isEdge) {
              console.log('Manage IE download>10');
              window.navigator.msSaveOrOpenBlob(scope.fileDownload, scope.fileName);
            }
          } else {
            console.log('Manage Mozilla Firefox download');
            var url = window.URL || window.webkitURL;
            var fileURL = url.createObjectURL(scope.fileDownload);
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = fileURL;
            a.download = scope.fileName;
            a.target = '_self';
            a.click();//we call click function
          }
        }
      });
    }
  }
});

angular
  .module('cndFrontend').directive('debitoDetailDialog', [function () {
    return {
      restrict: 'E',
      scope: {
        model: '='
      },
      link: function (scope, element, attributes) {
        scope.$watch('model.visible', function (newValue) {
          var modalElement = element.find('.modal');
          modalElement.modal(newValue ? 'show' : 'hide');
        });

        element.on('shown.bs.modal', function () {
          scope.$apply(function () {
            scope.model.visible = true;
          });
        });

        element.on('hidden.bs.modal', function () {
          angular.element('body').css('padding-right', '0');
          scope.$apply(function () {
            scope.model.visible = false;
          });
        });
      },
      templateUrl: 'app/components/directives/debito-detail-dialog.html'
    };
  }]);

/** @return string */
function CCNPJ_formateValue(cnpjWithoutFormat) {
  var cnpjFmt = cnpjWithoutFormat.slice(0, 2) + '.' + cnpjWithoutFormat.slice(2, 5) + '.' + cnpjWithoutFormat.slice(5, 8) + '/' + cnpjWithoutFormat.slice(8, 12) + '-' + cnpjWithoutFormat.slice(12);
  if (cnpjWithoutFormat.slice(8, 12) === "0001") {
    cnpjFmt = cnpjFmt + " (Matriz)"
  } else {
    cnpjFmt = cnpjFmt + " (Filial)"
  }
  return cnpjFmt
}

/** @return string */
function CCPF_formateValue(cpfWithoutFormat) {
  return cpfWithoutFormat.slice(0, 3) + '.' + cpfWithoutFormat.slice(3, 6) + '.' + cpfWithoutFormat.slice(6, 9) + '-' + cpfWithoutFormat.slice(9);
}

function checkIfIsDebitoFromMulta (codigoTipoDivida, codigoTipoReceita) {
  return CodigoTipoDivida.STC == codigoTipoDivida || CodigoTipoDivida.MTM == codigoTipoDivida
    || CodigoTipoReceita.STC == codigoTipoReceita || CodigoTipoReceita.MTM == codigoTipoReceita;
}

function formatDocumentoPessoa(documento) {
  var documentoFmt = "Indisponível";
  if (documento === null || documento === "") {
    return documentoFmt;
  }
  if (documento.length === 14) {
    documentoFmt = CCNPJ_formateValue(documento);
  }
  if (documento.length === 11) {
    documentoFmt = CCPF_formateValue(documento);
  }
  return documentoFmt;
}

function __montaMensagemDeErro(filter, fallback) {

  if(fallback === undefined){
    return filter('translate')('messages.service.error.unexpected');
  }
  if (HttpCode.NOT_FOUND === fallback.status) {
    return filter('translate')('messages.service.notfound');
  }
  if (HttpCode.SERVICE_UNAVAILABLE === fallback.status) {
    return filter('translate')('messages.service.unavailable');
  }
  if (HttpCode.SERVER_ERROR === fallback.status) {
    if(fallback.data.message === undefined){
      return fallback.text;
    }else{
      return fallback.data.message;
    }
  }
  if (HttpCode.BAD_REQUEST === fallback.status) {

    if(fallback.data.message === undefined){
      return filter('translate')('messages.service.badrequest') + fallback.data;
    }else{
      return filter('translate')('messages.service.badrequest') + fallback.data.message;
    }
  } else {
    return filter('translate')('messages.service.error.unexpected');
  }
}

function formatContasReceber(contas) {
  var contasReceberFmt = {
    vlTotalAtualizado: 0,
    vlTotalAtualizadoComJuros: 0,
    debitos: []
  };
  if (contas == undefined) {
    return contasReceberFmt;
  }
  for (var i = 0, len = contas.length; i < len; i++) {
    var debito = contas[i];
    debito.descricao = contas[i].deTipoReceita;
    debito.nuAnoContaReceber = contas[i].nuAnocontareceber;
    debito.nuContaReceber = contas[i].nuContareceber;
    debito.anoEnumeroCR = contas[i].nuContareceber + "/" + contas[i].nuAnocontareceber;
    debito.nuParcela = contas[i].nuParcelamento;
    debito.vlOriginal = contas[i].vlLiquido;
    debito.isCollapsedExtrato = false;
    debito.selected = false;
    debito.autoEplaca = formatAutoEPlacaPorTipoDeMultaCR(contas[i].nuTipoReceita, contas[i]).trim();
    debito.deTipoInfracao = getTipoInfracaoDocumentoPorTipoDeMulta(contas[i].nuTipoReceita, contas[i], null, null);
    debito.dtInfracaoDocumento = getDtInfracaoDocumentoPorTipoDeMulta(contas[i].nuTipoReceita, contas[i], null, null);
    debito.deInfracao = getDescricaoInfracaoDocumentoPorTipoDeMulta(contas[i].nuTipoReceita, contas[i], null, null);
    debito.deInfracaoFmt = debito.deTipoInfracao + " - " + debito.deInfracao;
    if (CodigoTipoReceita.MTM === contas[i].nuTipoReceita) {
      debito.cdOrgao = "116200";
    }
    if (debito.dtInfracaoDocumento === "" || debito.dtInfracaoDocumento === null || angular.isUndefined(debito.dtInfracaoDocumento)) {
      debito.dtInfracaoDocumento = contas[i].dtContaReceber;
    }
    debito.vlAtualizado = contas[i].vlAtualizado;
    debito.vlAtualizadoComJuros = contas[i].vlAtualizadoComJuros;
    debito.dtInicioAtualizacao = contas[i].dtInscricao;
    contasReceberFmt.vlTotalAtualizado = contasReceberFmt.vlTotalAtualizado + debito.vlAtualizado;
    contasReceberFmt.vlTotalAtualizadoComJuros = contasReceberFmt.vlTotalAtualizadoComJuros + debito.vlAtualizadoComJuros;
    contasReceberFmt.debitos[i] = debito;
  }
  return contasReceberFmt;
}

function getDtInfracaoDocumentoPorTipoDeMulta(nuTipoReceita, contaReceber, tipoDeMulta, divida) {
    if (CodigoTipoDivida.STC === tipoDeMulta) {
      return divida.dtAutuacao;
    }
    if (CodigoTipoDivida.MTM === tipoDeMulta) {
      return divida.dtInfracao;
    }
    if (CodigoTipoReceita.STC === nuTipoReceita) {
      return contaReceber.dtAutuacao;
    }
    if (CodigoTipoReceita.MTM === nuTipoReceita) {
      return contaReceber.dtInfracao;
    }
  }

  function getTipoInfracaoDocumentoPorTipoDeMulta(nuTipoReceita, contaReceber, tipoDeMulta, divida) {
    if (CodigoTipoReceita.STC === nuTipoReceita) {
      return contaReceber.nuPenalidade;
    }
    if (CodigoTipoReceita.MTM === nuTipoReceita) {
      return contaReceber.enquadramento;
    }
    if (CodigoTipoDivida.STC === tipoDeMulta) {
      return divida.nuPenalidade;
    }
    if (CodigoTipoDivida.MTM === tipoDeMulta) {
      return divida.enquadramento;
    }
  }

  function getDescricaoInfracaoDocumentoPorTipoDeMulta(nuTipoReceita, contaReceber, tipoDeMulta, divida) {
    if (CodigoTipoDivida.STC === tipoDeMulta) {
      if(divida.dePenalidade == null){
        return "";
      }
      return divida.dePenalidade;
    }
    if (CodigoTipoDivida.MTM === tipoDeMulta) {
      if(divida.deInfracao == null){
        return "";
      }
      return divida.deInfracao;
    }
    if (CodigoTipoReceita.STC === nuTipoReceita) {
      if(contaReceber.dePenalidade == null){
        return "";
      }
      return contaReceber.dePenalidade;
    }
    if (CodigoTipoReceita.MTM === nuTipoReceita) {
      if(contaReceber.deInfracao == null){
        return "";
      }
      return contaReceber.deInfracao;
    }
  }

  function formatAutoEPlacaPorTipoDeMultaCR(nuTipoReceita, contaReceber) {
    if (CodigoTipoReceita.MTM === nuTipoReceita) {
      if (contaReceber.nuMulta !== null && contaReceber.dePlaca !== null) {
        return contaReceber.nuMulta + " / " + contaReceber.dePlaca;
      } else {
        if (contaReceber.nuMulta !== null) {
          return contaReceber.nuMulta;
        }
        if (contaReceber.dePlaca !== null) {
          return contaReceber.dePlaca;
        }
      }
    }
    if (CodigoTipoReceita.STC === nuTipoReceita) {
      if (contaReceber.nuAuto !== null && contaReceber.dePlaca !== null) {
        return contaReceber.nuAuto + "/" + contaReceber.dePlaca;
      } else {
        if (contaReceber.nuAuto !== null) {
          return contaReceber.nuAuto;
        }
        if (contaReceber.dePlaca !== null) {
          return contaReceber.dePlaca;
        }
      }
    }
	if (contaReceber.nuAuto !== null) {
		return contaReceber.nuAuto;	
	}
    return "";
  }

  function formatDividasAtivas(dividas) {
    var dividasAtivasFmt = {
        vlTotalAtualizado: 0,
        vlTotalAtualizadoComJuros: 0,
        debitos: []
    };
    if (dividas == undefined) {
      return dividasAtivasFmt;
    }
    for (var i = 0, len = dividas.length; i < len; i++) {
      var debito = dividas[i];
      debito.descricao = dividas[i].deTipoDivida;
      debito.anoEnumeroCR = dividas[i].nuContaReceber + "/" + dividas[i].nuAnoContaReceber;
      debito.nuParcela = dividas[i].nuParcelamento;
      debito.vlOriginal = dividas[i].vlOriginalEmMoeda;
      debito.vlAtualizado = dividas[i].vlAtualizado;
      debito.vlAtualizadoComJuros = dividas[i].vlAtualizadoComJuros;
      debito.dtInicioAtualizacao = dividas[i].dtInscricao;
      debito.isCollapsedExtrato = false;
      if (CodigoTipoDivida.MTM === dividas[i].cdTipoDivida) {
        debito.cdOrgao = "116200";
      }
      debito.dtInfracaoDocumento = getDtInfracaoDocumentoPorTipoDeMulta(null, null, dividas[i].cdTipoDivida, dividas[i]);
      debito.autoEplaca = formatAutoEPlacaPorTipoDeMultaDivida(dividas[i].cdTipoDivida, dividas[i]);
      debito.deTipoInfracao = getTipoInfracaoDocumentoPorTipoDeMulta(null, null, dividas[i].cdTipoDivida, dividas[i]);
      debito.deInfracao = getDescricaoInfracaoDocumentoPorTipoDeMulta(null, null, dividas[i].cdTipoDivida, dividas[i]);
      debito.deInfracaoFmt =  debito.deTipoInfracao + " - " + debito.deInfracao;
      if (debito.dtInfracaoDocumento === "" || debito.dtInfracaoDocumento === null || angular.isUndefined(debito.dtInfracaoDocumento)) {
        debito.dtInfracaoDocumento = dividas[i].dtInscricao;
      }
      dividasAtivasFmt.vlTotalAtualizado = dividasAtivasFmt.vlTotalAtualizado + debito.vlAtualizado;
      dividasAtivasFmt.vlTotalAtualizadoComJuros = dividasAtivasFmt.vlTotalAtualizadoComJuros + debito.vlAtualizadoComJuros;
      dividasAtivasFmt.debitos[i] = debito;
    }
    return dividasAtivasFmt;
  }

  function formatDividasAtivasExecutadas(dividasExecutadas) {
    var dividasAtivasExecutadasFmt = {
        vlTotalExecutadoAtualizado: 0,
        debitos: []   
    };
    if (dividasExecutadas == undefined) {
      return dividasAtivasExecutadasFmt;
    }
    for (var i = 0, len = dividasExecutadas.length; i < len; i++) {
      var debito = dividasExecutadas[i];
      debito.descricao = dividasExecutadas[i].deTipoDivida;
      debito.dividaAtiva = dividasExecutadas[i].nuDividaAtiva;
      debito.fundamentoLegal = dividasExecutadas[i].deFundamentoLegal;
      debito.deInfracao = getDescricaoInfracaoDocumentoPorTipoDeMulta(null, null, dividasExecutadas[i].cdTipoDivida, dividasExecutadas[i]);
      debito.deInfracaoFmt =  debito.fundamentoLegal + " - " + debito.deInfracao;
      debito.vlOriginal = dividasExecutadas[i].vlOriginalEmMoeda;
      debito.vlAtualizado = dividasExecutadas[i].vlAtualizado;
      debito.dtInicioAtualizacao = dividasExecutadas[i].dtInscricao;
      debito.isCollapsedExtrato = false;
      if (CodigoTipoDivida.MTM === dividasExecutadas[i].cdTipoDivida) {
        debito.cdOrgao = "116200";
      }
      debito.dtInfracaoDocumento = getDtInfracaoDocumentoPorTipoDeMulta(null, null, dividasExecutadas[i].cdTipoDivida, dividasExecutadas[i]);
      debito.autoEplaca = formatAutoEPlacaPorTipoDeMultaDivida(dividasExecutadas[i].cdTipoDivida, dividasExecutadas[i]);
      if (debito.dtInfracaoDocumento === "") {
        debito.dtInfracaoDocumento = dividasExecutadas[i].dtInscricao;
      }
      dividasAtivasExecutadasFmt.vlTotalExecutadoAtualizado = dividasAtivasExecutadasFmt.vlTotalExecutadoAtualizado + debito.vlAtualizado;
      dividasAtivasExecutadasFmt.debitos[i] = debito;
    }
    return dividasAtivasExecutadasFmt;
  }

  function formatAcordosJuridicos(acordosJuridicos) {
    var acordosJuridicosFmt = [];
    if (acordosJuridicos == undefined) {
      return acordosJuridicosFmt;
    }
    for (var i = 0, len = acordosJuridicos.length; i < len; i++) {
      var debito = acordosJuridicos[i];
      debito.tipoNegociacao = "Jurídico";
      debito.isCollapsedExtratoAcordo = false;
      acordosJuridicosFmt[i] = debito;
    }
    return acordosJuridicosFmt;
  }

  function formatAcordosAdministrativos(acordosAdministrativos) {
    var acordosAdministrativosFmt = [];
    if (acordosAdministrativos == undefined) {
      return acordosAdministrativosFmt;
    }
    for (var i = 0, len = acordosAdministrativos.length; i < len; i++) {
      var acordoAdm = acordosAdministrativos[i];
      acordoAdm.tipoNegociacao = "Administrativo";
      acordoAdm.isCollapsedExtratoAcordo = false;
      acordoAdm.nuAnoContaReceber = acordosAdministrativos[i].nuAnoContaReceber;
      acordoAdm.nuContaReceber = acordosAdministrativos[i].nuContaReceber;
      acordoAdm.dtContaReceber = acordosAdministrativos[i].dtAcordoAdministrativo;
      acordoAdm.nuParcelas = acordosAdministrativos[i].nuTotalParcelas;
      acordoAdm.nuParcelaEmAberto = acordosAdministrativos[i].nuParcelasNaoPagas;
      acordoAdm.vlSaldo = acordosAdministrativos[i].vlTotalParcelasNaoPagas;
      acordoAdm.vlNegociacao = acordosAdministrativos[i].vlTotal;
      acordosAdministrativosFmt[i] = acordoAdm;
    }
    return acordosAdministrativosFmt;
  }

  function formatAutoEPlacaPorTipoDeMultaDivida(tipoDeMulta, divida) {
    if (CodigoTipoDivida.MTM === tipoDeMulta) {
      if (divida.nuMulta !== null && divida.dePlaca !== null) {
        return divida.nuMulta + " / " + divida.dePlaca;
      } else {
        if (divida.nuMulta !== null) {
          return divida.nuMulta;
        }
        if (divida.dePlaca !== null) {
          return divida.dePlaca;
        }
      }
    }
    if (CodigoTipoDivida.STC === divida.cdTipoDivida) {
      if (divida.nuAuto !== null && divida.dePlaca !== null) {
        return divida.nuAuto + " / " + divida.dePlaca;
      } else {
        if (divida.nuAuto !== null) {
          return divida.nuAuto;
        }
        if (divida.dePlaca !== null) {
          return divida.dePlaca;
        }
      }
    }
	if (divida.nuAuto !== null) {
		return divida.nuAuto;	
	}
    return "";
  }

(function () {
  "use strict";

  angular.module("cndFrontend").service("SidService", SidService);

  function SidService($http, $q, $resource, BACK_END_SID) {
    var efeitoSuspensivo = $resource(
      BACK_END_SID + "/api/efeitosuspensivo/find/:numeroDocumento",
      { numeroDocumento: "@numeroDocumento" }
    );
    var dividasAtivas = $resource(
      BACK_END_SID + "/api/dividaativa/dividas/devedor"
    );
    var dividasAtivasEmProtesto = $resource(
      BACK_END_SID + "/api/dividaativa/dividas/protesto/emprotesto"
    );
    var dividasAtivasEmProtestoProtestado = $resource(
      BACK_END_SID + "/api/dividaativa/dividas/protesto/emprotestoeprotestadas"
    );
    var dividasExecutadas = $resource(
      BACK_END_SID + "/api/dividaativa/dividas/executadas/devedor"
    );
    var grupoServico = $resource(BACK_END_SID + "/api/gruposervico/find");
    var efeitosSuspensivos = $resource(
      BACK_END_SID + "/api/dividaativa/dividas/efeitosuspensivo/devedor"
    );

    return {
      findEfeitoSuspensivoByNuDocumento: findEfeitoSuspensivoByNuDocumento,
      findGrupoServicoByChaveContaReceber: findGrupoServicoByChaveContaReceber,
      findAllDividaAtivasByNuDocumento: findAllDividaAtivasByNuDocumento,
      findAllDividaAtivasEmProtestoByNuDocumento:
        findAllDividaAtivasEmProtestoByNuDocumento,
      findAllDividaAtivasEmProtestoEProtestadasByNuDocumento:
        findAllDividaAtivasEmProtestoEProtestadasByNuDocumento,
      findAllDividaAtivasExecutadasByNuDocumento:
        findAllDividaAtivasExecutadasByNuDocumento,
      findAllDividasComEfeitoSuspensivo: findAllDividasComEfeitoSuspensivo,
      printBoletoCartorio: printBoletoCartorio,
    };

    function findEfeitoSuspensivoByNuDocumento(filter) {
      return efeitoSuspensivo.get({ numeroDocumento: filter }).$promise;
    }

    function findAllDividaAtivasByNuDocumento(nuDocumento, dePlaca) {
      return dividasAtivas.save({
        numeroDeDocumento: nuDocumento,
        dePlaca: dePlaca,
      }).$promise;
    }

    function findAllDividaAtivasEmProtestoByNuDocumento(nuDocumento, dePlaca) {
      return dividasAtivasEmProtesto.save({
        numeroDeDocumento: nuDocumento,
        dePlaca: dePlaca,
      }).$promise;
    }

    function findAllDividaAtivasEmProtestoEProtestadasByNuDocumento(
      nuDocumento,
      dePlaca
    ) {
      return dividasAtivasEmProtestoProtestado.save({
        numeroDeDocumento: nuDocumento,
        dePlaca: dePlaca,
      }).$promise;
    }

    function findAllDividaAtivasExecutadasByNuDocumento(nuDocumento, dePlaca) {
      return dividasExecutadas.save({
        numeroDeDocumento: nuDocumento,
        dePlaca: dePlaca,
      }).$promise;
    }

    function findAllDividasComEfeitoSuspensivo(nuDocumento, dePlaca) {
      var filterDTO = { numeroDeDocumento: nuDocumento, dePlaca: dePlaca };
      return efeitosSuspensivos.save(filterDTO).$promise;
    }

    function findGrupoServicoByChaveContaReceber(
      nuAnoContaReceber,
      nuContaReceber
    ) {
      var searchFilter = {
        nuAnoContaReceber: nuAnoContaReceber,
        nuContaReceber: nuContaReceber,
      };
      return grupoServico.save(searchFilter).$promise;
    }

    function printBoletoCartorio(nuDividaAtiva, cpfCnpj) {
      var deferred = $q.defer();
      $http
        .get(
          BACK_END_SID +
            "/api/dividaativa/dividas/protesto/cartorio/gerargru/" +
            nuDividaAtiva +
            "/" +
            cpfCnpj,
          { responseType: "arraybuffer" }
        )
        .success(function (data, status) {
          deferred.resolve({ status: status, data: data });
        })
        .error(function (data, status) {
          deferred.reject({ status: status, data: data });
        });
      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('cndFrontend')
    .service('RecService', RecService);

  function RecService($http, $q, BACK_END_REC, $resource) {

    var situacao = $resource(BACK_END_REC + '/api/contareceber/situacao/devedor');
    var contareceber = $resource(BACK_END_REC + '/api/contareceber/contas/devedor');
    var empresa = $resource(BACK_END_REC + '/api/empresa/find');
    var acordoJuridico = $resource(BACK_END_REC + '/api/acordojuridico/find');
    var acordoJuridicoDetalhes = $resource(BACK_END_REC + '/api/acordojuridico/find/detalhes');
    var acordoAdministrativo = $resource(BACK_END_REC + '/api/acordoadministrativo/find/list');
    var acordoAdministrativoDetalhes = $resource(BACK_END_REC + '/api/acordoadministrativo/find/detalhes');
    var agImposicaoFinal = $resource(BACK_END_REC + '/api/contareceber/contas/devedor/stc/aguardando-imposicao-final');
    var efeitosSuspensivos = $resource(BACK_END_REC + '/api/contareceber/contas/devedor/efeito-suspensivo');

    var findAllContasReceberPromisse = null;
    var findAllContasReceberFilter = null;
    var consultaSituacaoDoDevedorPromisse = null;
    var consultaSituacaoDoDevedorFilter = null;

    return {
      findAllContasReceber: findAllContasReceber,
      findAllAcordoJuridicos: findAllAcordoJuridicos,
      findDetalhesAcordoJuridico: findDetalhesAcordoJuridico,
      findAllAcordoAdministrativo: findAllAcordoAdministrativo,
      findAllContasComEfeitoSuspensivo: findAllContasComEfeitoSuspensivo,
      findAllContasAgImposicaoFinal: findAllContasAgImposicaoFinal,
      findDetalhesAcordoAdministrativo: findDetalhesAcordoAdministrativo,
      findDadosEmpresa: findDadosEmpresa,
      findSituacaoDoDevedor: findSituacaoDoDevedor,
      printCertidao: printCertidao,
      printExtratoDebito: printExtratoDebito
    };

    function findAllContasReceber(nuDocumento, dePlaca) {
      if (findAllContasReceberPromisse != null && findAllContasReceberFilter != null 
        && findAllContasReceberFilter.numeroDeDocumento === nuDocumento
        && findAllContasReceberFilter.dePlaca === dePlaca) {
        return findAllContasReceberPromisse;
      }
      var filterDTO = {
        numeroDeDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      findAllContasReceberFilter = filterDTO;
      findAllContasReceberPromisse = contareceber.save(filterDTO).$promise;
      return findAllContasReceberPromisse;
    }

    function findAllAcordoJuridicos(nuDocumento, dePlaca) {
      var filterDTO = {
        numeroDeDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      return acordoJuridico.save(filterDTO).$promise;
    }

    function findAllContasComEfeitoSuspensivo(nuDocumento, dePlaca) {
      var filterDTO = {
        numeroDeDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      return efeitosSuspensivos.save(filterDTO).$promise;
    }

    function findAllContasAgImposicaoFinal(nuDocumento, dePlaca) {
      var filterDTO = {
        numeroDeDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      return agImposicaoFinal.save(filterDTO).$promise;
    }

    function findDetalhesAcordoJuridico(filter) {
      return acordoJuridicoDetalhes.save(filter).$promise;
    }

    function findAllAcordoAdministrativo(nuDocumento, dePlaca) {
      var filterDTO = {
        nuDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      return acordoAdministrativo.save(filterDTO).$promise;
    }

    function findDetalhesAcordoAdministrativo(filter) {
      return acordoAdministrativoDetalhes.save(filter).$promise;
    }

    function findDadosEmpresa(filter) {
      return empresa.save(filter).$promise;
    }

    function findSituacaoDoDevedor(filter) {
      if (consultaSituacaoDoDevedorPromisse != null &&
        consultaSituacaoDoDevedorFilter != null && consultaSituacaoDoDevedorFilter.numeroDeDocumento === filter) {
        return consultaSituacaoDoDevedorPromisse;
      }
      var filterDTO = {
        numeroDeDocumento: filter
      };
      consultaSituacaoDoDevedorFilter = filterDTO;
      consultaSituacaoDoDevedorPromisse = situacao.save(filterDTO).$promise;
      return consultaSituacaoDoDevedorPromisse;
    }

    function printCertidao(filter) {
      var deferred = $q.defer();
      $http.post(BACK_END_REC + '/api/certidao/find/relatorio', filter, {
          responseType: 'arraybuffer'
        })
        .success(function (data, status) {
          deferred.resolve({
            status: status,
            data: data
          });
        })
        .error(function (data, status) {
          deferred.reject({
            status: status,
            data: data
          });
        });
      return deferred.promise;
    }

    function printExtratoDebito(data) {
      var deferred = $q.defer();
      $http.post(BACK_END_REC + '/api/extrato/debito/relatorio', data, {
          responseType: 'arraybuffer'
        })
        .success(function (data, status) {
          deferred.resolve({
            status: status,
            data: data
          });
        })
        .error(function (data, status) {
          deferred.reject({
            status: status,
            data: data
          });
        });
      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('cndFrontend')
    .service('ProtestoService', ProtestoService);

  function ProtestoService(BACK_END_PROTESTO, $resource,  $http) {

    var protestoCartorio = $resource(BACK_END_PROTESTO + '/api/dividaativa/dividas/protesto/cartorio/:numeroDA', {numeroDA:'@numeroDA'});
    
    return {
      findCartorioByDividaAtiva: findCartorioByDividaAtiva,
    };

    function findCartorioByDividaAtiva(filter) {

      return protestoCartorio.get({numeroDA : filter}).$promise;

      //var headers = {
      //  'consumerid': 'SIDERCND'  // Substitua o valor com o clientId que você deseja
      //};

     // return $http.get(BACK_END_PROTESTO + '/api/dividaativa/dividas/protesto/cartorio/' + filter, { headers: headers })
      //  .then(function(response) {
       //   return response.data;
       // });

    }

  }
})();

(function () {
  "use strict";

  angular.module("cndFrontend").service("GruService", GruService);

  function GruService($http, $q, BACK_END_GRU, $resource) {
    return {
      saveGru: saveGru,
      generatePaymentLink: generatePaymentLink,
      consultarPagamentoBBPay: consultarPagamentoBBPay,
      printBoleto: printBoleto,
    };

    function saveGru(filter) {
      var deferred = $q.defer();
      $http
        .post(BACK_END_GRU + "/api/gru/gerarRegistrada", filter, {
          transformResponse: function (dataText) {
            return dataText;
          },
        })
        .success(function (data, status) {
          deferred.resolve({ status: status, data: angular.fromJson(data) });
        })
        .error(function (messageError, status) {
          var data = { message: messageError };
          deferred.reject({ status: status, data: data });
        });
      return deferred.promise;
    }

    function generatePaymentLink(filter) {
      var deferred = $q.defer();
      $http
        .post(BACK_END_GRU + "/api/gru/bbpay/pagamentos/guia/cartao", filter, {
          transformResponse: function (dataText) {
            return dataText;
          },
        })
        .success(function (data, status) {
          deferred.resolve({ status: status, data: angular.fromJson(data) });
        })
        .error(function (messageError, status) {
          var data = { message: messageError };
          deferred.reject({ status: status, data: data });
        });
      return deferred.promise;
    }

    function consultarPagamentoBBPay(codigoSolicitacao) {
      var deferred = $q.defer();
      $http
        .get(BACK_END_GRU + "/api/gru/bbpay/pagamentos", {
          params: { codigoSolicitacao: codigoSolicitacao },
        })
        .success(function (data, status) {
          deferred.resolve({ status: status, data: data });
        })
        .error(function (data, status) {
          deferred.reject({ status: status, data: data });
        });
      return deferred.promise;
    }

    function printBoleto(filter) {
      var deferred = $q.defer();
      $http
        .post(BACK_END_GRU + "/api/boleto/emitir", filter, {
          responseType: "arraybuffer",
        })
        .success(function (data, status) {
          deferred.resolve({ status: status, data: data });
        })
        .error(function (data, status) {
          deferred.reject({ status: status, data: data });
        });
      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('cndFrontend')
    .service('CndService', CndService);

  function CndService(BACK_END_CND, $resource) {

    var inconsistenciaI = $resource(BACK_END_CND + '/api/inconsistencias/dividasExtintasComContaReceberExecutada');
    var inconsistenciaII = $resource(BACK_END_CND + '/api/inconsistencias/dividasQuitadasSemRegistroDaExtincao');
    var inconsistenciaIII = $resource(BACK_END_CND + '/api/inconsistencias/contasReceberQuitadasSemExtincaoDaDivida');
    var inconsistenciaIV = $resource(BACK_END_CND + '/api/inconsistencias/contasReceberAtivasComDividaExtinta');
    var inconsistenciaV = $resource(BACK_END_CND + '/api/inconsistencias/contasReceberParceladasComRecebimento');
    var inconsistenciaVI = $resource(BACK_END_CND + '/api/inconsistencias/contasReceberExecutadasComRecebimento');
    var inconsistenciaVII = $resource(BACK_END_CND + '/api/inconsistencias/contasReceberQuitadaSemRecebimento');
    var inconsistenciaVIII = $resource(BACK_END_CND + '/api/inconsistencias/contasReceberAtivasComDividaExecutada');
    var inconsistenciaIX = $resource(BACK_END_CND + '/api/inconsistencias/todasContasReceberQuitadasComDividaQuitadas');
    var notificacao = $resource(BACK_END_CND + '/api/inconsistencias/notificacaoDeInconsistencia');

    var consultaPessoa = $resource(BACK_END_CND + '/api/devedor/findPessoaByNuDocumentoOuDePlaca');
    var consultaSituacaoDevedor = $resource(BACK_END_CND + '/api/devedor/findSituacaoDoDevedor');

    return {
      dividasExtintasComContaReceberExecutada: dividasExtintasComContaReceberExecutada,
      dividasQuitadasSemRegistroDaExtincao: dividasQuitadasSemRegistroDaExtincao,
      contasReceberQuitadasSemExtincaoDaDivida: contasReceberQuitadasSemExtincaoDaDivida,
      contasReceberAtivasComDividaExtinta: contasReceberAtivasComDividaExtinta,
      contasReceberParceladasComRecebimento: contasReceberParceladasComRecebimento,
      contasReceberExecutadasComRecebimento: contasReceberExecutadasComRecebimento,
      contasReceberQuitadaSemRecebimento: contasReceberQuitadaSemRecebimento,
      contasReceberAtivasComDividaExecutada: contasReceberAtivasComDividaExecutada,
      contasReceberQuitadaComDividaQuitada: contasReceberQuitadaComDividaQuitada,
      notificacaoDeInconsistencia: notificacaoDeInconsistencia,
      findPessoaByNuDocumentoOuDePlaca: findPessoaByNuDocumentoOuDePlaca,
      findSituacaoDoDevedor: findSituacaoDoDevedor
    };

    function findPessoaByNuDocumentoOuDePlaca(nuDocumento, dePlaca) {
      var searchFilter = {
        nuDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      return consultaPessoa.save(searchFilter).$promise;
    }

    function findSituacaoDoDevedor(nuDocumento, dePlaca) {
      var searchFilter = {
        nuDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      return consultaSituacaoDevedor.save(searchFilter).$promise;
    }

    function dividasExtintasComContaReceberExecutada(nuDocumento, dePlaca) {
      var searchFilter = {
        nuDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      return inconsistenciaI.save(searchFilter).$promise;
    }

    function dividasQuitadasSemRegistroDaExtincao(nuDocumento, dePlaca) {
      var searchFilter = {
        nuDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      return inconsistenciaII.save(searchFilter).$promise;
    }

    function contasReceberQuitadasSemExtincaoDaDivida(nuDocumento, dePlaca) {
      var searchFilter = {
        nuDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      return inconsistenciaIII.save(searchFilter).$promise;
    }

    function contasReceberAtivasComDividaExtinta(nuDocumento, dePlaca) {
      var searchFilter = {
        nuDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      return inconsistenciaIV.save(searchFilter).$promise;
    }

    function contasReceberParceladasComRecebimento(nuDocumento, dePlaca) {
      var searchFilter = {
        nuDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      return inconsistenciaV.save(searchFilter).$promise;
    }

    function contasReceberExecutadasComRecebimento(nuDocumento, dePlaca) {
      var searchFilter = {
        nuDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      return inconsistenciaVI.save(searchFilter).$promise;
    }

    function contasReceberQuitadaSemRecebimento(nuDocumento, dePlaca) {
      var searchFilter = {
        nuDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      return inconsistenciaVII.save(searchFilter).$promise;
    }

    function contasReceberAtivasComDividaExecutada(nuDocumento, dePlaca) {
      var searchFilter = {
        nuDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      return inconsistenciaVIII.save(searchFilter).$promise;
    }
    
    function contasReceberQuitadaComDividaQuitada(nuDocumento, dePlaca) {
      var searchFilter = {
        nuDocumento: nuDocumento,
        dePlaca: dePlaca
      };
      return inconsistenciaIX.save(searchFilter).$promise;
    }

    function notificacaoDeInconsistencia(devedor, deEmail, deInconsistencias) {
      var searchFilter = {
        deNome: devedor.deNome,
        nuDocumento: devedor.nuDocumento,
        nuRegistro: devedor.nuRegistro,
        deEmail: deEmail,
        deInconsistencia: deInconsistencias
      };
      return notificacao.save(searchFilter).$promise;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('cndFrontend')
    .service('CdtService', CdtService);

  function CdtService($http, $q, BACK_END_CDT) {
    var findPessoaByNuDocumentoPromisse = null;
    var findPessoaByNuDocumentoFilter = null;

    return {
      findPessoaByNuDocumento: findPessoaByNuDocumento
    };

    function findPessoaByNuDocumento(filter) {
      if (findPessoaByNuDocumentoPromisse != null
        && findPessoaByNuDocumentoFilter != null && findPessoaByNuDocumentoFilter.nuDocumento === filter) {
        return findPessoaByNuDocumentoPromisse;
      }
      var filterDTO = {
        nuDocumento: filter,
        flEmuso: "S"
      };
      findPessoaByNuDocumentoFilter = filterDTO;
      var deferred = $q.defer();
      $http.post(BACK_END_CDT + '/api/pessoa/find', filterDTO, {
          transformResponse: function (dataText) {
            return dataText;
          }
        })
        .success(function (data, status) {
          deferred.resolve({status: status, data: angular.fromJson(data)});
        })
        .error(function (messageError, status) {
          var data = {message: messageError};
          deferred.reject({status: status, data: data});
        });
      findPessoaByNuDocumentoPromisse = deferred.promise;
      return findPessoaByNuDocumentoPromisse;
    }
  }
})();


(function() {
  'use strict';

  angular
    .module('cndFrontend')
    .run(['$location', '$window', '$rootScope', function($location, $window, $rootScope){
        $window.ga('create', 'UA-75928047-1', 'auto');
		
		$rootScope.$on('$stateChangeSuccess', 
        function(event, toState, toParams, fromState, fromParams, options){
			$window.ga('send', 'pageview', $location.path());
		});
	}]);
})();

(function () {
  "use strict";

  angular.module("cndFrontend").config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise("/");

    $stateProvider
      .state(RouterName.HOME, {
        url: "/",
        templateUrl: "app/view/search/search.html",
        controller: "SearchController",
        controllerAs: "searchController",
      })

      .state(RouterName.CARTORIO, {
        url: "/cartorio",
        templateUrl: "app/view/cartorio/emissaoGuia.html",
        controller: "EmissaoGuiaController",
        controllerAs: "emissaoGuiaController",
      })

      .state(RouterName.MAIN, {
        url: "/:nuDocumento/:nuRegistro/:dePlaca/main",
        templateUrl: "app/view/main/main.html",
        controller: "MainController",
        controllerAs: "mainController",
        resolve: {
          devedor: function (
            CndService,
            $stateParams,
            ngMessageCenter,
            $filter,
            $state
          ) {
            return CndService.findPessoaByNuDocumentoOuDePlaca(
              $stateParams.nuDocumento,
              $stateParams.dePlaca
            )
              .then(function (data) {
                data.dePlaca = $stateParams.dePlaca;
                return data;
              })
              .catch(function (fallback) {
                ngMessageCenter.warning({
                  timeout: 12000,
                  title: "Atenção!",
                  text:
                    HttpCode.BAD_REQUEST === fallback.status
                      ? fallback.data
                      : __montaMensagemDeErro($filter, fallback),
                  name: "searchMessages",
                });
                angular.element("#search-button").button("reset");
                $state.go(RouterName.HOME);
              });
          },
          situacao: function (
            CndService,
            $stateParams,
            $state,
            ngMessageCenter
          ) {
            return CndService.findSituacaoDoDevedor(
              $stateParams.nuDocumento,
              $stateParams.dePlaca
            ).then(function (data) {
              if (!!$stateParams.dePlaca && data.situacao === "Negativo") {
                ngMessageCenter.warning({
                  timeout: 12000,
                  title: "Atenção!",
                  text: "Não foram encontrados registros para a consulta.",
                  name: "searchMessages",
                });
                angular.element("#search-button").button("reset");
                $state.go(RouterName.HOME);
              }
              //debitos e consulta por placa
              else if (!!$stateParams.dePlaca && data.situacao !== "Negativo") {
                $state.go(RouterName.EXTRATO, {
                  nuDocumento: undefined,
                  dePlaca: $stateParams.dePlaca,
                  nuRegistro: $stateParams.nuRegistro,
                });
              } else {
                return data;
              }
            });
          },
          registro: function (RecService, $stateParams) {
            if (
              $stateParams.nuRegistro === "" &&
              $stateParams.nuDocumento !== ""
            ) {
              var documentoFilter = { nuDocumento: $stateParams.nuDocumento };
              return RecService.findDadosEmpresa(documentoFilter).then(
                function (data) {
                  return data;
                }
              );
            }
          },
        },
      })

      .state(RouterName.EXTRATO, {
        url: "/:nuDocumento/:dePlaca/:nuRegistro/extrato",
        params: {
          devedor: null,
          tabSelected: 1,
        },
        templateUrl: "app/view/extrato/extrato.html",
        controller: "ExtratoController",
        controllerAs: "extratoController",
        resolve: {
          contas: function (RecService, $stateParams) {
            return RecService.findAllContasReceber(
              $stateParams.nuDocumento,
              $stateParams.dePlaca
            ).then(function (data) {
              return data;
            });
          },
          dividas: function (SidService, $stateParams) {
            return SidService.findAllDividaAtivasByNuDocumento(
              $stateParams.nuDocumento,
              $stateParams.dePlaca
            ).then(function (data) {
              return data;
            });
          },
          dividasEmProtestoEProtestada: function (SidService, $stateParams) {
            return SidService.findAllDividaAtivasEmProtestoEProtestadasByNuDocumento(
              $stateParams.nuDocumento,
              $stateParams.dePlaca
            ).then(function (data) {
              return data;
            });
          },
          dividasExecutadas: function (SidService, $stateParams) {
            return SidService.findAllDividaAtivasExecutadasByNuDocumento(
              $stateParams.nuDocumento,
              $stateParams.dePlaca
            ).then(function (data) {
              return data;
            });
          },
          acordosAdministrativos: function (RecService, $stateParams) {
            return RecService.findAllAcordoAdministrativo(
              $stateParams.nuDocumento,
              $stateParams.dePlaca
            ).then(function (data) {
              return data;
            });
          },
          acordosJuridicos: function (RecService, $stateParams) {
            return RecService.findAllAcordoJuridicos(
              $stateParams.nuDocumento,
              $stateParams.dePlaca
            ).then(function (data) {
              return data;
            });
          },
          contasComEfeitoSuspensivo: function (RecService, $stateParams) {
            return RecService.findAllContasComEfeitoSuspensivo(
              $stateParams.nuDocumento,
              $stateParams.dePlaca
            ).then(function (data) {
              return data;
            });
          },
          dividasComEfeitoSuspensivo: function (SidService, $stateParams) {
            return SidService.findAllDividasComEfeitoSuspensivo(
              $stateParams.nuDocumento,
              $stateParams.dePlaca
            ).then(function (data) {
              return data;
            });
          },
          contasAgImposicaoFinal: function (RecService, $stateParams) {
            return RecService.findAllContasAgImposicaoFinal(
              $stateParams.nuDocumento,
              $stateParams.dePlaca
            ).then(function (data) {
              return data;
            });
          },
        },
      })

      .state(RouterName.EFEITOSUSPENSIVO, {
        url: "efeitosuspensivo",
        params: {
          devedor: null,
          contasComEfeitoSuspensivo: null,
          dividasComEfeitoSuspensivo: null,
        },
        templateUrl: "app/view/efeitosuspensivo/efeitoSuspensivo.tpl.html",
        controller: "EfeitoSuspensivoController",
        controllerAs: "efeitoSuspensivoController",
      })

      .state(RouterName.AGIMPOSICAOFINAL, {
        url: "agimposicaofinal",
        params: {
          devedor: null,
          contasAgImposicaoFinal: null,
        },
        templateUrl: "app/view/agimposicaofinal/agImposicaoFinal.tpl.html",
        controller: "AgImposicaoFinalController",
        controllerAs: "agImposicaoFinalController",
      })

      .state(RouterName.ACORDOJURIDICO, {
        url: "acordojuridico/:nuAnoContaReceber/:nuContaReceber",
        params: {
          devedor: null,
        },
        templateUrl: "app/view/acordo/acordoJuridico.tpl.html",
        controller: "AcordoJuridicoController",
        controllerAs: "acordoJuridicoController",
        resolve: {
          detalhesAcordoJuridico: function (RecService, $stateParams) {
            var filter = {
              nuAnoContaReceber: $stateParams.nuAnoContaReceber,
              nuContaReceber: $stateParams.nuContaReceber,
            };
            return RecService.findDetalhesAcordoJuridico(filter).then(
              function (data) {
                return data;
              }
            );
          },
        },
      })

      .state(RouterName.ACORDOADMINISTRATIVO, {
        url: "acordoadministrativo/:nuAnoContaReceber/:nuContaReceber",
        params: {
          devedor: null,
        },
        templateUrl: "app/view/acordo/acordoAdministrativo.tpl.html",
        controller: "AcordoAdministrativoController",
        controllerAs: "acordoAdministrativoController",
        resolve: {
          detalhesAcordoAdministrativo: function (RecService, $stateParams) {
            var filter = {
              nuAnoContaReceber: $stateParams.nuAnoContaReceber,
              nuContaReceber: $stateParams.nuContaReceber,
            };
            return RecService.findDetalhesAcordoAdministrativo(filter).then(
              function (data) {
                return data;
              }
            );
          },
        },
      });
  }
})();


/* global malarkey:false, moment:false 


####### ESTA VERSÃO É PARA USO EM LOCALHOST ########
(function() {
  'use strict';

  angular
    .module('cndFrontend')
    .constant('malarkey', malarkey)
    .constant('BACK_END_CDT', getBaseUrl() + '/cdt-pessoa')
    .constant('BACK_END_REC', getBaseUrl()+ '/rec-services')
    .constant('BACK_END_SID', getBaseUrl()+ '/sid-services')
    .constant('BACK_END_GRU', getBaseUrl()+ '/gru-services')
    .constant('BACK_END_CND', getBaseUrl()+ '/cnd-services')
    .constant('moment', moment)
    .constant('BACK_END_PROTESTO',getBaseUrl()+'/sid-services')
    .constant('CHAT_BOT', 'CHAT_BOT_KEY')
    .constant('BB_PAY_ENABLED', 'BB_PAY_ENABLED_FLAG')
    .constant('RECAPTCHA_KEY_SITE', 'RECAPTCHA_KEY_SITE_FLAG'); // mantis 122566 adicionado no desenv do Welligton

})();


 
function getBaseUrl() {
  var environment = window.location.hostname; // Pode pegar o hostname do servidor ou de onde o app está sendo executado.

  return 'https://homolog.sider.der.pr.gov.br';

  if (environment.includes('preproducao')) {
    return 'https://www.preproducao.com.br';
  } else if (environment === 'www.producao.com.br') {
    return 'https://www.producao.com.br';
  } else {
    return 'http://localhost:8081'; // URL de desenvolvimento
  }
}
*/




//**** VERSÃO PARA TODOS AMBIENTES  ***********/
/* global malarkey:false, moment:false */

(function() {
  'use strict';

  angular
    .module('cndFrontend')
    .constant('malarkey', malarkey)
    .constant('BACK_END_CDT', '/cdt-pessoa')
    .constant('BACK_END_REC', '/rec-services')
    .constant('BACK_END_SID', '/sid-services')
    .constant('BACK_END_GRU', '/gru-services')
    .constant('BACK_END_CND', '/cnd-services')
    .constant('moment', moment)
    .constant('BACK_END_PROTESTO','/sid-services')
    .constant('CHAT_BOT', 'CHAT_BOT_KEY')
    .constant('BB_PAY_ENABLED', 'BB_PAY_ENABLED_FLAG')
    .constant('RECAPTCHA_KEY_SITE', 'RECAPTCHA_KEY_SITE_FLAG'); // mantis 122566 adicionado no desenv do Welligton;
})();



/**********************************************************************
  NA VERSÃO PARA TAG ESTA FUNÇÃO DEVE FICAR COMENTADA
  *********************************************************************

function getBaseUrl() {
  var environment = window.location.hostname; // Pode pegar o hostname do servidor ou de onde o app está sendo executado.

  return 'https://homolog.sider.der.pr.gov.br';

  if (environment.includes('preproducao')) {
    return 'https://www.preproducao.com.br';
  } else if (environment === 'www.producao.com.br') {
    return 'https://www.producao.com.br';
  } else {
    return 'http://localhost:8081'; // URL de desenvolvimento
  }
*/

var RouterName = {
  HOME: "cnd",
  MAIN: "main",
  CARTORIO: "cartorio",
  EXTRATO: "extrato",
  ACORDOJURIDICO: "extrato.acordojuridico",
  ACORDOADMINISTRATIVO: "extrato.acordoadministrativo",
  EFEITOSUSPENSIVO: "extrato.efeitosuspensivo",
  AGIMPOSICAOFINAL: "extrato.agimposicaofinal",
};

var UNIDADES_FEDERAIS = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];

var tabCode = {
  TAB_EXTRATO: 1,
  TAB_ACORDO_ADMINISTRATIVO: 2,
  TAB_ACORDO_JURIDICO: 3,
  TAB_EFEITO_SUSPENSIVO: 4,
  TAB_AG_IMPOSICAO_FINAL: 5,
  TAB_PROTESTO: 6,
};

var TipoPessoa = {
  FISICA: "F",
  JURIDICA: "J",
};

var HttpCode = {
  OK: 200,
  BAD_REQUEST: 400,
  NOT_FOUND: 404,
  SERVICE_UNAVAILABLE: 503,
  SERVER_ERROR: 500,
};

var FilterType = {
  CNPJ: "cnpj",
  CPF: "cpf",
  REGISTRO: "registro",
  PLACA: "placa",
};

var Situacao = {
  NEGATIVO: "negativo",
  POSITIVO: "positivo",
  POSITIVO_NEGATIVO: "positivo com efeito negativo",
};

var Certidao = {
  NEGATIVA: 1,
  POSITIVA: 2,
  POSITIVA_NEGATIVA: 3,
};

var CodigoTipoDivida = {
  MTM: 6,
  STC: 1,
};

var TipoBoleto = {
  SACADO_DETALHADO_DERPR: 3,
};

var TipoCampoObservacaoBoleto = {
  CAMPO_OBSERVACAO_DERPR: 2,
};

var CodigoTipoReceita = {
  MTM: 1919990001,
  STC: 1919280001,
};

angular.module("cndFrontend").config(config);

/** @ngInject */
function config(
  $locationProvider,
  $translateProvider,
  $logProvider,
  toastrConfig
) {
  $locationProvider.hashPrefix();

  $translateProvider.useStaticFilesLoader({
    prefix: "app/components/i18n/locale-",
    suffix: ".json",
  });

  $translateProvider.preferredLanguage("pt-BR");
  $translateProvider.fallbackLanguage("pt-BR");
  $translateProvider.useSanitizeValueStrategy("escapeParameters");

  //Enable log
  $logProvider.debugEnabled(true);

  //Set options third-party lib
  toastrConfig.allowHtml = true;
  toastrConfig.timeOut = 6000;
  toastrConfig.positionClass = "toast-top-right";
  toastrConfig.preventDuplicates = false;
  toastrConfig.progressBar = true;
  toastrConfig.closeButton = true;
}

(function (CHAT_BOT) {

    angular
        .module('cndFrontend')
        .config(config);

    function config(CHAT_BOT) {
        
        window.onload = function () {
            var blipChat = new BlipChat()
                .withAppKey(CHAT_BOT)
                .withButton({ "color": "#438f6c", "icon": "" })
                .withEventHandler(BlipChat.ENTER_EVENT, hideBubble)
                .withCustomCommonUrl('https://chat.blip.ai/')
                .build();
        }
        function hideBubble() {
            document.getElementById("bubble-container").style.display = 'none';
        }
    }

})();
angular.module("cndFrontend").run(["$templateCache", function($templateCache) {$templateCache.put("app/view/acordo/acordoAdministrativo.tpl.html","<div ng-init=\"extratoController.tab=2\" role=\"tabpanel\" class=\"tab-pane acordoAdm\" id=\"acordoAdmdetail\" ng-class=\"{\'active\' : extratoController.tab==2}\"><div class=\"titulo\">Acordo Administrativo</div><p>Número da conta a receber: <b>{{acordoAdministrativoController.nuContaReceber}}</b> | Ano da conta a receber: <b>{{acordoAdministrativoController.nuAnoContaReceber}}</b></p><table class=\"table table-striped\"><thead><tr><th>Parcela</th><th>Vencimento</th><th>Valor(R$)</th><th>GRU</th><th>Ano GRU</th><th>Pagamento</th></tr></thead><tbody><tr ng-repeat=\"detalheAcordo in acordoAdministrativoController.detalhesAcordoAdministrativo\"><td>{{detalheAcordo.nuParcelamento | ifEmpty: \"-\"}}</td><td>{{detalheAcordo.dtVencimento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td><td>{{detalheAcordo.vlParcela | number:2 | ifEmpty: \"-\"}}</td><td>{{detalheAcordo.nuGru | ifEmpty: \"-\"}}</td><td>{{detalheAcordo.nuAnoGru | ifEmpty: \"-\"}}</td><td>{{detalheAcordo.dtPagamento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td></tr></tbody></table><div class=\"extratoDebito clearfix\"><div class=\"extratoDebitoMinifyHeader\"><div class=\"column col2\"><span>Vencimento</span></div><div class=\"column col3\"><span>Valor(R$)</span></div><div class=\"column col4\"><span>GRU</span></div><div class=\"column col5\"></div></div><div ng-repeat=\"detalheAcordo in acordoAdministrativoController.detalhesAcordoAdministrativo\"><div class=\"extratoDebitoMinify\" ng-click=\"debito.isCollapsedExtratoAcordo = !debito.isCollapsedExtratoAcordo\"><div class=\"column col2\"><h4>{{detalheAcordo.dtVencimento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</h4></div><div class=\"column col3\"><h4>{{detalheAcordo.vlParcela | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"column col4\"><h4>{{detalheAcordo.nuGru | ifEmpty: \"-\"}}</h4></div><div class=\"column col5\"><a role=\"button\" data-toggle=\"collapse\" title=\"Mais detalhes\" aria-expanded=\"false\" aria-controls=\"viewExtratoDebitoAcordo\"><i class=\"fa fa-plus-circle\" ng-show=\"!debito.isCollapsedExtratoAcordo\" id=\"acordoadm-more-detail\"></i> <i class=\"fa fa-minus-circle\" ng-show=\"debito.isCollapsedExtratoAcordo\"></i></a></div></div><div class=\"collapse\" id=\"viewExtratoDebitoAcordoDetail\" collapse=\"!debito.isCollapsedExtratoAcordo\"><div class=\"extrato-detail clearfix\"><div class=\"col-sm-6 col-xs-6\"><span>Parcela</span><h4>{{detalheAcordo.nuParcelamento | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Ano GRU</span><h4>{{detalheAcordo.nuAnoGru | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Pagamento</span><h4>{{detalheAcordo.dtPagamento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</h4></div></div></div></div></div></div>");
$templateCache.put("app/view/acordo/acordoJuridico.tpl.html","<div ng-init=\"extratoController.tab=3\" role=\"tabpanel\" class=\"tab-pane acordoJur\" id=\"acordoJurdetail\" ng-class=\"{\'active\' : extratoController.tab==3}\"><div class=\"titulo\">Acordo Jurídico</div><p>Número da conta a receber: <b>{{acordoJuridicoController.nuContaReceber}}</b> | Ano da conta a receber: <b>{{acordoJuridicoController.nuAnoContaReceber}}</b></p><table class=\"table table-striped\"><thead><tr><th>Parcela</th><th>Vencimento</th><th>Valor(R$)</th><th>Multa(%)</th><th>Total (R$)</th><th>GRU</th><th>Ano GRU</th><th>Pagamento</th></tr></thead><tbody><tr ng-repeat=\"detalheAcordo in acordoJuridicoController.detalhesAcordoJuridico\"><td>{{detalheAcordo.nuParcelamento | ifEmpty: \"-\"}}</td><td>{{detalheAcordo.dtVencimento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td><td>{{detalheAcordo.vlParcela | number:2 | ifEmpty: \"-\"}}</td><td>{{detalheAcordo.vlMulta | ifEmpty: \"-\"}}</td><td>{{detalheAcordo.vlTotal | number:2 | ifEmpty: \"-\"}}</td><td>{{detalheAcordo.nuGru | ifEmpty: \"-\"}}</td><td>{{detalheAcordo.nuAnoGru | ifEmpty: \"-\"}}</td><td>{{detalheAcordo.dtPagamento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td></tr></tbody></table><div class=\"extratoDebito clearfix\"><div class=\"extratoDebitoMinifyHeader\"><div class=\"column col2\"><span>Vencimento</span></div><div class=\"column col3\"><span>Valor(R$)</span></div><div class=\"column col4\"><span>GRU</span></div><div class=\"column col5\"></div></div><div ng-repeat=\"detalheAcordo in acordoJuridicoController.detalhesAcordoJuridico\"><div class=\"extratoDebitoMinify\" ng-click=\"debito.isCollapsedExtratoAcordo = !debito.isCollapsedExtratoAcordo\"><div class=\"column col2\"><h4>{{detalheAcordo.dtVencimento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</h4></div><div class=\"column col3\"><h4>{{detalheAcordo.vlParcela | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"column col4\"><h4>{{detalheAcordo.nuGru | ifEmpty: \"-\"}}</h4></div><div class=\"column col5\"><a role=\"button\" data-toggle=\"collapse\" title=\"Mais detalhes\" aria-expanded=\"false\" aria-controls=\"viewExtratoDebitoAcordo\"><i class=\"fa fa-plus-circle\" ng-show=\"!debito.isCollapsedExtratoAcordo\" id=\"acordojur-more-detail\"></i> <i class=\"fa fa-minus-circle\" ng-show=\"debito.isCollapsedExtratoAcordo\"></i></a></div></div><div class=\"collapse\" id=\"viewExtratoDebitoAcordoDetail\" collapse=\"!debito.isCollapsedExtratoAcordo\"><div class=\"extrato-detail clearfix\"><div class=\"col-sm-6 col-xs-6\"><span>Parcela</span><h4>{{detalheAcordo.nuParcelamento | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Multa</span><h4>{{detalheAcordo.vlMulta | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Total</span><h4>{{detalheAcordo.vlTotal | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Ano GRU</span><h4>{{detalheAcordo.nuAnoGru | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Pagamento</span><h4>{{detalheAcordo.dtPagamento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</h4></div></div></div></div></div></div>");
$templateCache.put("app/view/agimposicaofinal/agImposicaoFinal.tpl.html","<div ng-init=\"extratoController.tab=5\" role=\"tabpanel\" class=\"tab-pane agImpFinal\" id=\"agImpFinal\" ng-class=\"{\'active\' : extratoController.tab==5}\"><div class=\"titulo\">Débitos aguardando imposição final</div><div ng-if=\"!agImposicaoFinalController.debitosAgImposicaoFinal.length > 0\"><div class=\"empty-state-no-doc\"><img src=\"assets/images/empty-state--no-doc.png\"></div><div class=\"not-found\">Nada consta.</div></div><div class=\"content-aguardando-imposicao-final\" ng-if=\"agImposicaoFinalController.debitosAgImposicaoFinal.length > 0\"><table class=\"table table-striped\"><thead><tr><th><label><input type=\"checkbox\" name=\"checkbox\" ng-model=\"agImposicaoFinalController.selectedAll\" ng-click=\"agImposicaoFinalController.checkAll()\"></label></th><th>Código do órgão</th><th>Descrição do débito</th><th>Número do auto/Placa</th><th>Tipo de infração</th><th>Número da CR/Ano da CR</th><th>Número da Parcela</th><th>Valor original (R$)</th><th>Data da infração/Documento</th><th>Início da atualização</th><th>Valor atualizado (R$)</th></tr></thead><tbody><tr ng-repeat=\"debito in agImposicaoFinalController.debitosAgImposicaoFinal\"><td><label><input type=\"checkbox\" name=\"checkbox\" id=\"checkbox\" ng-model=\"debito.selected\" ng-click=\"agImposicaoFinalController.atualizaValorSelecionado(debito)\"></label></td><td>{{debito.cdOrgao | ifEmpty: \"-\"}}</td><td>{{debito.descricao | ifEmpty: \"-\"}}</td><td ng-if=\"agImposicaoFinalController.isDebitoFromMulta(debito.cdTipoDivida, debito.nuTipoReceita)\" ng-click=\"viewDebitoDetailDialog.open(debito)\"><div title=\"Mais informações\" style=\"width: 100%; display: table;\"><div style=\"display: table-row\"><div style=\"float: left; padding-top:1%; width: 60%;\">{{debito.autoEplaca | ifEmpty: \"-\"}}</div><div class=\"btn-help-extrato\"><i id=\"agimpfinal-more-info\" class=\"fa fa-info-circle btn-help\"></i></div></div></div></td><td ng-if=\"!agImposicaoFinalController.isDebitoFromMulta(debito.cdTipoDivida, debito.nuTipoReceita)\">{{debito.autoEplaca | ifEmpty: \"-\"}}</td><td title=\"{{debito.deInfracao}}\">{{debito.deTipoInfracao | ifEmpty: \"-\"}}</td><td>{{debito.anoEnumeroCR | ifEmpty: \"-\"}}</td><td>{{debito.nuParcela | ifEmpty: \"-\"}}</td><td>{{debito.vlOriginal | number:2 | ifEmpty: \"-\"}}</td><td>{{debito.dtInfracaoDocumento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td><td>{{debito.dtInicioAtualizacao | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td><td>{{debito.vlAtualizadoComJuros | number:2 | ifEmpty: \"-\"}}</td></tr></tbody></table><div class=\"extratoDebito clearfix\"><div class=\"extratoDebitoMinifyHeader\"><div class=\"column col1\"><label><input type=\"checkbox\" name=\"checkbox\" ng-model=\"agImposicaoFinalController.selectedAll\" ng-click=\"agImposicaoFinalController.checkAll()\"></label></div><div class=\"column col2\"><span>Número do auto/Placa</span></div><div class=\"column col3\"><span>Data da infração/Documento</span></div><div class=\"column col4\"><span>Valor atualizado (R$)</span></div><div class=\"column col5\"></div></div><div ng-repeat=\"debito in agImposicaoFinalController.debitosAgImposicaoFinal\"><div class=\"extratoDebitoMinify\"><div class=\"column col1\"><label><input type=\"checkbox\" name=\"checkbox\" ng-model=\"debito.selected\" ng-click=\"agImposicaoFinalController.atualizaValorSelecionado(debito)\"></label></div><div class=\"column col2\"><h4>{{debito.autoEplaca | ifEmpty: \"-\"}}</h4></div><div class=\"column col3\"><h4>{{debito.dtInfracaoDocumento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</h4></div><div class=\"column col4\"><h4>{{debito.vlAtualizadoComJuros | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"column col5\"><a role=\"button\" data-toggle=\"collapse\" title=\"Mais detalhes\" ng-click=\"debito.isCollapsedExtrato = !debito.isCollapsedExtrato\" aria-expanded=\"false\" aria-controls=\"viewExtratoDebito\"><i class=\"fa fa-plus-circle\" ng-show=\"!debito.isCollapsedExtrato\" id=\"agimpfinal-more-detail\"></i> <i class=\"fa fa-minus-circle\" ng-show=\"debito.isCollapsedExtrato\"></i></a></div></div><div class=\"collapse\" id=\"viewExtratoDebito\" collapse=\"!debito.isCollapsedExtrato\"><div class=\"extrato-detail clearfix\"><div class=\"col-sm-6 col-xs-6\"><span>Tipo de infração</span><h4 title=\"{{debito.deInfracao}}\">{{debito.deTipoInfracao | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Código do órgão</span><h4>{{debito.cdOrgao | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\" ng-if=\"agImposicaoFinalController.isDebitoFromMulta(debito.cdTipoDivida, debito.nuTipoReceita)\" ng-click=\"viewDebitoDetailDialog.open(debito)\" title=\"Mais informações\"><span>Descrição do débito</span><div style=\"display: flex; align-items: center\"><div><h4>{{debito.descricao | ifEmpty: \"-\"}}</h4></div><div style=\"padding-left: 5%; padding-bottom: 4%\"><div class=\"btn-help-extrato\"><i id=\"agimpfinal-more-info-minify\" class=\"col2 fa fa-info-circle btn-help\"></i></div></div></div></div><div class=\"col-sm-6 col-xs-6\"><span>Número da CR/Ano da CR</span><h4>{{debito.anoEnumeroCR | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Número da Parcela</span><h4>{{debito.nuParcela | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Valor original (R$)</span><h4>{{debito.vlOriginal | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Início da atualização</span><h4>{{debito.dtInicioAtualizacao | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</h4></div></div></div></div></div><div class=\"clearfix content-value\"><div class=\"alert alert-success emissao-guia\"><div><span>Valor total selecionado:</span><h3><span>R$</span> {{agImposicaoFinalController.vlTotalSelecionado | number:2 | ifEmpty: \"-\"}}</h3></div><a id=\"btn-agimpfinal-modal-gerar-guia-address\" role=\"button\" class=\"btn btn-primary\" ng-click=\"extratoController.openModal(agImposicaoFinalController.debitosAgImposicaoFinal)\">Gerar Guia</a></div><div class=\"alert alert-danger debitos\"><span>Total geral do valor atualizado:</span><h3><span>R$</span> {{agImposicaoFinalController.vlTotalAtualizadoComJuros | number:2 | ifEmpty: \"-\"}}</h3></div></div></div></div>");
$templateCache.put("app/view/content/content-app-extrato.tpl.html","<div class=\"data-search clearfix\"><div class=\"data-search-content\"><div class=\"data-search-container-razao-social\"><div class=\"info-data-search empresa\"><div class=\"label-field-data-search\">Razão Social</div><div class=\"field-data-search\">PEDREIRA TAQUARUCU LTDA</div></div><a data-toggle=\"collapse\" class=\"btn-mais-info\" href=\"#maisInfo\" aria-expanded=\"false\" aria-controls=\"maisInfo\"><i class=\"fa fa-plus-circle\"></i></a></div><div class=\"data-search-container-cnpj\"><div class=\"info-data-search cnpj\"><div class=\"label-field-data-search\">CNPJ</div><div class=\"field-data-search\">44.873.420/0001-58 (Matriz)</div></div></div><div class=\"data-search-container-registro\"><div class=\"info-data-search registro\"><div class=\"label-field-data-search\">Registro</div><div class=\"field-data-search\">-</div></div></div><div class=\"data-search-container-endereco\"><div class=\"info-data-search endereco\"><div class=\"label-field-data-search\">Endereço</div><div class=\"field-data-search\">Rua Bairro do Ovídio s/n</div></div></div><div class=\"clearfix\"></div></div><div class=\"collapse content-mais-info\" id=\"maisInfo\"><div class=\"container-mais-info\"><div class=\"cnpj\"><span class=\"label-cnpj\">CNPJ:</span> <span class=\"data-cnpj\">44.873.420/0001-58 (Matriz)</span></div><div class=\"registro\"><span class=\"label-registro\">Registro:</span> <span class=\"data-registro\">-</span></div><div class=\"endereco\"><span class=\"label-endereco\">Endereço:</span> <span class=\"data-endereco\">Rua Bairro do Ovídio s/n</span></div></div></div></div><div class=\"content-extrato\"><div class=\"content-nav-tabs\"><ul class=\"nav nav-tabs\" role=\"tablist\"><li role=\"presentation\" class=\"active extrato-debito\"><a href=\"#extratoDebito\" aria-controls=\"extratoDebito\" role=\"tab\" data-toggle=\"tab\">Extrato de Débito</a></li><li role=\"presentation\" class=\"acordo-adm\"><a href=\"#acordoAdm\" aria-controls=\"acordoAdm\" role=\"tab\" data-toggle=\"tab\">Acordo Adm. (Deliberação 88/2011)</a></li><li role=\"presentation\" class=\"acordo-jur\"><a href=\"#acordoJur\" aria-controls=\"acordoJur\" role=\"tab\" data-toggle=\"tab\">Acordos Jurídicos</a></li></ul></div><div class=\"tab-content\"><div role=\"tabpanel\" class=\"tab-pane extratoDebito active\" id=\"extratoDebito\"><div class=\"titulo\">Débitos aguardando a execução fiscal</div><table class=\"table table-striped\"><thead><tr><th><label><input type=\"checkbox\" name=\"checkbox\"></label></th><th>Código do órgão</th><th>Descrição do débito</th><th>Número do auto/Placa</th><th>Número da CR/Ano da CR</th><th>Número da Parcela</th><th>Valor original (R$)</th><th>Data da infração/Documento</th><th>Início da atualização</th><th>Valor atualizado (R$)</th></tr></thead><tbody><tr><td><label><input type=\"checkbox\" name=\"checkbox\" id=\"checkbox\"></label></td><td>116200</td><td>Multas de Trânsito</td><td>R040000106/AHG7848</td><td>91155/2010</td><td>1</td><td>3.809,13</td><td>15/12/2009</td><td>10/03/2011</td><td>5.614,28</td></tr></tbody></table><div class=\"extratoDebito clearfix\"><div class=\"extratoDebitoMinifyHeader\"><div class=\"column col1\"><label><input type=\"checkbox\" name=\"checkbox\"></label></div><div class=\"column col2\"><span>Número do auto/Placa</span></div><div class=\"column col3\"><span>Data da infração/Documento</span></div><div class=\"column col4\"><span>Valor atualizado (R$)</span></div><div class=\"column col5\"></div></div><div class=\"extratoDebitoMinify\"><div class=\"column col1\"><label><input type=\"checkbox\" name=\"checkbox\"></label></div><div class=\"column col2\"><h4>R040000106/AHG7848</h4></div><div class=\"column col3\"><h4>15/12/2009</h4></div><div class=\"column col4\"><h4>5.614,28</h4></div><div class=\"column col5\"><a role=\"button\" data-toggle=\"collapse\" title=\"Mais detalhes\" href=\"#viewExtratoDebito\" aria-expanded=\"false\" aria-controls=\"viewExtratoDebito\"><i class=\"fa fa-plus-circle\"></i></a></div></div><div class=\"collapse\" id=\"viewExtratoDebito\"><div class=\"extrato-detail clearfix\"><div class=\"col-sm-6 col-xs-6\"><span>Código do órgão</span><h4>116200</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Descrição do débito</span><h4>Multa de trânsito</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Número da CR/Ano da CR</span><h4>91155/2010</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Número da Parcela</span><h4>1</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Valor original (R$)</span><h4>3.809,13</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Início da atualização</span><h4>10/03/2011</h4></div></div></div></div><div class=\"clearfix content-value\"><div class=\"alert alert-success emissao-guia\"><div><span>Valor total selecionado:</span><h3>R$ 00,00</h3></div><button role=\"button\" class=\"btn btn-primary\">Gerar Guia</button></div><div class=\"alert alert-danger debitos\"><span>Total geral do valor atualizado:</span><h3>R$ 5.614,28</h3></div></div></div><div role=\"tabpanel\" class=\"tab-pane acordoAdm\" id=\"acordoAdm\"><div class=\"titulo\">Acordo Admministrativo (Deliberação 88/2011)</div><p>Não há</p></div><div role=\"tabpanel\" class=\"tab-pane acordoJur\" id=\"acordoJur\"><div class=\"titulo\">Acordo Jurídico</div><p>Não há</p></div></div><div class=\"alert alert-warning\" role=\"alert\"><p>Observações:</p><ul><li>A baixa do Débito será realizada com base em informações transmitidas pelo banco onde foi feito o pagamento;</li><li>Esta baixa pode demorar <b>até 24 horas</b>, se o pagamento for efetuado <b>de segunda à quinta-feira (exceto feriados)</b> e <b>até 96 horas</b> se o pagamento for efetuado no <b>final de semana com feriado prolongado</b>;</li><li>O envio do comprovante de pagamento ao DER não agilizará este processo, pois a liberação só é feita de forma automática.</li></ul></div><div class=\"tools-btn\"><button class=\"btn btn-default\" onclick=\"imprimir()\"><i class=\"fa fa-print fa-fw\"></i> <span class=\"hidden-xs\">Imprimir</span></button> <button class=\"btn btn-default\" onclick=\"window.location.href=\'main.html\'\"><i class=\"fa fa-chevron-left fa-fw\"></i> <span class=\"hidden-xs\">Voltar</span></button></div></div><script>\n  function imprimir() {\n    window.print();\n  }\n</script>");
$templateCache.put("app/view/content/content-app.tpl.html","<div class=\"data-search clearfix\"><div class=\"data-search-content\"><div class=\"data-search-container-razao-social\"><div class=\"info-data-search empresa\"><div class=\"label-field-data-search\">Razão Social</div><div class=\"field-data-search\">PEDREIRA TAQUARUCU LTDA</div></div><a data-toggle=\"collapse\" class=\"btn-mais-info\" href=\"#maisInfo\" aria-expanded=\"false\" aria-controls=\"maisInfo\"><i class=\"fa fa-plus-circle\"></i></a></div><div class=\"data-search-container-cnpj\"><div class=\"info-data-search cnpj\"><div class=\"label-field-data-search\">CNPJ</div><div class=\"field-data-search\">44.873.420/0001-58 (Matriz)</div></div></div><div class=\"data-search-container-registro\"><div class=\"info-data-search registro\"><div class=\"label-field-data-search\">Registro</div><div class=\"field-data-search\">-</div></div></div><div class=\"data-search-container-endereco\"><div class=\"info-data-search endereco\"><div class=\"label-field-data-search\">Endereço</div><div class=\"field-data-search\">Rua Bairro do Ovídio s/n</div></div></div><div class=\"clearfix\"></div></div><div class=\"collapse content-mais-info\" id=\"maisInfo\"><div class=\"container-mais-info\"><div class=\"cnpj\"><span class=\"label-cnpj\">CNPJ:</span> <span class=\"data-cnpj\">44.873.420/0001-58 (Matriz)</span></div><div class=\"registro\"><span class=\"label-registro\">Registro:</span> <span class=\"data-registro\">-</span></div><div class=\"endereco\"><span class=\"label-endereco\">Endereço:</span> <span class=\"data-endereco\">Rua Bairro do Ovídio s/n</span></div></div></div></div><div class=\"detail-info-search\"><div class=\"row\"><div class=\"positiva\"><div class=\"col-xs-12 col-sm-3 col-md-3\"><div class=\"alert alert-danger text-center\"><i class=\"fa fa-ban\"></i> <span class=\"status\">Certidão positiva de débitos</span> <span class=\"date\">Consulta realizada no dia 00/00/00 às 00:00 horas</span></div></div><div class=\"col-xs-12 col-sm-9 col-md-9\"><p>Ressalvado o direito do DER/PR de cobrar quaisquer dívidas de responsabilidade da Empresa acima citada, que vierem a ser apuradas.</p><p>É certificado <b class=\"text-danger\">que consta(m)</b>, até a presente data, pendência(s) em seu nome, relativa(s) à débito administrado pela Coordenadoria de Contabilidade e Finanças da Diretoria Administrativo Financeira do Departamento de Estradas de Rodagem do Estado do Paraná - DER/PR.</p><p>Esta certidão refere-se exclusivamente à situação da Empresa acima citada, no âmbito deste Departamento, não constituindo, por conseguinte, prova de inexistência de débitos inscritos em outros orgãos do Estado.</p><div class=\"tools-btn\"><button class=\"btn btn-primary\" onclick=\"window.location.href=\'../views/extrato/extrato.html\'\"><i class=\"fa fa-eye fa-fw\"></i> <span class=\"hidden-xs\">Visualizar</span></button> <button class=\"btn btn-default\" onclick=\"imprimir()\"><i class=\"fa fa-print fa-fw\"></i> <span class=\"hidden-xs\">Imprimir</span></button> <button class=\"btn btn-default\" onclick=\"window.location.href=\'../../index.html\'\"><i class=\"fa fa-chevron-left fa-fw\"></i> <span class=\"hidden-xs\">Voltar</span></button></div></div></div><div class=\"positiva-efeito\" style=\"display:none\"><div class=\"col-xs-12 col-sm-3 col-md-3\"><div class=\"alert alert-warning text-center\"><i class=\"fa fa-ban\"></i> <span class=\"status\">Certidão positiva de débitos com efeito de negativa</span> <span class=\"date\">Consulta realizada no dia 00/00/00 às 00:00 horas</span></div></div><div class=\"col-xs-12 col-sm-9 col-md-9\"><p>Ressalvado o direito do DER/PR de cobrar quaisquer dívidas de responsabilidade da Empresa acima citada, que vierem a ser apuradas.</p><p>É certificado <b class=\"text-warning\">que consta(m)</b>, até a presente data, pendência(s) em seu nome, relativa(s) à débito administrado pela Coordenadoria de Contabilidade e Finanças da Diretoria Administrativo Financeira do Departamento de Estradas de Rodagem do Estado do Paraná - DER/PR.</p><p>Esta certidão refere-se exclusivamente à situação da Empresa acima citada, no âmbito deste Departamento, não constituindo, por conseguinte, prova de inexistência de débitos inscritos em outros orgãos do Estado.</p><div class=\"tools-btn\"><button class=\"btn btn-primary\"><i class=\"fa fa-eye fa-fw\"></i> <span class=\"hidden-xs\">Visualizar</span></button> <button class=\"btn btn-default\"><i class=\"fa fa-print fa-fw\"></i> <span class=\"hidden-xs\">Imprimir</span></button> <button class=\"btn btn-default\"><i class=\"fa fa-chevron-left fa-fw\"></i> <span class=\"hidden-xs\">Voltar</span></button></div></div></div><div style=\"display:none\" class=\"negativa\"><div class=\"col-xs-12 col-sm-3 col-md-3\"><div class=\"alert alert-success text-center\"><i class=\"fa fa-check-circle-o\"></i> <span class=\"status\">Certidão negativa de débitos</span> <span class=\"date\">Consulta realizada no dia 00/00/00 às 00:00 horas</span></div></div><div class=\"col-xs-12 col-sm-9 col-md-9\"><p>Ressalvado o direito do DER/PR de cobrar quaisquer dívidas de responsabilidade da Empresa acima citada, que vierem a ser apuradas.</p><p>É certificado <b class=\"text-success\">que não consta(m)</b>, até a presente data, pendência(s) em seu nome, relativa(s) à débito administrado pela Coordenadoria de Contabilidade e Finanças da Diretoria Administrativo Financeira do Departamento de Estradas de Rodagem do Estado do Paraná - DER/PR.</p><p>Esta certidão refere-se exclusivamente à situação da Empresa acima citada, no âmbito deste Departamento, não constituindo, por conseguinte, prova de inexistência de débitos inscritos em outros orgãos do Estado.</p><div class=\"tools-btn\"><button class=\"btn btn-default\"><i class=\"fa fa-print fa-fw\"></i> <span class=\"hidden-xs\">Imprimir</span></button> <button class=\"btn btn-default\"><i class=\"fa fa-chevron-left fa-fw\"></i> <span class=\"hidden-xs\">Voltar</span></button></div></div></div></div></div><script>\n    function imprimir() {\n        window.print();\n    }\n</script>");
$templateCache.put("app/view/efeitosuspensivo/efeitoSuspensivo.tpl.html","<div ng-init=\"extratoController.tab=4\" role=\"tabpanel\" class=\"tab-pane efeitoSusp\" id=\"efeitoSusp\" ng-class=\"{\'active\' : extratoController.tab==4}\"><div class=\"titulo\">Débitos com Efeito Suspensivo</div><div ng-if=\"!efeitoSuspensivoController.debitosComEfeitoSuspensivo.length > 0\"><div class=\"empty-state-no-doc\"><img src=\"assets/images/empty-state--no-doc.png\"></div><div class=\"not-found\">Nada consta.</div></div><div class=\"content-efeito-suspensivo\" ng-if=\"efeitoSuspensivoController.debitosComEfeitoSuspensivo.length > 0\"><table class=\"table table-striped\"><thead><tr><th>Código do órgão</th><th>Descrição do débito</th><th>Número do auto/Placa</th><th>Tipo de infração</th><th>Número da CR/Ano da CR</th><th>Número da Parcela</th><th>Valor original (R$)</th><th>Data da infração/Documento</th><th>Início da atualização</th><th>Valor atualizado (R$)</th></tr></thead><tbody><tr ng-repeat=\"debito in efeitoSuspensivoController.debitosComEfeitoSuspensivo\"><td>{{debito.cdOrgao | ifEmpty: \"-\"}}</td><td>{{debito.descricao | ifEmpty: \"-\"}}</td><td ng-if=\"efeitoSuspensivoController.isDebitoFromMulta(debito.cdTipoDivida, debito.nuTipoReceita)\" ng-click=\"viewDebitoDetailDialog.open(debito)\"><div title=\"Mais informações\" style=\"width: 100%; display: table;\"><div style=\"display: table-row\"><div style=\"float: left; padding-top:1%; width: 60%;\">{{debito.autoEplaca | ifEmpty: \"-\"}}</div><div class=\"btn-help-extrato\"><i id=\"debitos-suspensos-more-info\" class=\"fa fa-info-circle btn-help\"></i></div></div></div></td><td ng-if=\"!efeitoSuspensivoController.isDebitoFromMulta(debito.cdTipoDivida, debito.nuTipoReceita)\">{{debito.autoEplaca | ifEmpty: \"-\"}}</td><td title=\"{{debito.deInfracao}}\">{{debito.deTipoInfracao | ifEmpty: \"-\"}}</td><td>{{debito.anoEnumeroCR | ifEmpty: \"-\"}}</td><td>{{debito.nuParcela | ifEmpty: \"-\"}}</td><td>{{debito.vlOriginal | number:2 | ifEmpty: \"-\"}}</td><td>{{debito.dtInfracaoDocumento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td><td>{{debito.dtInicioAtualizacao | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td><td>{{debito.vlAtualizadoComJuros | number:2 | ifEmpty: \"-\"}}</td></tr></tbody></table><div class=\"extratoDebito clearfix\"><div class=\"extratoDebitoMinifyHeader\"><div class=\"column col2\"><span>Número do auto/Placa</span></div><div class=\"column col3\"><span>Data da infração/Documento</span></div><div class=\"column col4\"><span>Valor atualizado (R$)</span></div><div class=\"column col5\"></div></div><div ng-repeat=\"debito in efeitoSuspensivoController.debitosComEfeitoSuspensivo\"><div class=\"extratoDebitoMinify\"><div class=\"column col2\"><h4>{{debito.autoEplaca | ifEmpty: \"-\"}}</h4></div><div class=\"column col3\"><h4>{{debito.dtInfracaoDocumento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</h4></div><div class=\"column col4\"><h4>{{debito.vlAtualizadoComJuros | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"column col5\"><a role=\"button\" data-toggle=\"collapse\" title=\"Mais detalhes\" ng-click=\"debito.isCollapsedExtrato = !debito.isCollapsedExtrato\" aria-expanded=\"false\" aria-controls=\"viewExtratoDebito\"><i class=\"fa fa-plus-circle\" ng-show=\"!debito.isCollapsedExtrato\" id=\"debitos-suspensos-more-detail\"></i> <i class=\"fa fa-minus-circle\" ng-show=\"debito.isCollapsedExtrato\"></i></a></div></div><div class=\"collapse\" id=\"viewExtratoDebito\" collapse=\"!debito.isCollapsedExtrato\"><div class=\"extrato-detail clearfix\"><div class=\"col-sm-6 col-xs-6\"><span>Tipo de infração</span><h4 title=\"{{debito.deInfracao}}\">{{debito.deTipoInfracao | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Código do órgão</span><h4>{{debito.cdOrgao | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\" ng-if=\"efeitoSuspensivoController.isDebitoFromMulta(debito.cdTipoDivida, debito.nuTipoReceita)\" ng-click=\"viewDebitoDetailDialog.open(debito)\" title=\"Mais informações\"><span>Descrição do débito</span><div style=\"display: flex; align-items: center\"><div><h4>{{debito.descricao | ifEmpty: \"-\"}}</h4></div><div style=\"padding-left: 5%; padding-bottom: 4%\"><div class=\"btn-help-extrato\"><i id=\"debitos-suspensos-more-info-minify\" class=\"col2 fa fa-info-circle btn-help\"></i></div></div></div></div><div class=\"col-sm-6 col-xs-6\"><span>Número da CR/Ano da CR</span><h4>{{debito.anoEnumeroCR | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Número da Parcela</span><h4>{{debito.nuParcela | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Valor original (R$)</span><h4>{{debito.vlOriginal | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Início da atualização</span><h4>{{debito.dtInicioAtualizacao | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</h4></div></div></div></div></div><div class=\"clearfix content-value\"><div class=\"alert alert-danger debitos\"><span>Total geral:</span><h3><span>R$</span> {{efeitoSuspensivoController.vlTotalAtualizadoComJuros | number:2 | ifEmpty: \"-\"}}</h3></div></div></div></div>");
$templateCache.put("app/view/cartorio/emissaoGuia.html","<div style=\"position: fixed; top: 0; bottom: 0; left: 0; right: 0; z-index: 0; background: #fff; overflow-y: auto; overflow-x: hidden;\"><ngmessagecenter-messages growl=\"\" name=\"cartorioMessages\"></ngmessagecenter-messages><div class=\"content-login\"><div class=\"header-login\"><div class=\"header-top-login\"></div><div class=\"fundo-header-top-login\"><img src=\"assets/images/fundo-top.png\"></div><div class=\"logotipo-parana-login\"><img src=\"assets/images/logotipo-parana-header.png\"></div><div class=\"header-top-info-login\"><span>SECRETARIA DE INFRAESTRUTURA E LOGÍSTICA</span></div><div class=\"fundo-header-main-login\"><span>Departamento de Estradas de Rodagem</span></div><a href=\"/\"><div class=\"logotipo-derpr-login\"></div></a></div><div class=\"container-login clearfix\"><div class=\"help\"><a href=\"http://sider.der.pr.gov.br/webhelp/files/cnd/index.htm\" target=\"_blank\" title=\"Ajuda\"><i class=\"fa fa-question-circle\" id=\"btn-help\"></i></a></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><p class=\"titulo\">Emissão de Boletos - Exclusivo para Cartórios</p></div><div class=\"col-xs-12 col-sm-6 col-md-6\"><p class=\"resume\"><strong>Pagamento exclusivo de débitos do DER.</strong></p><p class=\"resume\">Para gerar o boleto, informe o número do CPF ou CNPJ e o número da Dívida Ativa.</p><p class=\"resume\">A emissão do boleto pelos cartórios destina-se, exclusivamente, à quitação das despesas vinculadas ao Departamento de Estradas de Rodagem (DER). As custas cartorárias e a verba de sucumbência, por sua vez, deverão ser adimplidas por meio dos portais eletrônicos específicos disponibilizados para tal finalidade.</p></div><div class=\"col-xs-12 col-sm-1 col-md-1 hidden-xs\"></div><div class=\"col-xs-12 col-sm-5 col-md-5\"><p class=\"resume\">Informe os Dados</p><form class=\"form-inline\" name=\"searchForm\"><div><label class=\"radio-inline\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"checkCnpj\" value=\"cnpj\" ng-model=\"emissaoGuiaController.searchFilter.type\" ng-click=\"emissaoGuiaController.changeFieldOption()\"> CNPJ</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"checkCpf\" value=\"cpf\" ng-model=\"emissaoGuiaController.searchFilter.type\" ng-click=\"emissaoGuiaController.changeFieldOption()\"> CPF</label></div><div class=\"clearfix\"></div><div class=\"form-group\"><label class=\"sr-only\">Campo dados</label><div ng-if=\"emissaoGuiaController.searchFilter.isCPF\"><input id=\"cpf\" name=\"cpf\" class=\"form-control no-animate\" ng-model=\"emissaoGuiaController.searchFilter.nuDocumento\" type=\"tel\" placeholder=\"Informe o CPF\" sp-cpf=\"\" autofocus=\"\" required=\"\"> <span ng-messages=\"searchForm.cpf.$error\" sp-message-tooltip=\"\"><div ng-messages-include=\"app/view/partials/messages-include.html\"></div></span></div><div ng-if=\"emissaoGuiaController.searchFilter.isCNPJ\"><input id=\"cnpj\" name=\"cnpj\" class=\"form-control no-animate\" ng-model=\"emissaoGuiaController.searchFilter.nuDocumento\" type=\"tel\" placeholder=\"Informe o CNPJ\" sp-cnpj=\"\" autofocus=\"\" required=\"\"> <span ng-messages=\"searchForm.cnpj.$error\" sp-message-tooltip=\"\"><div ng-messages-include=\"app/view/partials/messages-include.html\"></div></span></div><div><input id=\"nudivida\" name=\"nudivida\" class=\"form-control no-animate\" ng-model=\"emissaoGuiaController.searchFilter.nuRegistro\" type=\"text\" maxlength=\"12\" placeholder=\"Informe o número da dívida\" sp-integer=\"\" autofocus=\"\" required=\"\"> <span ng-messages=\"searchForm.nudivida.$error\" sp-message-tooltip=\"\"><div ng-messages-include=\"app/view/partials/messages-include.html\"></div></span></div></div><div class=\"form-group\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"emissaoGuiaController.gerarGuia()\" file-download=\"emissaoGuiaController.gru\" file-name=\"emissaoGuiaController.gruName\" ng-disabled=\"searchForm.$invalid\" id=\"generate-emissao-guia-button\" data-loading-text=\"Gerar Guia <i class=\'fa fa-circle-o-notch fa-spin\'></i>\">Gerar Guia</button></div></form></div></div></div></div><div class=\"modal fade\" id=\"modalConsolidacao\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalConsolidacao\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"titleAviso\">Aviso</h4></div><div class=\"modal-body\"><p class=\"bg-warning\" style=\"padding: 25px\">Estamos consolidando as informações de seus débitos. Para sua comodidade, você receberá nossa notificação por e-mail em <b>até 48 horas</b> quando as informações estiverem disponíveis. Informe seu email de contato e confirme.</p><div class=\"row\"><form name=\"notificacaoForm\"><div class=\"col-md-8 col-sm-8 col-xs-12\"><input type=\"email\" class=\"form-control\" id=\"enviarEmail\" name=\"deEmail\" placeholder=\"Email\" maxlength=\"100\" ng-model=\"emissaoGuiaController.notificacaoForm.deEmail\" required=\"\"> <span ng-messages=\"notificacaoForm.deEmail.$error\" sp-message-tooltip=\"\"><div ng-messages-include=\"app/view/partials/messages-include.html\"></div></span></div><button class=\"btn btn-primary\" ng-disabled=\"!emissaoGuiaController.notificacaoForm.deEmail\" ng-click=\"emissaoGuiaController.confirmarNotificacao()\"><span class=\"hidden-xs\">Confirmar</span></button></form></div></div></div></div></div>");
$templateCache.put("app/view/extrato/extrato.html","<div><ngmessagecenter-messages growl=\"\" name=\"extratoMessages\"></ngmessagecenter-messages><header id=\"content-header\" class=\"content-header\"><div ng-include=\"\" src=\"\'app/view/header/header.tpl.html\'\"></div></header><section id=\"content-app\" class=\"content-app\"><div class=\"data-search clearfix\" id=\"identification-header\"><div class=\"data-search-content\" ng-click=\"extratoController.isCollapsedHeader = !extratoController.isCollapsedHeader\"><div class=\"data-search-container-razao-social\"><div class=\"info-data-search empresa\"><div class=\"label-field-data-search\">{{extratoController.devedor.dePlaca ? \'Placa do Veículo\' : \'Razão Social\'}}</div><div class=\"field-data-search\">{{extratoController.devedor.dePlaca ? extratoController.devedor.dePlaca : extratoController.devedor.deNomeFmt}}</div></div><a data-toggle=\"collapse\" class=\"btn-mais-info\" href=\"\" aria-expanded=\"false\" aria-controls=\"maisInfo\"><i class=\"fa fa-plus-circle\" ng-show=\"!extratoController.isCollapsedHeader\" id=\"header-btn-more-info\"></i> <i class=\"fa fa-minus-circle\" ng-show=\"extratoController.isCollapsedHeader\"></i></a></div><div class=\"data-search-container-cnpj\"><div class=\"info-data-search cnpj\"><div class=\"label-field-data-search\">CNPJ/CPF</div><div class=\"field-data-search\">{{extratoController.devedor.nuDocumentoFmt}}</div></div></div><div class=\"data-search-container-registro\"><div class=\"info-data-search registro\"><div class=\"label-field-data-search\">Registro</div><div class=\"field-data-search\">{{extratoController.devedor.nuRegistro}}</div></div></div><div class=\"data-search-container-endereco\"><div class=\"info-data-search endereco\"><div class=\"label-field-data-search\" ng-if=\"extratoController.exibeLabelEndereco\">Endereço</div><div class=\"field-data-search\">{{extratoController.devedor.deEnderecoFmt}}</div></div></div><div class=\"clearfix\"></div></div><div class=\"collapse content-mais-info\" id=\"maisInfo\" collapse=\"!extratoController.isCollapsedHeader\"><div class=\"container-mais-info\"><div class=\"cnpj\"><span class=\"label-cnpj\">CNPJ/CPF:</span> <span class=\"data-cnpj\">{{extratoController.devedor.nuDocumentoFmt}}</span></div><div class=\"registro\"><span class=\"label-registro\">Registro:</span> <span class=\"data-registro\">{{extratoController.devedor.nuRegistro}}</span></div><div class=\"endereco\" ng-if=\"extratoController.exibeLabelEndereco\"><span class=\"label-endereco\">Endereço:</span> <span class=\"data-endereco\">{{extratoController.devedor.deEnderecoFmt}}</span></div></div></div></div><div class=\"content-extrato\"><div class=\"content-nav-tabs-extended\"><div class=\"content-nav-tabs\"><ul class=\"nav nav-tabs\" role=\"tablist\"><li role=\"presentation\" class=\"extrato-debito\" ng-class=\"{\'active\' : extratoController.tab == 1}\"><a id=\"extrato-debito-tab-menu\" href=\"\" ng-click=\"extratoController.changeTab(1)\" aria-controls=\"extratoDebito\" role=\"tab\" data-toggle=\"tab\">Extrato de Débito <span ng-if=\"extratoController.debitos.length > 0\" class=\"badge\">{{extratoController.debitos.length}}</span></a></li><li role=\"presentation\" class=\"extrato-debito\" ng-class=\"{\'active\' : extratoController.tab == 6}\"><a id=\"protesto-tab-menu\" href=\"\" ng-click=\"extratoController.changeTab(6)\" aria-controls=\"extratoDebito\" role=\"tab\" data-toggle=\"tab\">Em Protesto / Protestado <span ng-if=\"extratoController.dividasEmProtesto.length > 0\" class=\"badge\">{{extratoController.dividasEmProtesto.length}}</span></a></li><li role=\"presentation\" class=\"acordo-adm\" ng-class=\"{\'active\' : extratoController.tab == 2}\"><a id=\"acordo-adm-tab-menu\" href=\"\" ng-click=\"extratoController.changeTab(2)\" aria-controls=\"acordoAdm\" role=\"tab\" data-toggle=\"tab\">Acordos Administrativos <span ng-if=\"extratoController.acordosAdministrativos.length > 0\" class=\"badge\">{{extratoController.acordosAdministrativos.length}}</span></a></li><li role=\"presentation\" class=\"acordo-jur\" ng-class=\"{\'active\' : extratoController.tab == 3}\"><a id=\"acordo-jur-tab-menu\" href=\"\" ng-click=\"extratoController.changeTab(3)\" aria-controls=\"acordoJur\" role=\"tab\" data-toggle=\"tab\">Acordos Jurídicos <span ng-if=\"extratoController.acordosJuridicos.length > 0\" class=\"badge\">{{extratoController.acordosJuridicos.length}}</span></a></li><li role=\"presentation\" class=\"efeito-susp\" ng-class=\"{\'active\' : extratoController.tab == 4}\"><a id=\"debitos-suspensos-tab-menu\" href=\"\" ng-click=\"extratoController.changeTab(4)\" aria-controls=\"acordoJur\" role=\"tab\" data-toggle=\"tab\">Débitos Suspensos <span ng-if=\"extratoController.debitosComEfeitoSuspensivo.length > 0\" class=\"badge\">{{extratoController.debitosComEfeitoSuspensivo.length}}</span></a></li><li role=\"presentation\" class=\"ag-imp-final\" ng-class=\"{\'active\' : extratoController.tab == 5}\"><a id=\"debitos-agimpfinal-tab-menu\" href=\"\" ng-click=\"extratoController.changeTab(5)\" aria-controls=\"acordoJur\" role=\"tab\" data-toggle=\"tab\">Ag. Imposição Final <span ng-if=\"extratoController.contasAgImposicaoFinal.length > 0\" class=\"badge\">{{extratoController.contasAgImposicaoFinal.length}}</span></a></li></ul></div></div><div class=\"content-nav-tabs-minify\"><div class=\"content-nav-tabs\"><ul class=\"nav nav-tabs\" role=\"tablist\"><li role=\"presentation\" class=\"extrato-debito\" ng-class=\"{\'active\' : extratoController.tab == 1}\"><a id=\"extrato-debito-tab-menu-minify\" href=\"\" ng-click=\"extratoController.changeTab(1)\" aria-controls=\"extratoDebito\" role=\"tab\" data-toggle=\"tab\">Ext. de Débitos <span ng-if=\"extratoController.debitos.length > 0\" class=\"badge\">{{extratoController.debitos.length}}</span></a></li><li role=\"presentation\" class=\"extrato-debito\" ng-class=\"{\'active\' : extratoController.tab == 6}\"><a id=\"protesto-tab-menu-minify\" href=\"\" ng-click=\"extratoController.changeTab(6)\" aria-controls=\"extratoDebito\" role=\"tab\" data-toggle=\"tab\">Em Protesto <span ng-if=\"extratoController.dividasEmProtesto.length > 0\" class=\"badge\">{{extratoController.dividasEmProtesto.length}}</span></a></li><li role=\"presentation\" class=\"acordo-adm\" ng-class=\"{\'active\' : extratoController.tab == 2}\"><a id=\"acordo-adm-tab-menu-minify\" href=\"\" ng-click=\"extratoController.changeTab(2)\" aria-controls=\"acordoAdm\" role=\"tab\" data-toggle=\"tab\">Acordos Adm. <span ng-if=\"extratoController.acordosAdministrativos.length > 0\" class=\"badge\">{{extratoController.acordosAdministrativos.length}}</span></a></li><li role=\"presentation\" class=\"acordo-jur\" ng-class=\"{\'active\' : extratoController.tab == 3}\"><a id=\"acordo-jur-tab-menu-minify\" href=\"\" ng-click=\"extratoController.changeTab(3)\" aria-controls=\"acordoJur\" role=\"tab\" data-toggle=\"tab\">Acordos Jur. <span ng-if=\"extratoController.acordosJuridicos.length > 0\" class=\"badge\">{{extratoController.acordosJuridicos.length}}</span></a></li><li role=\"presentation\" class=\"efeito-susp\" ng-class=\"{\'active\' : extratoController.tab == 4}\"><a id=\"debitos-suspensos-tab-menu-minify\" href=\"\" ng-click=\"extratoController.changeTab(4)\" aria-controls=\"acordoJur\" role=\"tab\" data-toggle=\"tab\">Débitos Susp. <span ng-if=\"extratoController.debitosComEfeitoSuspensivo.length > 0\" class=\"badge\">{{extratoController.debitosComEfeitoSuspensivo.length}}</span></a></li><li role=\"presentation\" class=\"ag-imp-final\" ng-class=\"{\'active\' : extratoController.tab == 5}\"><a id=\"debitos-agimpfinal-tab-menu-minify\" href=\"\" ng-click=\"extratoController.changeTab(5)\" aria-controls=\"acordoJur\" role=\"tab\" data-toggle=\"tab\">Ag. Imp. Final <span ng-if=\"extratoController.contasAgImposicaoFinal.length > 0\" class=\"badge\">{{extratoController.contasAgImposicaoFinal.length}}</span></a></li></ul></div></div><div class=\"tab-content\"><div role=\"tabpanel\" id=\"extratoDebito\" ng-show=\"extratoController.tab == 1\" ng-class=\"{\'active\' : extratoController.tab==1}\"><br><div class=\"titulo\">Débitos aguardando a execução fiscal</div><div ng-if=\"!extratoController.debitos.length > 0\"><div class=\"empty-state-no-doc\"><img src=\"assets/images/empty-state--no-doc.png\"></div><div class=\"not-found\">Nada consta.</div></div><div class=\"content-aguardando-execucao-fiscal\" ng-if=\"extratoController.debitos.length > 0\"><table class=\"table table-striped\"><thead><tr><th><label><input id=\"checkbox-mark-all\" type=\"checkbox\" name=\"checkbox\" ng-model=\"extratoController.selectedAll\" ng-click=\"extratoController.checkAll()\"></label></th><th>Código do órgão</th><th>Descrição do débito</th><th>Número do auto/Placa</th><th>Tipo de infração</th><th>Número da CR/Ano da CR</th><th>Número da Parcela</th><th>Valor original (R$)</th><th>Data da infração/Documento</th><th>Início da atualização</th><th>Valor atualizado (R$)</th></tr></thead><tbody><tr ng-repeat=\"debito in extratoController.debitos\"><td><label><input type=\"checkbox\" name=\"checkbox\" id=\"checkbox\" ng-model=\"debito.selected\" ng-click=\"extratoController.atualizaValorSelecionado(debito)\"></label></td><td>{{debito.cdOrgao | ifEmpty: \"-\"}}</td><td>{{debito.descricao | ifEmpty: \"-\"}}</td><td ng-if=\"extratoController.isDebitoFromMulta(debito.cdTipoDivida, debito.nuTipoReceita)\" ng-click=\"viewDebitoDetailDialog.open(debito)\"><div title=\"Mais informações\" style=\"width: 100%; display: table;\"><div style=\"display: table-row\"><div style=\"float: left; padding-top:1%; width: 80%;\">{{debito.autoEplaca | ifEmpty: \"-\"}}</div><div class=\"btn-help-extrato\"><i id=\"extrato-debito-more-info\" class=\"fa fa-info-circle btn-help\"></i></div></div></div></td><td ng-if=\"!extratoController.isDebitoFromMulta(debito.cdTipoDivida, debito.nuTipoReceita)\">{{debito.autoEplaca | ifEmpty: \"-\"}}</td><td title=\"{{debito.deInfracao}}\">{{debito.deTipoInfracao | ifEmpty: \"-\"}}</td><td>{{debito.anoEnumeroCR | ifEmpty: \"-\"}}</td><td>{{debito.nuParcela | ifEmpty: \"-\"}}</td><td>{{debito.vlOriginal | number:2 | ifEmpty: \"-\"}}</td><td>{{debito.dtInfracaoDocumento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td><td>{{debito.dtInicioAtualizacao | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td><td>{{debito.vlAtualizado | number:2 | ifEmpty: \"-\"}}</td></tr></tbody></table><div class=\"extratoDebito clearfix\"><div class=\"extratoDebitoMinifyHeader\"><div class=\"column col1\"><label><input type=\"checkbox\" name=\"checkbox\" ng-model=\"extratoController.selectedAll\" ng-click=\"extratoController.checkAll()\"></label></div><div class=\"column col2\"><span>Número do auto/Placa</span></div><div class=\"column col3\"><span>Data da infração/Documento</span></div><div class=\"column col4\"><span>Valor atualizado (R$)</span></div><div class=\"column col5\"></div></div><div ng-repeat=\"debito in extratoController.debitos\"><div class=\"extratoDebitoMinify\"><div class=\"column col1\"><label><input type=\"checkbox\" name=\"checkbox\" ng-model=\"debito.selected\" ng-click=\"extratoController.atualizaValorSelecionado(debito)\"></label></div><div class=\"column col2\"><h4>{{debito.autoEplaca | ifEmpty: \"-\"}}</h4></div><div class=\"column col3\"><h4>{{debito.dtInfracaoDocumento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</h4></div><div class=\"column col4\"><h4>{{debito.vlAtualizadoComJuros | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"column col5\"><a role=\"button\" data-toggle=\"collapse\" title=\"Mais detalhes\" ng-click=\"debito.isCollapsedExtrato = !debito.isCollapsedExtrato\" aria-expanded=\"false\" aria-controls=\"viewExtratoDebito\"><i class=\"fa fa-plus-circle\" ng-show=\"!debito.isCollapsedExtrato\" id=\"extrato-debitos-more-details\"></i> <i class=\"fa fa-minus-circle\" ng-show=\"debito.isCollapsedExtrato\"></i></a></div></div><div class=\"collapse\" id=\"viewExtratoDebito\" collapse=\"!debito.isCollapsedExtrato\"><div class=\"extrato-detail clearfix\"><div class=\"col-sm-6 col-xs-6\"><span>Tipo de infração</span><h4 title=\"{{debito.deInfracao}}\">{{debito.deTipoInfracao | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Código do órgão</span><h4>{{debito.cdOrgao | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\" ng-if=\"extratoController.isDebitoFromMulta(debito.cdTipoDivida, debito.nuTipoReceita)\" ng-click=\"viewDebitoDetailDialog.open(debito)\" title=\"Mais informações\"><span>Descrição do débito</span><div style=\"display: flex; align-items: center\"><div><h4>{{debito.descricao | ifEmpty: \"-\"}}</h4></div><div style=\"padding-left: 5%; padding-bottom: 4%\"><div class=\"btn-help-extrato\"><i id=\"extrato-debito-more-info-minify\" class=\"col2 fa fa-info-circle btn-help\"></i></div></div></div></div><div class=\"col-sm-6 col-xs-6\"><span>Número da CR/Ano da CR</span><h4>{{debito.anoEnumeroCR | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Número da Parcela</span><h4>{{debito.nuParcela | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Valor original (R$)</span><h4>{{debito.vlOriginal | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Início da atualização</span><h4>{{debito.dtInicioAtualizacao | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</h4></div></div></div></div></div><div class=\"clearfix content-value\"><div class=\"alert alert-success emissao-guia\"><div><span>Valor total selecionado:</span><h3><span>R$</span> {{extratoController.vlTotalSelecionado | number:2 | ifEmpty: \"-\"}}</h3></div><a id=\"btn-modal-gerar-guia-address\" role=\"button\" class=\"btn btn-primary\" ng-click=\"extratoController.openModal(extratoController.debitos)\">Gerar Guia</a> <a id=\"btn-modal-gerar-guia-bb-pay\" role=\"button\" class=\"btn btn-bbpay\" ng-if=\"extratoController.showBbPayButtons\" ng-click=\"extratoController.generateBbPayLink(extratoController.debitos, $event)\" ng-disabled=\"!extratoController.canGenerateBbPay || extratoController.isGeneratingBbPay\" data-loading-text=\"Gerando Link de Pagamento <i class=\'fa fa-circle-o-notch fa-spin\'></i>\"><img src=\"assets/images/parcelar-com-bb-pay.png\"></a></div><div class=\"alert alert-danger debitos\"><span>Total geral do valor atualizado:</span><h3><span>R$</span> {{extratoController.vlTotalAtualizado | number:2 | ifEmpty: \"-\"}}</h3></div></div></div><div class=\"content-relativos-execucao-fiscal\" ng-if=\"extratoController.debitosExecutados.length > 0\"><div class=\"titulo\">Débitos relativos a execução fiscal</div><div class=\"alert alert-info\">Para eventual interesse em emissão de Guia de Débitos Judiciais, favor entrar em contato com o Departamento Jurídico - Fone: (41) 3304-8311</div><table class=\"table table-striped\"><thead><tr><th>Código do órgão</th><th>Descrição do débito</th><th>Número do auto/Placa</th><th>Número da dívida</th><th>Fundamento legal</th><th>Valor original (R$)</th><th>Data da infração/Documento</th><th>Início da atualização</th><th>Valor ou valor parcela(P) (R$)</th></tr></thead><tbody><tr ng-repeat=\"debitoExecutado in extratoController.debitosExecutados\"><td>{{debitoExecutado.cdOrgao | ifEmpty: \"-\"}}</td><td>{{debitoExecutado.descricao | ifEmpty: \"-\"}}</td><td ng-if=\"extratoController.isDebitoFromMulta(debitoExecutado.cdTipoDivida, null)\" ng-click=\"viewDebitoDetailDialog.open(debito)\"><div title=\"Mais informações\" style=\"width: 100%; display: table;\"><div style=\"display: table-row\"><div style=\"float: left; padding-top:1%; width: 80%;\">{{debitoExecutado.autoEplaca | ifEmpty: \"-\"}}</div><div class=\"btn-help-extrato\"><i id=\"debitos-executados-more-info\" class=\"col6 fa fa-info-circle btn-help\"></i></div></div></div></td><td ng-if=\"!extratoController.isDebitoFromMulta(debitoExecutado.cdTipoDivida, null)\">{{debitoExecutado.autoEplaca | ifEmpty: \"-\"}}</td><td>{{debitoExecutado.dividaAtiva | ifEmpty: \"-\"}}</td><td title=\"{{debitoExecutado.deInfracao}}\">{{debitoExecutado.fundamentoLegal | ifEmpty: \"-\"}}</td><td>{{debitoExecutado.vlOriginal | number:2 | ifEmpty: \"-\"}}</td><td>{{debitoExecutado.dtInfracaoDocumento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td><td>{{debitoExecutado.dtInicioAtualizacao | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td><td>{{debitoExecutado.vlAtualizado | number:2 | ifEmpty: \"-\"}}</td></tr></tbody></table><div class=\"extratoDebito clearfix\"><div class=\"extratoDebitoMinifyHeader\"><div class=\"column col2\"><span>Número do auto/Placa</span></div><div class=\"column col3\"><span>Data da infração/Documento</span></div><div class=\"column col4\"><span>Valor atualizado (R$)</span></div><div class=\"column col5\"></div></div><div ng-repeat=\"debito in extratoController.debitosExecutados\"><div class=\"extratoDebitoMinify\" ng-click=\"debito.isCollapsedExtrato = !debito.isCollapsedExtrato\"><div class=\"column col2\"><h4>{{debito.autoEplaca | ifEmpty: \"-\"}}</h4></div><div class=\"column col3\"><h4>{{debito.dtInfracaoDocumento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</h4></div><div class=\"column col4\"><h4>{{debito.vlAtualizado | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"column col5\"><a role=\"button\" data-toggle=\"collapse\" title=\"Mais detalhes\" aria-expanded=\"false\" aria-controls=\"viewExtratoDebitoExecucao\"><i class=\"fa fa-plus-circle\" ng-show=\"!debito.isCollapsedExtrato\" id=\"debitos-executados-more-details\"></i> <i class=\"fa fa-minus-circle\" ng-show=\"debito.isCollapsedExtrato\"></i></a></div></div><div class=\"collapse\" id=\"viewExtratoDebitoExecucao\" collapse=\"!debito.isCollapsedExtrato\"><div class=\"extrato-detail clearfix\"><div class=\"col-sm-6 col-xs-6\"><span>Código do órgão</span><h4>{{debito.cdOrgao | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\" ng-if=\"extratoController.isDebitoFromMulta(debito.cdTipoDivida, null)\" ng-click=\"viewDebitoDetailDialog.open(debito)\" title=\"Mais informações\"><span>Descrição do débito</span><div style=\"display: flex; align-items: center\"><div><h4>{{debito.descricao | ifEmpty: \"-\"}}</h4></div><div style=\"padding-left: 5%; padding-bottom: 4%\"><div class=\"btn-help-extrato\"><i id=\"debitos-executados-more-info-minify\" class=\"col2 fa fa-info-circle btn-help\"></i></div></div></div></div><div class=\"col-sm-6 col-xs-6\"><span>Número da dívida</span><h4>{{debito.dividaAtiva | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Fundamento legal</span><h4 title=\"{{debito.deInfracao}}\">{{debito.fundamentoLegal | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Valor original (R$)</span><h4>{{debito.vlOriginal | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Início da atualização</span><h4>{{debito.vlAtualizado | number:2 | ifEmpty: \"-\"}}</h4></div></div></div></div></div><div class=\"clearfix content-value\"><div class=\"alert alert-danger debitos\"><span>Total geral:</span><h3><span>R$</span> {{extratoController.vlTotalExecutadoAtualizado | number:2 | ifEmpty: \"-\"}}</h3></div></div></div></div><div role=\"tabpanel\" id=\"protesto\" ng-show=\"extratoController.tab == 6\" ng-class=\"{\'active\' : extratoController.tab==6}\"><br><div class=\"titulo\">Débitos em Processo de Protesto e Protestado pelo Cartório</div><div ng-if=\"!extratoController.dividasEmProtesto.length > 0\"><div class=\"empty-state-no-doc\"><img src=\"assets/images/empty-state--no-doc.png\"></div><div class=\"not-found\">Nada consta.</div></div><div class=\"content-aguardando-execucao-fiscal\" ng-if=\"extratoController.dividasEmProtesto.length > 0\"><table class=\"table table-striped\"><thead><tr><th>-</th><th>Código do órgão</th><th>Descrição do débito</th><th>Número do auto/Placa</th><th>Tipo de infração</th><th>Número da CR/Ano da CR</th><th>Situação</th><th>Cartório</th><th>Valor original (R$)</th><th>Data da infração</th><th>Início da atualização</th><th>Valor atualizado (R$)</th></tr></thead><tbody><tr ng-repeat=\"debito in extratoController.dividasEmProtesto\"><td><label ng-if=\"debito.protestado\"><input type=\"checkbox\" name=\"checkbox\" id=\"checkbox2\" ng-model=\"debito.selected\" ng-click=\"extratoController.atualizaValorSelecionadoProtestado(debito)\"></label></td><td>{{debito.cdOrgao | ifEmpty: \"-\"}}</td><td>{{debito.descricao | ifEmpty: \"-\"}}</td><td ng-if=\"extratoController.isDebitoFromMulta(debito.cdTipoDivida, debito.nuTipoReceita)\" ng-click=\"viewDebitoDetailDialog.open(debito)\"><div title=\"Mais informações\" style=\"width: 100%; display: table;\"><div style=\"display: table-row\"><div style=\"float: left; padding-top:1%; width: 80%;\">{{debito.autoEplaca | ifEmpty: \"-\"}}</div><div class=\"btn-help-extrato\"><i id=\"extrato-debito-more-info\" class=\"fa fa-info-circle btn-help\"></i></div></div></div></td><td title=\"{{debito.deInfracao}}\">{{debito.deTipoInfracao | ifEmpty: \"-\"}}</td><td>{{debito.anoEnumeroCR | ifEmpty: \"-\"}}</td><td>{{debito.deSituacao | ifEmpty: \"\"}}</td><td ng-if=\"extratoController.isDebitoFromMulta(debito.cdTipoDivida, debito.nuTipoReceita)\" ng-click=\"viewProtestoDetailDialog.open(debito)\"><div title=\"Informações do Cartório\" style=\"width: 100%; display: table;\"><div style=\"display: table-row\"><div class=\"btn-help-extrato\" style=\"display: flex; align-items: center;\"><i class=\"fa fa-info-circle\" style=\"margin-right: 5px;\"></i></div></div></div></td><td>{{debito.vlOriginal | number:2 | ifEmpty: \"-\"}}</td><td>{{debito.dtInfracaoDocumento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td><td>{{debito.dtInicioAtualizacao | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td><td>{{debito.vlAtualizado | number:2 | ifEmpty: \"-\"}}</td></tr></tbody></table><div class=\"extratoDebito clearfix\"><div class=\"extratoDebitoMinifyHeader\"><div class=\"column col2\"><span>Número do auto/Placa</span></div><div class=\"column col3\"><span>Data da infração/Documento</span></div><div class=\"column col4\"><span>Valor atualizado (R$)</span></div><div class=\"column col5\"></div><div class=\"column col6\"><span>Valor atualizado (R$)</span></div></div><div ng-repeat=\"debito in extratoController.dividasEmProtesto\"><div class=\"extratoDebitoMinify\"><div class=\"column col1\"></div><div class=\"column col2\"><h4>{{debito.autoEplaca | ifEmpty: \"-\"}}</h4></div><div class=\"column col3\"><h4>{{debito.dtInfracaoDocumento | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</h4></div><div class=\"column col4\"><h4>{{debito.vlAtualizadoComJuros | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"column col5\"><a role=\"button\" data-toggle=\"collapse\" title=\"Mais detalhes\" ng-click=\"debito.isCollapsedExtrato = !debito.isCollapsedExtrato\" aria-expanded=\"false\" aria-controls=\"viewExtratoDebitoProtesto\"><i class=\"fa fa-plus-circle\" ng-show=\"!debito.isCollapsedExtrato\" id=\"extrato-debitos-more-details\"></i> <i class=\"fa fa-minus-circle\" ng-show=\"debito.isCollapsedExtrato\"></i></a></div></div><div class=\"collapse\" id=\"viewExtratoDebitoProtesto\" collapse=\"!debito.isCollapsedExtrato\"><div class=\"extrato-detail clearfix\"><div class=\"col-sm-6 col-xs-6\"><span>Tipo de infração</span><h4 title=\"{{debito.deInfracao}}\">{{debito.deTipoInfracao | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Código do órgão</span><h4>{{debito.cdOrgao | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\" ng-if=\"extratoController.isDebitoFromMulta(debito.cdTipoDivida, debito.nuTipoReceita)\" ng-click=\"viewDebitoDetailDialog.open(debito)\" title=\"Mais informações\"><span>Descrição do débito</span><div style=\"display: flex; align-items: center\"><div><h4>{{debito.descricao | ifEmpty: \"-\"}}</h4></div><div style=\"padding-left: 5%; padding-bottom: 4%\"><div class=\"btn-help-extrato\"><i id=\"extrato-debito-more-info-minify\" class=\"col2 fa fa-info-circle btn-help\"></i></div></div></div></div><div class=\"col-sm-6 col-xs-6\"><span>Número da CR/Ano da CR</span><h4>{{debito.anoEnumeroCR | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Situação</span><h4>{{debito.deSituacao | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\" ng-if=\"extratoController.isDebitoFromMulta(debito.cdTipoDivida, debito.nuTipoReceita)\" ng-click=\"viewProtestoDetailDialog.open(debito)\" title=\"Informações do Cartório\" style=\"width: 100%; display: table;\"><span>Cartório</span><div style=\"display: table-row\"><div class=\"btn-help-extrato\" style=\"display: flex; align-items: center;\"><i class=\"fa fa-info-circle\" style=\"margin-right: 5px;\"></i></div></div></div><div class=\"col-sm-6 col-xs-6\"><span>Valor original (R$)</span><h4>{{debito.vlOriginal | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Início da atualização</span><h4>{{debito.dtInicioAtualizacao | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</h4></div></div></div></div></div><div class=\"clearfix content-value\"><div class=\"alert alert-success emissao-guia\"><div><span>Valor total selecionado:</span><h3><span>R$</span> {{extratoController.vlTotalSelecionadoProtestado | number:2 | ifEmpty: \"-\"}}</h3></div><a id=\"btn-modal-gerar-guia-address\" role=\"button\" class=\"btn btn-primary\" ng-click=\"extratoController.openModal(extratoController.dividasEmProtesto)\">Gerar Guia</a> <a id=\"btn-modal-gerar-guia-bb-pay-protesto\" role=\"button\" class=\"btn btn-bbpay\" ng-if=\"extratoController.showBbPayButtons\" ng-click=\"extratoController.generateBbPayLink(extratoController.dividasEmProtesto, $event)\" ng-disabled=\"!extratoController.canGenerateBbPay || extratoController.isGeneratingBbPay\" data-loading-text=\"Gerando Link de Pagamento <i class=\'fa fa-circle-o-notch fa-spin\'></i>\"><img src=\"assets/images/parcelar-com-bb-pay.png\"></a></div><div class=\"alert alert-danger debitos\"><span>Total geral do valor atualizado:</span><h3><span>R$</span> {{extratoController.vlTotalEmProtestoAtualizado| number:2 | ifEmpty: \"-\"}}</h3></div></div><div class=\"alert alert-success emissao-guia\"><div class=\"titulo\"><span>O pagamento das guias de documento de dívidas com a situação \"Em Protesto\" deve ser realizada diretamente no cartório competente, no valor correspondente ao montante declarado pelo apresentante, acrescido das taxas cartoriais e de outras despesas aplicáveis.</span><br><span>As dívidas com a situação \"Protestado\" deve ser efetuado o pagamento no montante declarado e as taxas cartoriais devem ser pagas diretamente no cartório de protesto.</span></div></div></div></div></div><div role=\"tabpanel\" class=\"tab-pane acordoAdm\" id=\"acordoAdm\" ui-view=\"\" ng-show=\"extratoController.tab == 2\" ng-class=\"{\'active\' : extratoController.tab==2}\"><div class=\"titulo\">Acordos Administrativos</div><div ng-if=\"!extratoController.acordosAdministrativos.length > 0\"><div class=\"empty-state-no-doc\"><img src=\"assets/images/empty-state--no-doc.png\"></div><div class=\"not-found\">Nada consta.</div></div><div ng-if=\"extratoController.acordosAdministrativos.length > 0\"><table class=\"table table-striped\"><thead><tr><th>Data</th><th>Número da conta a receber</th><th>Ano da conta a receber</th><th>Número de parcelas</th><th>Valor total (R$)</th><th>Número de parcelas a pagar</th><th>Saldo (R$)</th><th>Negociação tipo</th><th>Acordo</th></tr></thead><tbody><tr ng-repeat=\"acordoAdm in extratoController.acordosAdministrativos\"><td>{{acordoAdm.dtContaReceber | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td><td>{{acordoAdm.nuContaReceber | ifEmpty: \"-\"}}</td><td>{{acordoAdm.nuAnoContaReceber | ifEmpty: \"-\"}}</td><td>{{acordoAdm.nuParcelas | ifEmpty: \"-\"}}</td><td>{{acordoAdm.vlNegociacao | number:2 | ifEmpty: \"-\"}}</td><td>{{acordoAdm.nuParcelaEmAberto | ifEmpty: \"-\"}}</td><td>{{acordoAdm.vlSaldo | number:2 | ifEmpty: \"-\"}}</td><td>{{acordoAdm.tipoNegociacao | ifEmpty: \"-\"}}</td><td><button id=\"btn-acordoadm-detail\" class=\"btn btn-primary-outline\" ng-click=\"extratoController.openDetalheAcordoAdministrativo($index)\" title=\"Ver detalhes do acordo\"><i class=\"fa fa-file-text-o\"></i></button></td></tr></tbody></table><div class=\"extratoDebito clearfix\"><div class=\"extratoDebitoMinifyHeader\"><div class=\"column col2\"><span>Data</span></div><div class=\"column col3\"><span>Saldo(R$)</span></div><div class=\"column col4\"><span>Acordo</span></div><div class=\"column col5\"></div></div><div ng-repeat=\"acordoAdm in extratoController.acordosAdministrativos\"><div class=\"extratoDebitoMinify\" ng-click=\"acordoAdm.isCollapsedExtratoAcordo = !acordoAdm.isCollapsedExtratoAcordo\"><div class=\"column col2\"><h4>{{acordoAdm.dtContaReceber | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</h4></div><div class=\"column col3\"><h4>{{acordoAdm.vlSaldo | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"column col4\"><button id=\"btn-acordoadm-detail-minify\" class=\"btn btn-primary-outline\" ng-click=\"extratoController.openDetalheAcordoAdministrativo($index)\" title=\"Ver detalhes do acordo\"><i class=\"fa fa-file-text-o\"></i></button></div><div class=\"column col5\"><a role=\"button\" data-toggle=\"collapse\" title=\"Mais detalhes\" aria-expanded=\"false\" aria-controls=\"viewExtratoDebitoAcordoAdm\"><i class=\"fa fa-plus-circle\" ng-show=\"!acordoAdm.isCollapsedExtratoAcordo\" id=\"acordoadm-more-details\"></i> <i class=\"fa fa-minus-circle\" ng-show=\"acordoAdm.isCollapsedExtratoAcordo\"></i></a></div></div><div class=\"collapse\" id=\"viewExtratoDebitoAcordoAdm\" collapse=\"!acordoAdm.isCollapsedExtratoAcordo\"><div class=\"extrato-detail clearfix\"><div class=\"col-sm-6 col-xs-6\"><span>Número da conta a receber</span><h4>{{acordoAdm.nuContaReceber | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Ano da conta a receber</span><h4>{{acordoAdm.nuAnoContaReceber | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Número de parcelas</span><h4>{{acordoAdm.nuParcelas | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Valor total(R$)</span><h4>{{acordoAdm.vlNegociacao | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Número de parcelas a pagar</span><h4>{{acordoAdm.nuParcelaEmAberto | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Negociação tipo</span><h4>{{acordoAdm.tipoNegociacao | ifEmpty: \"-\"}}</h4></div></div></div></div></div></div></div><div role=\"tabpanel\" class=\"tab-pane acordoJur\" id=\"acordoJur\" ui-view=\"\" ng-show=\"extratoController.tab == 3\" ng-class=\"{\'active\' : extratoController.tab==3}\"><div class=\"titulo\">Acordos Jurídicos</div><div ng-if=\"!extratoController.acordosJuridicos.length > 0\"><div class=\"empty-state-no-doc\"><img src=\"assets/images/empty-state--no-doc.png\"></div><div class=\"not-found\">Nada consta.</div></div><div ng-if=\"extratoController.acordosJuridicos.length > 0\"><table class=\"table table-striped\"><thead><tr><th>Data</th><th>Número da conta a receber</th><th>Ano da conta a receber</th><th>Número de parcelas</th><th>Valor total (R$)</th><th>Número de parcelas a pagar</th><th>Saldo (R$)</th><th>Negociação tipo</th><th>Acordo</th></tr></thead><tbody><tr ng-repeat=\"acordoJuridico in extratoController.acordosJuridicos\"><td>{{acordoJuridico.dtContaReceber | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</td><td>{{acordoJuridico.nuContaReceber | ifEmpty: \"-\"}}</td><td>{{acordoJuridico.nuAnoContaReceber | ifEmpty: \"-\"}}</td><td>{{acordoJuridico.nuParcelas | ifEmpty: \"-\"}}</td><td>{{acordoJuridico.vlNegociacao | number:2 | ifEmpty: \"-\"}}</td><td>{{acordoJuridico.nuParcelaEmAberto | ifEmpty: \"-\"}}</td><td>{{acordoJuridico.vlSaldo | number:2 | ifEmpty: \"-\"}}</td><td>{{acordoJuridico.tipoNegociacao | ifEmpty: \"-\"}}</td><td><a id=\"btn-acordojur-detail\" href=\"\" ng-click=\"extratoController.openDetalheAcordoJuridico($index)\" title=\"Ver detalhes do acordo\"><i class=\"fa fa-file-text-o\"></i></a></td></tr></tbody></table><div class=\"extratoDebito clearfix\"><div class=\"extratoDebitoMinifyHeader\"><div class=\"column col2\"><span>Data</span></div><div class=\"column col3\"><span>Saldo(R$)</span></div><div class=\"column col4\"><span>Acordo</span></div><div class=\"column col5\"></div></div><div ng-repeat=\"acordoJuridico in extratoController.acordosJuridicos\"><div class=\"extratoDebitoMinify\" ng-click=\"acordoJuridico.isCollapsedExtratoAcordo = !acordoJuridico.isCollapsedExtratoAcordo\"><div class=\"column col2\"><h4>{{acordoJuridico.dtContaReceber | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}}</h4></div><div class=\"column col3\"><h4>{{acordoJuridico.vlSaldo | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"column col4\"><a id=\"btn-acordojur-detail-minify\" href=\"\" ng-click=\"extratoController.openDetalheAcordoJuridico($index)\" title=\"Ver detalhes do acordo\"><i class=\"fa fa-file-text-o\"></i></a></div><div class=\"column col5\"><a role=\"button\" data-toggle=\"collapse\" title=\"Mais detalhes\" aria-expanded=\"false\" aria-controls=\"viewExtratoDebitoAcordoJur\"><i class=\"fa fa-plus-circle\" ng-show=\"!acordoJuridico.isCollapsedExtratoAcordo\" id=\"acordojur-more-details\"></i> <i class=\"fa fa-minus-circle\" ng-show=\"acordoJuridico.isCollapsedExtratoAcordo\"></i></a></div></div><div class=\"collapse\" id=\"viewExtratoDebitoAcordoJur\" collapse=\"!acordoJuridico.isCollapsedExtratoAcordo\"><div class=\"extrato-detail clearfix\"><div class=\"col-sm-6 col-xs-6\"><span>Número da conta a receber</span><h4>{{acordoJuridico.nuContaReceber | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Ano da conta a receber</span><h4>{{acordoJuridico.nuAnoContaReceber | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Número de parcelas</span><h4>{{acordoJuridico.nuParcelas | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Valor total(R$)</span><h4>{{acordoJuridico.vlNegociacao | number:2 | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Número de parcelas a pagar</span><h4>{{acordoJuridico.nuParcelaEmAberto | ifEmpty: \"-\"}}</h4></div><div class=\"col-sm-6 col-xs-6\"><span>Negociação tipo</span><h4>{{acordoJuridico.tipoNegociacao | ifEmpty: \"-\"}}</h4></div></div></div></div></div></div></div><div role=\"tabpanel\" class=\"tab-pane efeitoSusp\" id=\"efeitoSusp\" ui-view=\"\" ng-show=\"extratoController.tab == 4\" ng-class=\"{\'active\' : extratoController.tab==4}\"></div><div role=\"tabpanel\" class=\"tab-pane agImpFinal\" id=\"agImpFinal\" ui-view=\"\" ng-show=\"extratoController.tab == 5\" ng-class=\"{\'active\' : extratoController.tab==5}\"></div><debito-detail-dialog model=\"viewDebitoDetailDialog\"></debito-detail-dialog><protesto-detail-dialog model=\"viewProtestoDetailDialog\"></protesto-detail-dialog><div ng-include=\"\" src=\"\'app/view/extrato/modalEndereco.html\'\"></div><div class=\"modal fade\" id=\"bbPayPaymentModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"bbPayPaymentModalLabel\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"bbPayPaymentModalLabel\">Pagamento com Cartão - BB Pay</h4></div><div class=\"modal-body\"><iframe ng-show=\"extratoController.bbPayModalUrl\" ng-src=\"{{extratoController.bbPayModalUrl}}\" style=\"width: 100%; height: 600px; border: none;\"></iframe></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Fechar</button></div></div></div></div><div class=\"alert alert-warning\" role=\"alert\"><p>Observações:</p><ul><li>A baixa do Débito será realizada com base em informações transmitidas pelo banco onde foi feito o pagamento;</li><li>O pagamento da GRU utilizando PIX, será confirmado em até 2 minutos e a baixa do débito levará <b>até 15 minutos</b> para ser concretizada ou se optar pelo pagamento por Código de Barras, este pagamento será confirmado em até 24 horas assim como a baixa do débito também;</li><li>Optando pelo parcelamento via BBPay, o pagamento será confirmado em <b>até 15 minutos</b> para ser concretizado assim como a baixa do débito também;</li><li>O envio do comprovante de pagamento ao DER não agilizará este processo, pois a liberação só é feita de forma automática.</li></ul></div><div class=\"tools-btn\"><button ng-if=\"extratoController.showPrintButton\" class=\"btn btn-default\" ng-click=\"extratoController.imprimirExtratoDebito()\" file-download=\"extratoController.extratoDebitoReport\" file-name=\"extratoController.extratoDebitoReportName\" id=\"btn-print-debits-report\" data-loading-text=\"Imprimir <i class=\'fa fa-circle-o-notch fa-spin\'></i>\"><i class=\"fa fa-print fa-fw\"></i> <span class=\"hidden-xs\">Imprimir</span></button> <button class=\"btn btn-default\" ng-click=\"extratoController.backToPreviousPage()\" id=\"btn-back-page\"><i class=\"fa fa-chevron-left fa-fw\"></i> <span class=\"hidden-xs\">Voltar</span></button></div></div></section><section id=\"content-footer\" class=\"content-footer\"><div ng-include=\"\" src=\"\'app/view/footer/footer.tpl.html\'\"></div></section></div>");
$templateCache.put("app/view/extrato/modalEndereco.html","<div class=\"modal fade\" id=\"modalEndereco\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalEndereco\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"titleEndereco\">Informe o endereço para Emissão da Guia</h4></div><div class=\"modal-body\"><form name=\"enderecoForm\"><p class=\"text-danger\">* Campos de preenchimento obrigatório</p><div class=\"form-group\"><label for=\"deEndereco\">Logradouro*</label> <input type=\"text\" class=\"form-control\" id=\"deEndereco\" name=\"deEndereco\" placeholder=\"Digite o Logradouro\" maxlength=\"48\" ng-model=\"extratoController.enderecoForm.deEndereco\" autofocus=\"\" required=\"\"> <span ng-messages=\"enderecoForm.deEndereco.$error\" sp-message-tooltip=\"\"><div ng-messages-include=\"app/view/partials/messages-include.html\"></div></span></div><div class=\"form-group\"><label for=\"nuNumero\">Número*</label> <input type=\"text\" class=\"form-control\" id=\"nuNumero\" name=\"nuNumero\" placeholder=\"Digite o Número\" ng-model=\"extratoController.enderecoForm.nuNumero\" sp-number=\"10\" autofocus=\"\" required=\"\"> <span ng-messages=\"enderecoForm.nuNumero.$error\" sp-message-tooltip=\"\"><div ng-messages-include=\"app/view/partials/messages-include.html\"></div></span></div><div class=\"form-group\"><label for=\"deComplemento\">Complemento</label> <input type=\"text\" class=\"form-control\" id=\"deComplemento\" name=\"deComplemento\" placeholder=\"Digite o Complemento\" maxlength=\"100\" ng-model=\"extratoController.enderecoForm.deComplemento\"> <span ng-messages=\"enderecoForm.deComplemento.$error\" sp-message-tooltip=\"\"><div ng-messages-include=\"app/view/partials/messages-include.html\"></div></span></div><div class=\"form-group\"><label for=\"nmBairro\">Bairro</label> <input type=\"text\" class=\"form-control\" id=\"nmBairro\" name=\"nmBairro\" placeholder=\"Digite o nome do Bairro\" maxlength=\"150\" ng-model=\"extratoController.enderecoForm.nmBairro\"> <span ng-messages=\"enderecoForm.nmBairro.$error\" sp-message-tooltip=\"\"><div ng-messages-include=\"app/view/partials/messages-include.html\"></div></span></div><div class=\"form-group\"><label for=\"nuCEP\">CEP*</label> <input type=\"text\" class=\"form-control\" id=\"nuCEP\" name=\"nuCEP\" placeholder=\"Digite seu CEP\" ng-model=\"extratoController.enderecoForm.nuCEP\" sp-mask=\"99999-999\" autofocus=\"\" required=\"\"> <span ng-messages=\"enderecoForm.nuCEP.$error\" sp-message-tooltip=\"\"><div ng-messages-include=\"app/view/partials/messages-include.html\"></div></span></div><div class=\"form-group\"><label for=\"nmMunicipio\">Cidade*</label> <input type=\"text\" class=\"form-control\" id=\"nmMunicipio\" name=\"nmMunicipio\" placeholder=\"Digite sua cidade\" ng-model=\"extratoController.enderecoForm.nmMunicipio\" maxlength=\"50\" autofocus=\"\" required=\"\"> <span ng-messages=\"enderecoForm.nmMunicipio.$error\" sp-message-tooltip=\"\"><div ng-messages-include=\"app/view/partials/messages-include.html\"></div></span></div><div class=\"form-group\"><label for=\"sgUnidadefederal\">UF*</label><select class=\"form-control\" name=\"sgUnidadefederal\" id=\"sgUnidadefederal\" ng-model=\"extratoController.enderecoForm.sgUnidadefederal\" ng-options=\"uf as uf for uf in extratoController.unidadesFederais\"></select></div><div class=\"form-group\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"extratoController.geraGru()\" file-download=\"extratoController.gru\" file-name=\"extratoController.gruName\" ng-disabled=\"enderecoForm.$invalid\" id=\"generate-gru-button\" data-loading-text=\"Gerar Guia <i class=\'fa fa-circle-o-notch fa-spin\'></i>\">Gerar Guia</button></div></form></div></div></div></div>");
$templateCache.put("app/view/extrato/modalProtesto_old.html","<div class=\"modal fade\" id=\"modalProtesto\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalProtesto\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"titleProtesto\">Detalhes do protesto</h4></div><div class=\"modal-body\"><form name=\"ProtestoForm\"><div class=\"form-group\"><label for=\"deEndereco\">Cartório XXX</label></div></form></div></div></div></div>");
$templateCache.put("app/view/footer/footer.tpl.html","<div class=\"container-footer clearfix\"><div class=\"pull-left\"><p class=\"note-sac\"><span>Serviço de Atendimento ao Cliente:</span> <i class=\"fa fa-volume-control-phone rotate-10\"></i> <span><b>0800 0 41 0158</b> com ligação gratuita para todo o território nacional, exceto para celulares.</span></p></div></div>");
$templateCache.put("app/view/header/header.tpl.html","<div class=\"header\"><div class=\"header-top\"></div><div class=\"fundo-header-top\"><img src=\"assets/images/fundo-top.png\"></div><div class=\"logotipo-parana\"><img src=\"assets/images/logotipo-parana-header.png\"></div><div class=\"header-top-info\"><span>SECRETARIA DE INFRAESTRUTURA E LOGÍSTICA</span></div><div class=\"fundo-header-main\"><span>Departamento de Estradas de Rodagem</span></div><div class=\"logotipo-derpr\"><a href=\"/\"><img alt=\"Início\" src=\"assets/images/logotipo-derpr.png\"></a></div><div class=\"product-title\"><h3>Emissão de Certidões</h3></div></div><div class=\"clearfix\"></div><div class=\"breadcrumb\"><i class=\"fa fa-angle-right\"></i> <span>Resultado da pesquisa</span><div class=\"help\"><a href=\"http://sider.der.pr.gov.br/webhelp/files/cnd/index.htm\" target=\"_blank\" title=\"Ajuda\"><i class=\"fa fa-question-circle\" id=\"btn-help-header\"></i></a></div></div>");
$templateCache.put("app/view/main/main.html","<div><ngmessagecenter-messages growl=\"\" name=\"mainMessages\"></ngmessagecenter-messages><header id=\"content-header\" class=\"content-header\"><div ng-include=\"\" src=\"\'app/view/header/header.tpl.html\'\"></div></header><section id=\"content-app\" class=\"content-app\"><div class=\"data-search clearfix\"><div class=\"data-search-content\" ng-click=\"mainController.isCollapsed = !mainController.isCollapsed\"><div class=\"data-search-container-razao-social\"><div class=\"info-data-search empresa\"><div class=\"label-field-data-search\">Razão Social</div><div class=\"field-data-search\">{{mainController.devedor.deNomeFmt}}</div></div><a data-toggle=\"collapse\" class=\"btn-mais-info\" href=\"\" aria-expanded=\"false\" aria-controls=\"maisInfo\"><i class=\"fa fa-plus-circle\" ng-show=\"!mainController.isCollapsed\"></i> <i class=\"fa fa-minus-circle\" ng-show=\"mainController.isCollapsed\"></i></a></div><div class=\"data-search-container-cnpj\"><div class=\"info-data-search cnpj\"><div class=\"label-field-data-search\">CNPJ/CPF</div><div class=\"field-data-search\">{{mainController.devedor.nuDocumentoFmt}}</div></div></div><div class=\"data-search-container-registro\"><div class=\"info-data-search registro\"><div class=\"label-field-data-search\">Registro</div><div class=\"field-data-search\">{{mainController.devedor.nuRegistro}}</div></div></div><div class=\"data-search-container-endereco\"><div class=\"info-data-search endereco\"><div class=\"label-field-data-search\" ng-if=\"mainController.exibeLabelEndereco\">Endereço</div><div class=\"field-data-search\">{{mainController.devedor.deEnderecoFmt}}</div></div></div><div class=\"clearfix\"></div></div><div class=\"collapse content-mais-info\" id=\"maisInfo\" collapse=\"!mainController.isCollapsed\"><div class=\"container-mais-info\"><div class=\"cnpj\"><span class=\"label-cnpj\">CNPJ/CPF:</span> <span class=\"data-cnpj\">{{mainController.devedor.nuDocumentoFmt}}</span></div><div class=\"registro\"><span class=\"label-registro\">Registro:</span> <span class=\"data-registro\">{{mainController.devedor.nuRegistro}}</span></div><div class=\"endereco\" ng-if=\"mainController.exibeLabelEndereco\"><span class=\"label-endereco\">Endereço:</span> <span class=\"data-endereco\">{{mainController.devedor.deEnderecoFmt}}</span></div></div></div></div><div class=\"detail-info-search\"><div class=\"row\"><div class=\"positiva\" ng-if=\"mainController.situacao.positivo\"><div class=\"col-xs-12 col-sm-3 col-md-3\"><div class=\"alert alert-danger text-center\"><i class=\"fa fa-ban\"></i> <span class=\"status\">Certidão positiva de débitos</span> <span class=\"date\">Consulta realizada no dia {{mainController.situacao.dataAtual | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}} às {{mainController.situacao.dataAtual | date : \'HH:mm:ss\'| ifEmpty: \"-\"}}</span></div></div><div class=\"col-xs-12 col-sm-9 col-md-9\"><p>Ressalvado o direito do DER/PR de cobrar quaisquer dívidas de responsabilidade da Empresa acima citada, que vierem a ser apuradas.</p><p>É certificado <b class=\"text-danger\">que consta(m)</b>, até a presente data, pendência(s) em seu nome, relativa(s) à débito administrado pela Coordenadoria de Contabilidade e Finanças da Diretoria Administrativo Financeira do Departamento de Estradas de Rodagem do Estado do Paraná - DER/PR.</p><p>Esta certidão refere-se exclusivamente à situação da Empresa acima citada, no âmbito deste Departamento, não constituindo, por conseguinte, prova de inexistência de débitos inscritos em outros orgãos do Estado.</p><div class=\"tools-btn\"><button class=\"btn btn-primary\" ng-click=\"mainController.openExtatoPage()\" id=\"visualize-positive-button\" data-loading-text=\"Visualizar <i class=\'fa fa-circle-o-notch fa-spin\'></i>\"><i class=\"fa fa-eye fa-fw\"></i> <span class=\"hidden-xs\">Visualizar</span></button> <a class=\"btn btn-default\" ng-click=\"mainController.imprimirCertidao()\" file-download=\"mainController.certidaoPositiva\" file-name=\"mainController.certidaoName\" id=\"print-positive-certificate-button\" data-loading-text=\"Imprimir <i class=\'fa fa-circle-o-notch fa-spin\'></i>\"><i class=\"fa fa-print fa-fw\"></i> <span class=\"hidden-xs\">Imprimir</span></a> <button class=\"btn btn-default\" ng-click=\"mainController.backToPreviousPage()\"><i class=\"fa fa-chevron-left fa-fw\"></i> <span class=\"hidden-xs\">Voltar</span></button></div></div></div><div class=\"positiva-efeito\" ng-if=\"mainController.situacao.positivoNegativo\"><div class=\"col-xs-12 col-sm-3 col-md-3\"><div class=\"alert alert-warning text-center\"><i class=\"fa fa-ban\"></i> <span class=\"status\">Certidão positiva de débitos com efeito de negativa</span> <span class=\"date\">Consulta realizada no dia {{mainController.situacao.dataAtual | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}} às {{mainController.situacao.dataAtual | date : \'HH:mm:ss\'| ifEmpty: \"-\"}}</span></div></div><div class=\"col-xs-12 col-sm-9 col-md-9\"><p>Ressalvado o direito do DER/PR de cobrar quaisquer dívidas de responsabilidade da Empresa acima citada, que vierem a ser apuradas.</p><p>É certificado <b class=\"text-warning\">que consta(m)</b>, até a presente data, pendência(s) em seu nome, relativa(s) à débito administrado pela Coordenadoria de Contabilidade e Finanças da Diretoria Administrativo Financeira do Departamento de Estradas de Rodagem do Estado do Paraná - DER/PR.</p><p>Esta certidão refere-se exclusivamente à situação da Empresa acima citada, no âmbito deste Departamento, não constituindo, por conseguinte, prova de inexistência de débitos inscritos em outros orgãos do Estado.</p><div class=\"tools-btn\"><button class=\"btn btn-primary\" id=\"visualize-positive-negative-button\" data-loading-text=\"Visualizar <i class=\'fa fa-circle-o-notch fa-spin\'></i>\" ng-click=\"mainController.openExtatoPage()\"><i class=\"fa fa-eye fa-fw\"></i> <span class=\"hidden-xs\">Visualizar</span></button> <a class=\"btn btn-default\" ng-click=\"mainController.imprimirCertidao()\" file-download=\"mainController.certidaoPositivaNegativa\" file-name=\"mainController.certidaoName\" id=\"print-positive-negative-certificate-button\" data-loading-text=\"Imprimir <i class=\'fa fa-circle-o-notch fa-spin\'></i>\"><i class=\"fa fa-print fa-fw\"></i> <span class=\"hidden-xs\">Imprimir</span></a> <button class=\"btn btn-default\" ng-click=\"mainController.backToPreviousPage()\"><i class=\"fa fa-chevron-left fa-fw\"></i> <span class=\"hidden-xs\">Voltar</span></button></div></div></div><div class=\"negativa\" ng-if=\"mainController.situacao.negativo\"><div class=\"col-xs-12 col-sm-3 col-md-3\"><div class=\"alert alert-success text-center\"><i class=\"fa fa-check-circle-o\"></i> <span class=\"status\">Certidão negativa de débitos</span> <span class=\"date\">Consulta realizada no dia {{mainController.situacao.dataAtual | date : \'dd/MM/yyyy\'| ifEmpty: \"-\"}} às {{mainController.situacao.dataAtual | date : \'HH:mm:ss\'| ifEmpty: \"-\"}}</span></div></div><div class=\"col-xs-12 col-sm-9 col-md-9\"><p>Ressalvado o direito do DER/PR de cobrar quaisquer dívidas de responsabilidade da Empresa acima citada, que vierem a ser apuradas.</p><p>É certificado <b class=\"text-success\">que não consta(m)</b>, até a presente data, pendência(s) em seu nome, relativa(s) à débito administrado pela Coordenadoria de Contabilidade e Finanças da Diretoria Administrativo Financeira do Departamento de Estradas de Rodagem do Estado do Paraná - DER/PR.</p><p>Esta certidão refere-se exclusivamente à situação da Empresa acima citada, no âmbito deste Departamento, não constituindo, por conseguinte, prova de inexistência de débitos inscritos em outros orgãos do Estado.</p><div class=\"tools-btn\"><button class=\"btn btn-primary\" ng-click=\"mainController.openExtatoPage()\" id=\"visualize-negative-button\" data-loading-text=\"Visualizar <i class=\'fa fa-circle-o-notch fa-spin\'></i>\"><i class=\"fa fa-eye fa-fw\"></i> <span class=\"hidden-xs\">Visualizar</span></button> <a class=\"btn btn-default\" ng-click=\"mainController.imprimirCertidao()\" file-download=\"mainController.certidaoNegativa\" file-name=\"mainController.certidaoName\" id=\"print-negative-certificate-button\" data-loading-text=\"Imprimir <i class=\'fa fa-circle-o-notch fa-spin\'></i>\"><i class=\"fa fa-print fa-fw\"></i> <span class=\"hidden-xs\">Imprimir</span></a> <button class=\"btn btn-default\" ng-click=\"mainController.backToPreviousPage()\"><i class=\"fa fa-chevron-left fa-fw\"></i> <span class=\"hidden-xs\">Voltar</span></button></div></div></div></div></div></section><section id=\"content-footer\" class=\"content-footer\"><div ng-include=\"\" src=\"\'app/view/footer/footer.tpl.html\'\"></div></section></div>");
$templateCache.put("app/view/partials/messages-include.html","<span ng-message=\"parse\">{{ \'messages.parse\' | translate }}</span> <span ng-message=\"notfound\">{{ \'messages.notfound\' | translate }}</span> <span ng-message=\"required\">{{ \'messages.required\' | translate }}</span> <span ng-message=\"number\">{{ \'messages.number\' | translate }}</span> <span ng-message=\"min\">{{ \'messages.min\' | translate }}</span> <span ng-message=\"max\">{{ \'messages.max\' | translate }}</span> <span ng-message=\"cpf\">{{ \'messages.cpf\' | translate }}</span> <span ng-message=\"cnpj\">{{ \'messages.cnpj\' | translate }}</span> <span ng-message=\"email\">{{ \'messages.email\' | translate }}</span> <span ng-message=\"date\">{{ \'messages.date\' | translate }}</span> <span ng-message=\"cep\">{{ \'messages.cep\' | translate }}</span> <span ng-message=\"time\">{{ \'messages.time\' | translate }}</span>");
$templateCache.put("app/view/search/search.html","<div style=\"position: fixed; top:0; bottom: 0; left:0; right: 0; z-index:0; background: #fff; overflow-y: auto; overflow-x: hidden\"><ngmessagecenter-messages growl=\"\" name=\"searchMessages\"></ngmessagecenter-messages><div class=\"content-login\"><div class=\"header-login\"><div class=\"header-top-login\"></div><div class=\"fundo-header-top-login\"><img src=\"assets/images/fundo-top.png\"></div><div class=\"logotipo-parana-login\"><img src=\"assets/images/logotipo-parana-header.png\"></div><div class=\"header-top-info-login\"><span>SECRETARIA DE INFRAESTRUTURA E LOGÍSTICA</span></div><div class=\"fundo-header-main-login\"><span>Departamento de Estradas de Rodagem</span></div><a href=\"/\"><div class=\"logotipo-derpr-login\"></div></a></div><div class=\"container-login clearfix\"><div class=\"help\"><a href=\"http://sider.der.pr.gov.br/webhelp/files/cnd/index.htm\" target=\"_blank\" title=\"Ajuda\"><i class=\"fa fa-question-circle\" id=\"btn-help\"></i></a></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><p class=\"titulo\">Emissão de Certidões e Guias</p></div><div class=\"col-xs-12 col-sm-6 col-md-6\"><p class=\"resume\">Bem-vindo à Consulta e Emissão de Certidões e Guias.</p><p class=\"resume\">Informe o CNPJ/CPF ou o Registro da empresa para visualizar a respectiva situação de débito.</p><p class=\"resume\">Serviço de Atendimento ao Cliente: <i class=\"fa fa-volume-control-phone rotate-10\"></i> <span><b>0800 41 0111</b> com ligação gratuita para todo o território nacional, exceto para celulares.</span></p><p class=\"resume\">Serviço de Atendimento ao Transporte Rodoviário Comercial: <i class=\"fa fa-volume-control-phone rotate-10\"></i> <span><b>0800 0 41 0158</b> com ligação gratuita para todo o território nacional, exceto para celulares.</span></p></div><div class=\"col-xs-12 col-sm-1 col-md-1 hidden-xs\"></div><div class=\"col-xs-12 col-sm-5 col-md-5\"><p class=\"resume\">Opção de pesquisa</p><form class=\"form-inline\" name=\"searchForm\"><div><label class=\"radio-inline\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"checkCnpj\" value=\"cnpj\" ng-model=\"searchController.searchFilter.type\" ng-click=\"searchController.changeFieldOption()\"> CNPJ</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"checkCpf\" value=\"cpf\" ng-model=\"searchController.searchFilter.type\" ng-click=\"searchController.changeFieldOption()\"> CPF</label></div><div><label class=\"radio-inline\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"checkRegistro\" value=\"registro\" ng-model=\"searchController.searchFilter.type\" ng-click=\"searchController.changeFieldOption()\"> Registro</label> <label class=\"radio-inline\" style=\"width: 123px;\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"checkPlacaVeiculo\" value=\"placa\" ng-model=\"searchController.searchFilter.type\" ng-click=\"searchController.changeFieldOption()\"> Placa do veículo</label></div><div class=\"clearfix\"></div><div class=\"form-group\"><label class=\"sr-only\">Campo dados</label><div ng-if=\"searchController.searchFilter.isCPF\"><input id=\"cpf\" name=\"cpf\" class=\"form-control no-animate\" ng-model=\"searchController.searchFilter.nuDocumento\" type=\"tel\" placeholder=\"Informe o CPF\" sp-cpf=\"\" autofocus=\"\" required=\"\"> <span ng-messages=\"searchForm.cpf.$error\" sp-message-tooltip=\"\"><div ng-messages-include=\"app/view/partials/messages-include.html\"></div></span></div><div ng-if=\"searchController.searchFilter.isCNPJ\"><input id=\"cnpj\" name=\"cnpj\" class=\"form-control no-animate\" ng-model=\"searchController.searchFilter.nuDocumento\" sp-cnpj-alfa=\"\" sp-mask=\"**.***.***/****-99\" type=\"text\" maxlength=\"18\" placeholder=\"Informe o CNPJ\" autofocus=\"\" required=\"\"> <span ng-messages=\"searchForm.cnpj.$error\" sp-message-tooltip=\"\"><div ng-messages-include=\"app/view/partials/messages-include.html\"></div></span></div><div ng-if=\"searchController.searchFilter.isREGISTRO\"><input id=\"registro\" name=\"registro\" class=\"form-control no-animate\" ng-model=\"searchController.searchFilter.nuRegistro\" type=\"text\" maxlength=\"12\" placeholder=\"Informe o número de registro\" sp-integer=\"\" autofocus=\"\" required=\"\"> <span ng-messages=\"searchForm.registro.$error\" sp-message-tooltip=\"\"><div ng-messages-include=\"app/view/partials/messages-include.html\"></div></span></div><div ng-if=\"searchController.searchFilter.isPLACA\"><input id=\"placa\" name=\"placa\" class=\"form-control no-animate\" onkeyup=\"this.value = this.value.toUpperCase();\" ng-model=\"searchController.searchFilter.nuPlaca\" type=\"text\" maxlength=\"7\" placeholder=\"Informe o número da placa do veículo\" autofocus=\"\" required=\"\"> <span ng-messages=\"searchForm.placa.$error\" sp-message-tooltip=\"\"><div ng-messages-include=\"app/view/partials/messages-include.html\"></div></span></div></div><button type=\"submit\" class=\"btn btn-primary pull-right\" id=\"search-button\" data-loading-text=\"<i class=\'fa fa-circle-o-notch fa-spin\'></i>\" ng-click=\"searchController.validateCaptchaAndSubmit(searchForm)\"><i class=\"fa fa-search\"></i></button><script src=\"https://www.google.com/recaptcha/enterprise.js\" async=\"\" defer=\"\"></script><div class=\"captcha-container\" style=\"margin-top: 20px; margin-bottom: 20px; clear: both;\"><div class=\"g-recaptcha\" data-sitekey=\"{{searchController.valor_chave_captcha}}\" data-callback=\"onSuccess\"></div></div><script nonce=\"VAWDxUhgyNm43HPUIgMpsw\">\n           var onSuccess = function(response) {\n             var errorDivs = document.getElementsByClassName(\"recaptcha-error\");\n             if (errorDivs.length) {\n               errorDivs[0].className = \"\";\n             }\n             var errorMsgs = document.getElementsByClassName(\"recaptcha-error-message\");\n             if (errorMsgs.length) {\n               errorMsgs[0].parentNode.removeChild(errorMsgs[0]);\n             }\n           };\n         </script><div><noscript><div style=\"width: 302px; height: 462px;\"><iframe src=\"https://www.google.com/recaptcha/api/fallback?k={{searchController.valor_chave_captcha}}\" frameborder=\"0\" scrolling=\"no\" style=\"width: 302px; height:422px; border: 1px solid green\"></iframe><div><textarea id=\"g-recaptcha-response\" name=\"g-recaptcha-response\" class=\"g-recaptcha-response\" style=\"width: 250px; height: 40px;\">\n               </textarea></div></div></noscript></div><div id=\"divMsgCaptcha\"></div></form></div></div></div></div><div class=\"modal fade\" id=\"modalConsolidacao\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalConsolidacao\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"titleAviso\">Aviso</h4></div><div class=\"modal-body\"><p class=\"bg-warning\" style=\"padding: 25px\">Estamos consolidando as informações de seus débitos. Para sua comodidade, você receberá nossa notificação por e-mail em <b>até 48 horas</b> quando as informações estiverem disponíveis. Informe seu email de contato e confirme.</p><div class=\"row\"><form name=\"notificacaoForm\"><div class=\"col-md-8 col-sm-8 col-xs-12\"><input type=\"email\" class=\"form-control\" id=\"enviarEmail\" name=\"deEmail\" placeholder=\"Email\" maxlength=\"100\" ng-model=\"searchController.notificacaoForm.deEmail\" required=\"\"> <span ng-messages=\"notificacaoForm.deEmail.$error\" sp-message-tooltip=\"\"><div ng-messages-include=\"app/view/partials/messages-include.html\"></div></span></div><button class=\"btn btn-primary\" ng-disabled=\"!searchController.notificacaoForm.deEmail\" ng-click=\"searchController.confirmarNotificacao()\"><span class=\"hidden-xs\">Confirmar</span></button></form></div></div></div></div></div>");
$templateCache.put("app/components/directives/debito-detail-dialog.html","<div class=\"modal fade\" id=\"modalDetalheAutoInfracao\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalDetalheAutoInfracao\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"titleDetalheAutoInfracao\">Dados do Auto de Infração {{model.debito.autoInfracao}}</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nº AR Notificação:</label> {{model.debito.nuArNotificacao | ifEmpty: \"\" }}</div><div class=\"form-group\"><label>Nº AR Imposição:</label> {{model.debito.nuArImposicao | ifEmpty: \"\" }}</div><div class=\"form-group\"><label>Data da infração:</label> {{model.debito.dtInfracaoDocumento | date : \'dd/MM/yyyy\' | ifEmpty: \"\" }}</div><div class=\"form-group\"><label>Data de vencimento:</label> {{model.debito.dtVencto | date : \'dd/MM/yyyy\' | ifEmpty: \"\" }}</div><div class=\"form-group\"><label>Placa:</label> {{model.debito.dePlaca | ifEmpty: \"\" }}</div><div class=\"form-group\"><label>Local de infração:</label> {{model.debito.deLocalInfracao | ifEmpty: \"\" }}</div><div class=\"form-group\"><label>Infração:</label> {{model.debito.deInfracaoFmt | ifEmpty: \"\" }}</div></div></div></div></div>");
$templateCache.put("app/components/directives/protesto-detail-dialog.html","<div class=\"modal fade\" id=\"modalProtesto\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalProtesto\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"titleDetalheAutoInfracao\">Dados do Cartório de Protesto</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nº da Dívida:</label> {{model.debito.nuDividaAtiva}}</div><div class=\"form-group\"><label>Nº Auto:</label> {{model.debito.autoInfracao | ifEmpty: \"\" }}</div><div class=\"form-group\" ng-if=\"model.debito.cartorioNome\"><label>Cartório:</label> {{model.debito.cartorioNome }}</div><div class=\"form-group\" ng-if=\"model.debito.cartorioEndereco\"><label>Endereço:</label> {{model.debito.cartorioEndereco }}</div><div class=\"form-group\" ng-if=\"model.debito.cartorioTelefone\"><label>Telefone:</label> {{model.debito.cartorioTelefone | ifEmpty: \"\" }}</div><div class=\"form-group\" ng-if=\"model.debito.cartorioEmail\"><label>E-mail:</label> {{model.debito.cartorioEmail | ifEmpty: \"\" }}</div></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");}]);